import React, { Component, Suspense } from "react";
import { NavLink } from "react-router-dom";
// import { Redirect } from "react-router";
import { withTranslation } from "react-multi-lang";
import "react-confirm-alert/src/react-confirm-alert.css";
import { CreateDialog } from "../controls/Dialog";
import { SplitButton } from "@progress/kendo-react-buttons";
import { CheckBox } from "../custom_modules/methodsetup/components/CustomControls.jsx";

import {
  PercentageCalculator,
  ControlRights,
  Silentauditobject,
  IsJSON,
  GetutcDate,
  GetutctoDate,
  GetutcDateaudi,
  GetutcDateoncurenttime,
  dateDiffInDays,
  Manualauditobject,
  // extractValuefromsheet,
  Servicecalls,
  setDateAsuserDefined,
  userdetails,
  convertUTCDateToLocalDate,
  Getuserprojectfromsession,
  Getuserworkflowfromsession,
  AuditTrailValidation,
  replacedotwithdecimal,
  Getteamusersfromsession,
  onAuditHandler,
  convertdoubledigitdate,
  convertdoubledigittime,
  Getprotocoluserworkflowfromsession,
  valiadateTenantPackage, extractValuefromsheet, orderTypeforprotocol, orderType, Onsaveactivewidgetsdata,
  formsequenceformatview,
  Servicecallsforfiles
  // onAuditHandler
} from "./../custom_functions/Functions.jsx";
import {
  isMultitenant,
  sheetDefaultContent,
  convertprotocolshorthandtooriginal,
  convertshorthandtooriginal,
  getsequenceoncode,
  getordertype,
  getprotocolordertype,
  orderdefaultcheck,
  protocoldefaultcheck,
  OrderSequence, ProtocolSequence
} from "./../custom_functions/Constance.jsx";
import $ from "jquery";
import "bootstrap";
import "overlayscrollbars/css/OverlayScrollbars.css";
import { DashboardDetails } from "./../redux_store/actions/index";
import { withAlert } from "react-alert";
// import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
// import { AuditModuleNameEnum } from "././../custom_functions/AuditActionEnum";
import Service from "./general/Service.jsx";
// import request from "superagent";
import "bootstrap/dist/css/bootstrap.min.css";
import store from "./../redux_store/store/index";
// import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";

// import { ScrollMenu } from "react-horizontal-scrolling-menu";
import {
  Modal,
  ModalBody,
} from "reactstrap";
// import {
//   Unshareorder,
//   Shareorder,
// } from "./../custom_functions/ManipulationFunction.jsx";
import { groupBy, formatData, formatserverData, getFolderTree, convertDateFormat, convertExtensionToIcon, searchTreeItem, getFolderToSave, addFolderonObj, Onsetfolderexpande } from "./../helpers/helperMethods";
// import KendoChart from "../controls/KendoChart.jsx";
import KendoChartDashboard from "../controls/KendoChartDashboard.jsx";
import KendoGridView from "../controls/KendoGridView.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
// import KendoChart from "../controls/KendoChart.jsx";
// import { FolderTree } from "./../controls/FolderTree";
// import {
//   DataModel,
// } from "./../interfaces/FileManagerModels";
// import { it } from "date-fns/locale";
// import { gzip } from 'pako';
import { Tooltip } from "@progress/kendo-react-tooltip";
import Activatewidgets from "../controls/Activatewidgets";
import { Label } from "reactstrap";
import DashboardProjectView from "./dashboard/DashboardProjectView";
import KendoCombobox from "../controls/KendoCombobox";
// import Activatewidgets from "../controls/Activatewidgets";
// const FolderTree = React.lazy(() => import('./../controls/FolderTree').then(({ FolderTree }) => ({ default: FolderTree })),
// );
const PageLoader = React.lazy(() => import("./general/PageLoader.jsx"));
const Upgrade = React.lazy(() => import("./general/Upgrade.jsx"));
export const MyDashboardContext = React.createContext();

const { Unshareorder, Shareorder } = React.lazy(() => import("./../custom_functions/ManipulationFunction.jsx"));
const Audit = React.lazy(() => import("./../custom_modules/Audit.jsx"));
const TextBox = React.lazy(() => import("./../controls/TextBox.jsx"));
const Orderdetail = React.lazy(() => import("./general/Orderdetail.jsx"));

const workflow = Getuserworkflowfromsession();

const isPremiumTenant = valiadateTenantPackage() === "3" ? true : false;
const loadingPanel = (
  <Suspense fallback={<div></div>}>
    <PageLoader innerLoader={true} />
  </Suspense>
);
const protocolordercontent = {
  protocolname: "",
  AI: {
    value: {
      data: [],
    },
  },
  abstract: { value: "" },
  matrices: { value: "" },
  material: { value: "" },
  sections: [],
  result: {},
}
class Dashboard extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    let filtertypevalue =
      $.session.get("filtertype") !== undefined &&
        $.session.get("filtertype") !== null
        ? parseInt($.session.get("filtertype"))
        : localStorage.getItem("filtertype") !== undefined &&
          localStorage.getItem("filtertype") !== null
          ? parseInt(localStorage.getItem("filtertype"))
          : 2;

    let filterdate = new Date();
    this.ELNurl = window.appUrl.ELN;
    this.onLegendItemClick = this.onLegendItemClick.bind(this);

    let dashview = [{ viewcode: 1, viewname: "Default View" }, { viewcode: 2, viewname: "Project View" }];

    this.state = {
      gridRefresh: false,
      isChartRender: false,
      TotalOrderCount: 0,
      Completedorders: 0,
      rejectedOrder: 0,
      canceledOrder: 0,
      PendingOrders: 0,
      Inprogress: 0,
      rejectedTemplate: 0,
      approvedTemplate: 0,
      createdTemplate: 0,
      inProgressTemplate: 0,
      retiredTemplate: 0,
      Parameter: [],
      SelectedParam: {},
      ParsedData: [],
      Activities: [],
      Activitiescount: 0,
      viewoptiontemplate: 1,
      Dashboardrights: false,
      Ordervalue: false,
      parameterusage: false,
      noworkflow: false,
      sitebasedusers: [],
      act: false,
      SheetnameNameValidcls: "",
      protocolNameValidcls: "",
      Sheetname: undefined,
      protocolname: undefined,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      validurl: true,
      Ispiechartrender: false,
      Islinechartrender: true,
      filtertype: filtertypevalue,
      dummyorderlist: [],
      isshowtosite: 1,
      initpagenofororder: 0,
      initpagenofortemplate: 0,
      totalordercountforsheetordergrid: 0,
      totalordercountfortemplategrid: 0,
      isformatorder: 1,
      isformatemplate: 1,
      Loadershow: true,
      Loadershowsheet: true,
      isAllorders: false,
      // pageperrecors: 500,
      pageperrecors: localStorage.getItem("ElnitemperpageDashboard") !== undefined &&
        localStorage.getItem("ElnitemperpageDashboard") !== null
        ? parseInt(localStorage.getItem("ElnitemperpageDashboard"))
        : 10,
      filtertest: { "testcode": -1 },
      inventoryrights: false,
      // dummytemplatelist: [],
      fromdate:
        $.session.get("filterfrom") !== undefined &&
          $.session.get("filterfrom") !== null
          ? new Date($.session.get("filterfrom"))
          : localStorage.getItem("daydiff") !== undefined &&
            localStorage.getItem("daydiff") !== null
            ? new Date(
              filterdate.setDate(
                filterdate.getDate() - parseInt(localStorage.getItem("daydiff"))
              )
            )
            : filtertypevalue === 1
              ? new Date()
              : new Date(filterdate.setDate(filterdate.getDate() - 7)),
      todate:
        $.session.get("filterto") !== undefined &&
          $.session.get("filterto") !== null
          ? new Date($.session.get("filterto"))
          : new Date(),
      inventFromDate:
        $.session.get("filterfrom") !== undefined &&
          $.session.get("filterfrom") !== null
          ? new Date($.session.get("filterfrom"))
          : localStorage.getItem("daydiff") !== undefined &&
            localStorage.getItem("daydiff") !== null
            ? new Date(
              filterdate.setDate(
                filterdate.getDate() - parseInt(localStorage.getItem("daydiff"))
              )
            )
            : filtertypevalue === 1
              ? new Date()
              : new Date(filterdate.setDate(filterdate.getDate() - 1)),
      inventToDate:
        $.session.get("filterto") !== undefined &&
          $.session.get("filterto") !== null
          ? new Date($.session.get("filterto"))
          : new Date(),
      orderlist: [],
      isregpopoveron: false,
      lsttest: [],
      lstsheet: [],
      lstvalsheet: [],
      lstproject: [],
      lstsample: [],
      lstworkflowuser: [],
      lstProtocolName: [],
      lstinventory: [],
      lstinventorydata: [],
      // selectedorder: { type: 2, name: "ELN order - with template" },
      // selectedprotocolorder: { type: 1, name: "ELN Protocol Order" },
      selectedorder: [],
      selectedprotocolorder: [],
      selectedtest: undefined,
      selectedsheet: undefined,
      selectedvalsheet: undefined,
      selectedproject: undefined,
      selectedsample: undefined,
      selectedworkflow: undefined,
      selectedinventory: undefined,
      selectedinventorydata: undefined,
      selectedprotocolname: undefined,
      testdisplay: "block",
      sheetdisplay: "block",
      sampledisplay: "block",
      valsheetdisplay: "none",
      Orderfor: localStorage.getItem("dashorderselect") && localStorage.getItem("dashorderselect") !== "" ? parseInt(localStorage.getItem("dashorderselect")) : 1,
      Templatefor: localStorage.getItem("dashtempselect") && localStorage.getItem("dashtempselect") !== "" ? parseInt(localStorage.getItem("dashtempselect")) : 1,
      sheetlist: [],
      issheetpopoveron: false,
      Orderselectionontype: localStorage.getItem("dashorderselecttype") && localStorage.getItem("dashorderselecttype") !== "" ? parseInt(localStorage.getItem("dashorderselecttype")) : 1,
      MyTask: [],
      Inventory: [],
      SelectedInventory: 0,
      keyName: "",
      OrderKey: "",
      AssigntProtocolfor: 1,
      Filtedata: [{ field: "repositoryname", operator: "contains", value: "" }],
      customFields: [],
      repositoryitem: [],
      lstCustomFields: [],
      repositorydata: {},
      isMoveParent: 4,
      defaultCustomField: [],

      protorderRights: false,
      orderRights: false,
      sheetRights: false,
      protoTemplRights: false,
      instrRights: false,

      createOrder: false,
      createProOrder: false,

      sheetSave: false,
      protocolSave: false,

      initialLoad: true,
      filterproject: { projectname: this.props.t("Dashboard.IDS_LBL_SEARCHBYALL"), projectcode: -1 },
      showDashboardFilter: false,
      defaultMenuIndex: -1,
      selecttaskandprojectvalues: [],
      filtertestorprojectkey: 0,
      isfilter: false,
      Addnewfolder_Onregister: false,
      onCDFselectstate: 4,
      selectedTreeItem_Addnewfolder: {},
      selectedTreeItem: {},
      stateCDFData: [],
      stateCDFData1: [],
      Columns: [
        {
          header: this.props.t("Dashboard.IDS_LBL_INVENTORYID"),
          datatype: "Inventoryid",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          className: "clsModulename",
          width: "100px",
          minWidth: 100,
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_NAME"),
          datatype: "InventoryName",
          rowselector: false,
          visible: true,
          resizable: false,
          doFilter: true,
          className: "clsModulename",
          width: "200px",
          minWidth: 200,
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_ADDEDBY"),
          datatype: "Addedby",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          className: "clsModulename",
          width: "100px",
          minWidth: 300,
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_ADDEDON"),
          datatype: "Addedonview",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          className: "clsModulename",
          width: "100px",
          minWidth: 200,
        },
      ],

      lstMaterial: [],
      selectedMaterial: {},
      lstMaterialInventory: [],
      lstMasterMaterialInventory: [],
      selectedMaterialInventory: {},

      lstChartTypes: [{ chartType: 1, typeName: "donut" }, { chartType: 2, typeName: "bar" }],
      selectedChartType: { chartType: 1, typeName: "donut" },
      selectedChartTemplateType: 'donut',
      selectedChartOrderType: 'donut',
      lstOnChartMode: [{ chartMode: 1, modeName: "Order" }, { chartMode: 2, modeName: "Template" }],
      selectedChartMode: { chartMode: 1, modeName: "Order" },
      viewChart: 1,
      Sheettemplate_Customcolumn: [
        {
          header: this.props.t("Dashboard.IDS_LBL_SHEETNAME"),
          datatype: "filenameuser",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          sortable: false,
          celltype: "orderGridView",
          pathName: "/sheetcreation",
          className: "simple-grid-view",
          width: "100px",
          Isshow: true,
          Desabled: true
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_VERSION"),
          datatype: "versioncout",
          rowselector: false,
          visible: true,
          celltype: "noWrapColumn",
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 90,
          Isshow: true
        },
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_VIEWOPTION", {
            param: "",
          }),
          datatype: "viewoptionstr",
          rowselector: false,
          visible: true,
          doFilter: true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
          Isshow: false
        },
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_CREATEDATE"),
          datatype: "createdateview",
          rowselector: false,
          visible: true,
          doFilter: true,
          filterable: false,
          className: "clsModulename",
          celltype: "dateColumn",
          width: "140px",
          Isshow: true
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_CREATEDBY"),
          datatype: "createby.userfullname",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          celltype: "noWrapColumn",
          className: "simple-grid-view",
          width: "100px",
          Isshow: true
        },
        {
          header: this.props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDON", {
            param: "",
          }),
          datatype: "modifieddate",
          rowselector: false,
          visible: true,
          doFilter: true,
          filterable: false,
          className: "clsModulename",
          celltype: "dateColumn",
          width: "100px",
          Isshow: false
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_STATUS"),
          datatype: "status",
          rowselector: false,
          visible: true,
          doFilter: true,
          celltype: "customStatusColumn",
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 90,
          Isshow: false
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_WORKFLOWLEVEL"),
          datatype: "lssheetworkflowname",
          rowselector: false,
          visible: isMultitenant === 2 && sessionStorage.accouttype === "1" ? false : true,
          celltype: "noWrapColumn",
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          width: "100px",
          Isshow: true
        }
      ],
      Protocoltemplate_Customcolumn: [
        {
          header: this.props.t("Dashboard.IDS_LBL_PROTOCOLNAME"),
          datatype: "protocolmastername",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          sortable: false,
          celltype: "orderGridView",
          pathName: "/protocols",
          className: "simple-grid-view",
          width: "100px",
          Isshow: true,
          Desabled: true
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_VERSION"),
          datatype: "versionno",
          rowselector: false,
          visible: true,
          celltype: "noWrapColumn",
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          Isshow: true
        },
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_VIEWOPTION", {
            param: "",
          }),
          datatype: "viewoptionstr",
          rowselector: false,
          doFilter: true,
          visible: isMultitenant === 2 ? false : true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
        },

        {
          header: this.props.t("Templates.Protocoltemplates.IDS_LBL_CREATEDATE"),
          datatype: "createdateprotocol",
          rowselector: false,
          doFilter: true,
          visible: true,
          filterable: false,
          className: "clsModulename",
          celltype: "dateColumn",
          width: "140px",
          Isshow: true
        },
        {
          header: this.props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDON", {
            param: "",
          }),
          datatype: "lastmodified",
          rowselector: false,
          visible: true,
          doFilter: true,
          filterable: false,
          className: "clsModulename",
          celltype: "dateColumn",
          width: "100px",
          Isshow: false
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_CREATEDBY"),
          datatype: "createdbyusername",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          celltype: "noWrapColumn",
          className: "simple-grid-view",
          width: "100px",
          Isshow: true,
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_STATUS"),
          datatype: "transactionstatus",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          celltype: "customStatusColumn",
          className: "simple-grid-view",
          maxWidth: 90,
          Isshow: true
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_WORKFLOWLEVEL"),
          datatype: "lssheetworkflowname",
          rowselector: false,
          visible: isMultitenant === 2 && sessionStorage.accouttype === "1" ? false : true,
          doFilter: true,
          resizable: false,
          celltype: "noWrapColumn",
          className: "simple-grid-view",
          width: "100px",
          Isshow: true
        }
      ],
      Sheetorders_Customcolumn: [
        {
          header: this.props.t("Dashboard.IDS_LBL_ORDERID", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASK") : this.props.t("Dashboard.IDS_LBL_ORDER") }),
          datatype: "batchid",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          sortable: false,
          pathName: "/registertask",
          celltype: "orderGridView",
          className: "simple-grid-view",
          width: "100px",
          Isshow: true,
          Desabled: true
        },
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_SHEETNAME", {
            param: "",
          }),
          datatype: "filename",
          rowselector: false,
          visible: true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_TASK"),
          datatype: "testname",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          celltype: "noWrapColumn",
          className: "simple-grid-view",
          maxWidth: 100,
          headerTemplate: "<span title='Task'>Task</span>",
          Isshow: true

        },
        {
          header: this.props.t("Dashboard.IDS_LBL_CREATEDDATE"),
          celltype: "dateColumn",
          datatype: "createdtimestampobj",
          rowselector: false,
          sortable: false,
          visible: true,
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          width: "200px",
          Isshow: true
        },
        {
          header: this.props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDON", {
            param: "",
          }),
          celltype: "dateColumn",
          datatype: "modifieddateobj",
          rowselector: false,
          visible: true,
          doFilter: true,
          filterable: false,
          className: "simple-grid-view",
          width: "100px",
          Isshow: false
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
          celltype: "Datecolumn_Completed",
          datatype: "completedtimestampobj",
          rowselector: false,
          sortable: false,
          visible: true,
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          width: "200px"
        },

        {
          header: this.props.t("Dashboard.IDS_LBL_PROJECT"),
          datatype: "projectname",
          rowselector: false,
          visible: true,
          doFilter: true,
          celltype: "noWrapColumn",
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          Isshow: true
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_TITLE"),
          datatype: "tle",
          rowselector: false,
          visible: true,
          doFilter: true,
          celltype: "noWrapColumn",
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          // Isshow: true
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_MATNAME"),
          datatype: "materialname",
          rowselector: false,
          visible: true,
          doFilter: true,
          celltype: "noWrapColumn",
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          // Isshow: true
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_KEYWORD"),
          datatype: "keyword",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_STATUS"),
          datatype: "status",
          rowselector: false,
          visible: true,
          doFilter: true,
          // celltype: "noWrapColumn",
          celltype: "customStatusColumn",
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          Isshow: true
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_DUEDATE"),
          datatype: "lsordernotification.duedateobj",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          celltype: "dateColumn_duedate",
          className: "simple-grid-view",
          maxWidth: 90,
          // Isshow: true
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_WORKFLOWLEVEL"),
          datatype: "lsworkflow.workflowname",
          rowselector: false,
          visible: isMultitenant === 2 && sessionStorage.accouttype === "1" ? false : true,
          doFilter: true,
          celltype: "noWrapColumn",
          resizable: false,
          className: "simple-grid-view",
          width: "100px",
          headerTemplate: "<span title='Workflow Level'>Workflow Level</span>",
          Isshow: true
        }
      ],
      Protocolorder_Customcolumn: [
        {
          header: this.props.t("Dashboard.IDS_LBL_ORDERID", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASK") : this.props.t("Dashboard.IDS_LBL_ORDER") }),
          datatype: "protoclordername",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          sortable: false,
          celltype: "orderGridView",
          pathName: "/Protocolorder",
          className: "simple-grid-view",
          width: "100px",
          Isshow: true,
          Desabled: true
        },
        {
          header: this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOL", {
            param: "",
          }),
          datatype: "protocolmastername",
          rowselector: false,
          visible: true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_TASK"),
          datatype: "testname",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          celltype: "noWrapColumn",
          className: "simple-grid-view",
          maxWidth: 100,
          Isshow: true
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_CREATEDDATE"),
          celltype: "dateColumn",
          datatype: "createdtimestamp",
          rowselector: false,
          sortable: false,
          // celltype: "noWrapColumn",
          visible: true,
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          width: "100px",
          Isshow: true
        },
        {
          header: this.props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDON", {
            param: "",
          }),
          datatype: "modifieddate",
          celltype: "dateColumn",
          rowselector: false,
          visible: true,
          doFilter: true,
          filterable: false,
          className: "simple-grid-view",
          width: "100px",
          Isshow: false
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
          celltype: "Datecolumn_Completed",
          datatype: "completedtimestamp",
          rowselector: false,
          sortable: false,
          visible: true,
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          width: "200px"
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_PROJECT"),
          datatype: "projectname",
          rowselector: false,
          celltype: "noWrapColumn",
          visible: true,
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          Isshow: true
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_STATUS"),
          datatype: "status",
          rowselector: false,
          visible: true,
          doFilter: true,
          // celltype: "noWrapColumn",
          celltype: "customStatusColumn",
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          Isshow: true
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_MATNAME"),
          datatype: "materialname",
          rowselector: false,
          visible: true,
          doFilter: true,
          celltype: "noWrapColumn",
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          // Isshow: true
        },
        {
          header: this.props.t("DueDate"),
          datatype: "lsordernotification.duedate",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          celltype: "dateColumn_duedate",
          className: "simple-grid-view",
          maxWidth: 90,
          // Isshow: true
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_TITLE"),
          datatype: "tittle",
          rowselector: false,
          visible: true,
          doFilter: true,
          celltype: "noWrapColumn",
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100,
          // Isshow: true
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_KEYWORD"),
          datatype: "keyword",
          rowselector: false,
          visible: true,
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          maxWidth: 100
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_WORKFLOWLEVEL"),
          datatype: "elnprotocolworkflow.workflowname",
          rowselector: false,
          visible: isMultitenant === 2 && sessionStorage.accouttype === "1" ? false : true,
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          celltype: "noWrapColumn",
          width: "100px",
          Isshow: true

        }
      ],
      isupgradeopen: false,
      Activewidgets_Pulldata: undefined,
      dashboardviews: dashview,
      selecteddashview: { viewcode: 1, viewname: "Default View" }
      // localStorage.getItem("dashview") ?
      //   dashview.find(view => { return view.viewcode === parseInt(localStorage.getItem("dashview")) })
      //   : { viewcode: 1, viewname: "Default View" }
    };
    this.intl = "en";
    //  useInternationalization();
    //this.setUserrights = this.setUserrights.bind(this);

    this.ordertypes = [
      { type: 2, name: this.props.t("Dashboard.IDS_LBL_ELNTASKORDER", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") }) },
      { type: 3, name: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_RESEARCHACTASKS") : this.props.t("Dashboard.IDS_LBL_RESEARCHACTIVITYORDER") },
      { type: 4, name: this.props.t("Dashboard.IDS_LBL_MANAGEEXCEL", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") }) },
      { type: 5, name: this.props.t("Dashboard.IDS_LBL_SHEETEVALUATION") },
    ];

    this.protocolordertypes = [
      { type: 1, name: this.props.t("Dashboard.IDS_LBL_ELNPROTO", { screenname: isMultitenant === 2 ? this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER") }) },
      { type: 2, name: this.props.t("Dashboard.IDS_LBL_DYNAMICPROTO", { screenname: isMultitenant === 2 ? this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER") }) },
    ];

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.wrapperReffordashboard = React.createRef();


  }

  onLegendItemClick() {
    this.setState({ isChartView: true, isChartRender: true })
  }

  componentDidMount() {

    let orderupdatedata = store.getState().sheetorderdata;
    let protocolorderdata = store.getState().protocolorderdata;

    // for eln lite single user validation start 
    if (isMultitenant === 2 && sessionStorage.accouttype === "1") {
      this.setState(prevState => ({
        Sheettemplate_Customcolumn: prevState.Sheettemplate_Customcolumn?.filter(item => item.datatype !== "viewoptionstr" && item.datatype !== "lssheetworkflowname"),
        Protocoltemplate_Customcolumn: prevState.Protocoltemplate_Customcolumn.filter(item => item.datatype !== "viewoptionstr" && item.datatype !== "lssheetworkflowname"),
        Sheetorders_Customcolumn: prevState.Sheetorders_Customcolumn?.filter(item => item.datatype !== "lsworkflow.workflowname"),
        Protocolorder_Customcolumn: prevState.Protocolorder_Customcolumn?.filter(item => item.datatype !== "elnprotocolworkflow.workflowname")
      }));
    }
    // for eln lite single user validation end

    // this.onChartModeChange()  //kumu
    document.title = this.props.t("ELNTitle.IDS_LBL_DASHBOARD");
    let _this = this;
    const fromdate = this.state.fromdate;
    const fDate = new Date(fromdate);
    const toDate = this.state.todate;

    $(document).on('click', 'g g', function () {
      if (!_this.state.isChartRender) {
        _this.onLegendItemClick()
      }
    })

    this._isMounted = true;
    this.updateuserrights(this.props.rights);

    this.props.onRef(this);

    this.props.onref(this)
    // setTimeout(() => {
    this.getordermasters();
    setTimeout(() => {
      //for dashboard complete get count and status update
      if (((orderupdatedata?.orderflag.trim() === "R" || orderupdatedata?.approvelstatus === 3 && orderupdatedata?.ordercancell === undefined)) ||
        ((protocolorderdata?.orderflag.trim() === "R" || protocolorderdata?.approvelstatus === 3 && protocolorderdata?.ordercancell === undefined))) {

        this.getordercount(fDate, toDate);
        this.GetDashboarddetails("0", fDate, toDate, true, true, false);

      } else if (store.getState().DashboardDetails !== undefined) {
        let { MyTask, orderlist, Orderfor, Templatefor, sheetlist, Completedorders, PendingOrders, canceledOrder, rejectedOrder, Orderselectionontype } = store.getState().DashboardDetails;
        if (orderlist?.length > 0) {

          orderlist.map(items => {
            if (items.pathName === "/registertask" && items?.bi === orderupdatedata?.orderid) {
              items.status = orderupdatedata.status;
              items.lsworkflow = orderupdatedata.lsworkflow;
              items.lsw = orderupdatedata.lsworkflow;
              items.approvelstatus = orderupdatedata.approvelstatus;
              items.orderflag = orderupdatedata.orderflag;
              items.approved = orderupdatedata.approved;
              items.ordercancell = orderupdatedata.ordercancell;
              items.oc = orderupdatedata.ordercancell;
              items.of = orderupdatedata.orderflag;
            } else if (items.pathName === "/Protocolorder" && items?.protoclordername === protocolorderdata?.orderid) {
              items.status = protocolorderdata.status;
              items.elnprotocolworkflow = protocolorderdata.elnprotocolworkflow;
              items.approvelstatus = protocolorderdata.approvelstatus;
              items.orderflag = protocolorderdata.orderflag;
              items.approved = protocolorderdata.approved;
              items.ordercancell = protocolorderdata.ordercancell;
            }
            return items
          })
          this.setState({ MyTask, orderlist, Orderfor, Templatefor, sheetlist, Completedorders, PendingOrders, canceledOrder, rejectedOrder, Orderselectionontype }, () => {
            console.log("kumu");
            delete store.getState().DashboardDetails;
          })
        }
      } else {
        this.getordercount(fDate, toDate);
        this.GetDashboarddetails("0", fDate, toDate, true, true, false);
      }
    }, isMultitenant === 2 ? 500 : 250);
    // }, 50);
    let protoRights = ControlRights("IDS_MDL_ORDERS", "IDS_SCN_PROTOCOLORDERS");
    let orderRights = ControlRights("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS");
    let sheetRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATE");
    let protoTemplRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE");
    let instrRights = ControlRights("IDS_MDL_SETUP", "IDS_SCN_INSTRUMENTMASTER");

    let orderCreate = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNTASKORDER");
    let Researchorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_RESEARCHACTIVITY");
    let manageexcel = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_MANAGEEXCEL");
    let sheeteval = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_SHEETEVALUATION");

    let elnprotocol = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNPROTOCOL");
    let dynamicorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_DYNAMICPROTOCOL")

    this.setState({
      protorderRights: protoRights.UserGroupRights.rights,
      orderRights: orderRights.UserGroupRights.rights,
      sheetRights: sheetRights.UserGroupRights.rights,
      protoTemplRights: protoTemplRights.UserGroupRights.rights,
      instrRights: instrRights.UserGroupRights.rights,
      Researchorderrights: Researchorder.UserGroupRights.save,
      sheetSave: sheetRights.UserGroupRights.save,
      protocolSave: protoTemplRights.UserGroupRights.save,
      Manageexcelrights: manageexcel.UserGroupRights.save,
      createOrder: orderRights.UserGroupRights.rights,
      createsheet: orderCreate.UserGroupRights.save,
      sheetevalrights: sheeteval.UserGroupRights.save,
      createProOrder: elnprotocol.UserGroupRights.rights,
      protocolorder: elnprotocol.UserGroupRights.save,
      Dynamicorderrights: dynamicorder.UserGroupRights.save,

      initialLoad: true,
    }, () => {
      let val = [];
      this.ordertypes.forEach((item) => {
        if (this.state.createsheet === true && item.type === 2) {
          val.push(item);
        } if (this.state.Researchorderrights === true && item.type === 3) {
          val.push(item);
        } if (this.state.Manageexcelrights === true && item.type === 4) {
          val.push(item);
        }
        if (this.state.sheetevalrights === true && item.type === 5) {
          val.push(item);
        }
      });
      val.unshift([]);
      this.ordertypes = val;

      let val1 = [];

      this.protocolordertypes.forEach((item) => {
        if (this.state.protocolorder === true && item.type === 1) {
          val1.push(item);
        } if (this.state.Dynamicorderrights === true && item.type === 2) {
          val1.push(item);
        }
      });
      val1.unshift([]);
      this.protocolordertypes = val1;


      const dashboardCustomColumn = JSON.parse(localStorage.getItem("Dashboard_Customcolumn")) || {};
      const applyCustomColumns = (columnKey, stateArray) => {
        const updatedState = stateArray.map((item) => {
          item.Isshow = dashboardCustomColumn[columnKey]?.includes(item.datatype) ?? false;
          return item;
        });
        if (updatedState.length > 0) {
          this.setState({ [columnKey]: updatedState });
        }
      };
      const sheetColumnKey = 'Sheetorders_Customcolumn';
      const protocolColumnKey = 'Protocolorder_Customcolumn';
      const sheetTemplateColumnKey = 'Sheettemplate_Customcolumn';
      const protocolTemplateColumnKey = 'Protocoltemplate_Customcolumn';
      if (dashboardCustomColumn[sheetColumnKey] !== undefined) {
        applyCustomColumns(sheetColumnKey, this.state[sheetColumnKey]);
      }
      if (dashboardCustomColumn[protocolColumnKey] !== undefined) {
        applyCustomColumns(protocolColumnKey, this.state[protocolColumnKey]);
      }
      if (dashboardCustomColumn[sheetTemplateColumnKey] !== undefined) {
        applyCustomColumns(sheetTemplateColumnKey, this.state[sheetTemplateColumnKey]);
      }
      if (dashboardCustomColumn[protocolTemplateColumnKey] !== undefined) {
        applyCustomColumns(protocolTemplateColumnKey, this.state[protocolTemplateColumnKey]);
      }

    });

    document.addEventListener("mousedown", this.handleClickOutside);

    // this.getdirectory()
  }


  getdirectory = (isassigneduser, selecteduser) => {
    let passObjDet = {};
    if (isassigneduser === undefined && selecteduser === undefined) {
      passObjDet =
        store.getState().Loggeduser !== undefined &&
          store.getState().Loggeduser !== null &&
          Object.keys(store.getState().Loggeduser).length > 0
          ? { ...store.getState().Loggeduser }
          : {
            usercode: $.session.get("User"),
            username: $.session.get("Username"),
            lssitemaster: { sitecode: $.session.get("Usersite") },
          };
      passObjDet.usernotify = Getteamusersfromsession();
    } else {
      passObjDet = selecteduser;
    }
    passObjDet.lstproject = Getuserprojectfromsession();
    passObjDet.activeusersite = { sitecode: Number(sessionStorage?.Usersite) }
    Servicecalls(
      "" + this.ELNurl + "/Instrument/Getfoldersfordashboard",
      passObjDet,
      this.onGetfoldersfordashboardSuccess.bind(this),
      this.onGetTestFaliure.bind(this)
    );
  }
  foldersstructure(directory, key) {

    // // let directory = directory;
    // let orders = [];
    // if (directory !== null && directory !== undefined && directory.length > 0) {

    //   directory = directory.filter((items) => items.path !== undefined);
    //   directory.forEach((dic, index) => {
    //     orders.push({
    //       directorycode: dic.directorycode,
    //       parentdircode: dic.parentdircode,
    //       dateCreated: convertDateFormat(
    //         convertUTCDateToLocalDate(new Date(dic.dateCreated)),
    //         this.intl
    //       ),
    //       dateModified: convertDateFormat(
    //         convertUTCDateToLocalDate(new Date(dic.dateModified)),
    //         this.intl
    //       ),
    //       size: 124,
    //       path: dic.path,
    //       directoryname: dic.directoryname,
    //       icon: convertExtensionToIcon(dic.directoryname, null),
    //       filefor: "DR",
    //       viewoption: dic.viewoption,
    //       teamname: dic.teamname !== undefined ? dic.teamname : undefined
    //     });
    //   });
    // }
    // let groupeddata = groupBy(orders, "parentdircode");
    // let data = groupeddata["-1"];
    // let Userprojects = JSON.parse(sessionStorage.Userprojects);
    // directory = directory.filter((items) => ((items?.parentcodeondefaultfoder && Userprojects.filter((projectcode) => projectcode === items?.parentcodeondefaultfoder)?.length > 0) || (items?.parentcodeondefaultfoder === undefined) || (items?.parentcodeondefaultfoder % 1 !== 0)));
    const currentDate = sessionStorage.getItem("currentDate");
    let directoryobj = [];
    // let projects = directory.projects;
    // let tests = directory.tests;
    // let Material_List = directory.Material;
    // let Materialtest = directory.Materialtest;
    if (key === 2 && directory.directorypro !== undefined && directory.directorypro.length > 0) {
      directoryobj = directory.directorypro;
    } else if (key === 1 && directory.directory !== undefined && directory.directory.length > 0) {
      directoryobj = directory.directory;
    }
    let orders = [];
    directoryobj = directoryobj.map((items) => {
      if (items.floatvalues !== undefined) {
        items.parentdircode = parseFloat(items.parentdircode + "." + items.floatvalues);
      }
      return items;
    })

    // let screen = key === 1 ? "Sheet" : "Protocol"
    // if (projects !== undefined) {
    //   projects.map((obj) => {
    //     let projectname = obj.projectname.replaceAll(".", " ");
    //     let projectpath = `${screen}/${"Project"}/${projectname}`;
    //     let testitems = [];
    //     let projecttest = tests.filter(
    //       (testary) => testary[1] === obj.projectcode
    //     );
    //     if (projecttest !== undefined) {
    //       testitems = projecttest.map((testobj) => {
    //         return {
    //           directorycode: parseFloat(obj.projectcode + "." + testobj[0]),
    //           parentdircode: parseInt(obj.projectcode) + 3,
    //           dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), this.intl),
    //           dateModified: convertDateFormat(new Date(), this.intl),
    //           size: 124,
    //           path: `${projectpath}/${testobj[2]}`,
    //           directoryname: testobj[2],
    //           icon: convertExtensionToIcon(testobj[2], null),
    //           filefor: "TMP",
    //           items: [],
    //         };
    //       });
    //     }
    //     orders = orders.concat(testitems)
    //     orders.push({
    //       directorycode: parseInt(obj.projectcode) + 3,
    //       parentdircode: -3,
    //       dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), this.intl),
    //       dateModified: convertDateFormat(new Date(), this.intl),
    //       size: 124,
    //       path: projectpath,
    //       directoryname: projectname,
    //       icon: convertExtensionToIcon(projectname, null),
    //       filefor: "PR",
    //       items: []//testitems,
    //     }); return obj;
    //   });
    // }

    // orders.push({
    //   directorycode: -3,
    //   parentdircode: -1,
    //   dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), this.intl),
    //   dateModified: convertDateFormat(new Date(), this.intl),
    //   size: 124,
    //   path: screen + "/Project",
    //   directoryname: this.props.t("Orders.Sheetorders.IDS_LBL_PROJECT"),
    //   icon: convertExtensionToIcon("Project", null),
    //   filefor: "PR",
    //   items: []//projectitems,
    // });
    // let Material_Items = [];
    // if (Material_List !== undefined) {
    //   Material_List.map((obj) => {
    //     let Material_Path = `${screen}/${"Material"}/${obj.smaterialname}`;
    //     let testitems = [];
    //     let Material_Temp = Materialtest.filter(
    //       (testary) => testary[1] === obj.nmaterialcode
    //     );
    //     if (Material_Temp !== undefined) {
    //       testitems = Material_Temp.map((testobj) => {
    //         return {
    //           directorycode: parseFloat(obj.nmaterialcode + "." + testobj[0]),
    //           parentdircode: parseFloat(obj.nmaterialcode + "." + 521),
    //           dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), this.intl),
    //           dateModified: convertDateFormat(new Date(), this.intl),
    //           size: 124,
    //           path: `${Material_Path}/${testobj[2]}`,
    //           directoryname: testobj[2],
    //           icon: convertExtensionToIcon(testobj[2], null),
    //           filefor: "TMM",
    //           items: [],
    //         };
    //       });
    //     }
    //     orders = orders.concat(testitems)
    //     // orders = [...orders, testitems];
    //     orders.push({
    //       directorycode: parseFloat(obj.nmaterialcode + "." + 521),// parseInt(obj.nmaterialcode) + 5,
    //       parentdircode: -17,
    //       dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), this.intl),
    //       dateModified: convertDateFormat(new Date(), this.intl),
    //       size: 124,
    //       path: Material_Path,
    //       directoryname: obj.smaterialname,
    //       icon: convertExtensionToIcon(obj.smaterialname, null),
    //       filefor: "SMM",
    //       items: []//testitems,
    //     }); return obj;
    //   });
    // }
    // orders.push({
    //   directorycode: -17,
    //   parentdircode: -1,
    //   dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), this.intl),
    //   dateModified: convertDateFormat(new Date(), this.intl),
    //   size: 124,
    //   path: `${screen}/${"Material"}`,
    //   directoryname: this.props.t("Dashboard.Sheetorders.IDS_LBL_MATERIAL"),
    //   icon: convertExtensionToIcon("Material", null),
    //   filefor: "SMM",
    //   items: Material_Items,
    // });

    if (directoryobj !== null && directoryobj !== undefined && directoryobj.length > 0) {

      directoryobj = directoryobj.filter((items) => items.path !== undefined);
      directoryobj.forEach((dic, index) => {
        // console.log("Index", index);
        orders.push({
          directorycode: dic.directorycode,
          parentdircode: dic.parentdircode,
          dateCreated: convertDateFormat(
            convertUTCDateToLocalDate(new Date(dic.dateCreated)),
            this.intl
          ),
          ...(dic.dateModified && {
            dateModified: convertDateFormat(
              convertUTCDateToLocalDate(new Date(dic.dateModified)),
              this.intl
            )
          }),
          size: 124,
          path: dic.path,
          directoryname: dic.directoryname,
          icon: convertExtensionToIcon(dic.directoryname, null),
          filefor: "DR",
          viewoption: dic.viewoption,
          teamname: dic.teamname !== undefined ? dic.teamname : undefined
        });
      });
    }

    let groupeddata = groupBy(orders, "parentdircode");
    let data = groupeddata["-1"];
    let stateCDFData;
    let stateCDFData1;
    if (key === 1) {
      if (data !== undefined) {
        orders = formatData(
          formatserverData(data, groupeddata, this.intl, "Sheet", "Sheet"),
          this.intl
        );
        let selectedTreeItem = orders.length > 0 ? orders[0] : {}
        stateCDFData = getFolderTree(
          JSON.parse(JSON.stringify(orders)),
          selectedTreeItem
        ) || []
        stateCDFData.unshift({
          directorycode: null,
          parentdircode: -1,
          dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), this.intl),
          dateModified: convertDateFormat(new Date(), this.intl),
          size: 124,
          path: "Home",
          directoryname: this.props.t("Templates.Sheettemplates.IDS_LBL_HOME"),
          icon: convertExtensionToIcon(this.props.t("Templates.Sheettemplates.IDS_LBL_HOME"), null),
          filefor: "HF",
          items: []//projectitems,
        })
        this.setState({
          folderdata: orders, selectedTreeItem_Addnewfolder: selectedTreeItem, stateCDFData
        })
      }

    } else {
      // let basepath = this.state.Orderfor === 1 ? "Sheet" : "Protocol";
      // let screen = this.state.Orderfor === 1 ? "Sheet" : "Protocol";
      if (data !== undefined) {
        orders = formatData(
          formatserverData(data, groupeddata, this.intl, "Protocol", "Protocol"),
          this.intl
        );
        let selectedTreeItem = orders.length > 0 ? orders[0] : {}
        stateCDFData1 = getFolderTree(
          JSON.parse(JSON.stringify(orders)),
          selectedTreeItem
        ) || []
        stateCDFData1.unshift({
          directorycode: null,
          parentdircode: -1,
          dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), this.intl),
          dateModified: convertDateFormat(new Date(), this.intl),
          size: 124,
          path: "Home",
          directoryname: this.props.t("Templates.Sheettemplates.IDS_LBL_HOME"),
          icon: convertExtensionToIcon(this.props.t("Templates.Sheettemplates.IDS_LBL_HOME"), null),
          filefor: "HF",
          items: []//projectitems,
        })
        this.setState({ folderdataprotocol: orders, selectedTreeItem_Addnewfolder: selectedTreeItem, stateCDFData1 })

      }

    }
  }

  onGetfoldersfordashboardSuccess = (responce) => {

    responce.directory = responce?.directory?.filter((x) => {
      return x?.sitemaster?.sitecode === Number(sessionStorage?.Usersite)
    });

    responce.directorypro = responce?.directorypro?.filter((x) => {
      return x?.sitemaster?.sitecode === Number(sessionStorage?.Usersite)
    });

    if (responce !== undefined) {
      this.foldersstructure(responce, 1)
    }
    if (responce !== undefined) {
      this.foldersstructure(responce, 2)
    }
  }

  handleClickOutside(event) {
    if (
      this.wrapperReffordashboard &&
      this.wrapperReffordashboard.current &&
      !this.wrapperReffordashboard.current.contains(event.target)
    ) {
      this.setState({ showDashboardFilter: false });
    }

  }



  UNSAFE_componentWillReceiveProps(nextProps) {



    if (this.props.isrender !== undefined && this.props.isrender) {
      if (nextProps.rights !== undefined && nextProps.isdispatcheddone) {
        this.updateuserrights(nextProps.rights);
      }

      this.setState({
        Ispiechartrender: true,
        Islinechartrender: true,
      });
    } else {
      this.setState({
        Ispiechartrender: false,
        Islinechartrender: false,
      });
    }
    let elnorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNTASKORDER");
    let researchorder = ControlRights(
      "IDS_MDL_ORDERS",
      "IDS_TSK_RESEARCHACTIVITY"
    );
    let excelorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_MANAGEEXCEL");
    let Evaluation = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_SHEETEVALUATION");
    let elnprotocol = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNPROTOCOL");
    let dynorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_DYNAMICPROTOCOL");
    // let sheetcreat = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATE");
    // let protocolRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE");
    let userrights = ({
      ELNorder: elnorder.UserGroupRights.save,
      Researchvisible: researchorder.UserGroupRights.save,
      Excelsavevisb: excelorder.UserGroupRights.save,
      Evalsavevisb: Evaluation.UserGroupRights.save,
      elnordersave: elnprotocol.UserGroupRights.save,
      dynordersave: dynorder.UserGroupRights.save,
      // Sheettempvisible: sheetcreat.UserGroupRights.rights,
      // Protocoltempvisible: protocolRights.UserGroupRights.rights,

    });

    this.setState({
      Orderrights: userrights
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.onRef(undefined);
    this.props.onref(undefined)
  }

  getordermasters() {
    let passObjDet =
      store.getState().Loggeduser !== undefined &&
        store.getState().Loggeduser !== null &&
        Object.keys(store.getState().Loggeduser).length > 0
        ? store.getState().Loggeduser
        : {
          usercode: $.session.get("User"),
          username: $.session.get("Username"),
          lssitemaster: { sitecode: $.session.get("Usersite") },
        };

    // let pass = { sitecode: Number(sessionStorage.Usersite) };

    passObjDet.ismultitenant = isMultitenant;

    Servicecalls(
      "" + this.ELNurl + "/Basemaster/getTestwithsheet",
      passObjDet,
      this.onGetTestSuccess.bind(this),
      this.onGetTestFaliure.bind(this)
    );

    // Servicecalls(
    //   "" + this.ELNurl + "/Basemaster/getSamplemaster",
    //   passObjDet,
    //   this.onGetsampleSuccess.bind(this),
    //   this.onGetTestFaliure.bind(this)
    // );

    Servicecalls(
      "" + this.ELNurl + "/Basemaster/getProjectmasteronproject",
      passObjDet,
      this.onGetprojectSuccess.bind(this),
      this.onGetTestFaliure.bind(this)
    );

    // if (isPremiumTenant) {
    //   Servicecalls(
    //     "" + this.ELNurl + "/transaction/getMaterialLst4DashBoard",
    //     pass,
    //     this.onGetMaterialInventorySuccess.bind(this),
    //     this.onGetTestFaliure.bind(this)
    //   );
    // } else {
    //   Servicecalls(
    //     "" + this.ELNurl + "/Master/Getallrepositories",
    //     pass,
    //     this.onGetInventorySuccess.bind(this),
    //     this.onGetTestFaliure.bind(this)
    //   );
    // }

    // Servicecalls(
    //   "" + this.ELNurl + "/File/GetUnapprovedsheets",
    //   passObjDet,
    //   this.onGetvalidationsheetsSuccess.bind(this),
    //   this.onGetTestFaliure.bind(this)
    // );
  }

  onGetsampleSuccess(response) {

    let defaultsample = {}

    const newData = response.slice(0);
    newData.splice(response, 0, defaultsample);

    this.setState({
      lstsample: newData,
      // selectedsample:
      //   newData !== undefined && newData !== null && newData.length > 0
      //     ? newData[0]
      //     : undefined,
    });
  }

  onGetprojectSuccess(response) {

    let projectuser = [
      { usercode: -1, username: this.props.t("Dashboard.IDS_LBL_WORKFLOWNAME", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASK") : this.props.t("Dashboard.IDS_LBL_ORDER") }), },
      { usercode: -2, username: this.props.t("Dashboard.IDS_LBL_NOWORKFLOW", { param: "" }), }];
    response.unshift({});
    this.setState({
      lstproject: response,
      // selectedproject:
      //   response !== undefined && response !== null && response.length > 0
      //     ? response[0]
      //     : undefined,
      lstworkflowuser: projectuser,
      selectedworkflow:
        projectuser !== undefined &&
          projectuser !== null &&
          projectuser.length > 0
          ? projectuser[0]
          : undefined,
    });
    // let res = [...response];
    this.props.updatetestandproject([...response], 1);
  }

  onGetTestSuccess(response) {
    // response.Test.unshift({})
    response.Sheet.unshift({})
    this.setState({
      lsttest: response.Test,
      selectedtest: {},
      // selectedtest:
      //   response.Test !== undefined &&
      //     response.Test !== null &&
      //     response.Test.length > 0
      //     ? response.Test[0]
      //     : undefined,
      // lstsheet: response.Sheet,
      // selectedsheet:
      //   response.Sheet !== undefined &&
      //     response.Sheet !== null &&
      //     response.Sheet.length > 0
      //     ? response.Sheet[0]
      //     : undefined,
    });
    this.props.updatetestandproject([...response.Test], 0);
    if (response.Protocol.length > 0) {
      this.setState({
        lstProtocolName:
          response.Protocol !== undefined &&
            response.Protocol !== null &&
            response.Protocol.length > 0
            ? response.Protocol
            : undefined,
        Protocolcode:
          response.Protocol.length > 0
            ? response.Protocol[0].protocolmastercode
            : -1,
        selectedprotocolname:
          response.Protocol.length > 0 ? response.Protocol[0] : {},
      });
    }
  }

  onGetProtocolInitialSuccess(res) {
    // if (res.length === 0) {
    if (this.state.Orderfor === 2 && this.state.selectedprotocolorder.type === 2) {
      let dynamicprotocolitem = [
        {
          protocolmastercode: -2,
          protocolmastername: "Default Template",
        },
      ];
      res.unshift(dynamicprotocolitem[0]);
    }


    if (res.length === 0 && this.state.selectedprotocolorder.type !== 2) {
      this.setState({
        lstProtocolName: [],
        Protocolcode: null,
        selectedprotocolname: undefined,
      });
      if (this.state.Orderfor === 1) {
        this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_NOSHEET"));
      } else {
        this.props.alert.error(this.props.t("Dashboard.Protocolorders.IDS_MSG_NOTASSIGNTEST"));
      }

    } else {
      if (res.length !== 1) {
        res.unshift({})
      }
      this.setState({
        lstProtocolName: res,
        Protocolcode: res[0].protocolmastercode,
        selectedprotocolname: res[0],
      });
    }
    // } 
  }

  onGetInventorySuccess(response) {

    let defaultsample = {}

    const newData = response.slice(0);
    newData.splice(response, 0, defaultsample);

    this.setState({
      lstinventory: newData,
      selectedinventory: defaultsample,
      SelectedRepository: defaultsample,
    });

    let repositoryitem = {
      repositorycode: this.state.selectedinventory.repositorycode,
      sitecode: $.session.get("Usersite"),
    };
    Servicecalls(
      "" + this.ELNurl + "/Master/Getallrepositoriesdata",
      repositoryitem,
      this.onGetRepoSuccess.bind(this),
      this.onGetRepoFailure.bind(this),
    );
    // this.setState({
    //   ServiceToUrl: "" + this.ELNurl + "/Master/Getallrepositoriesdata",
    //   ServiceHeaderobject: repositoryitem,
    //   ServiceMethodType: "POST",
    //   ServcieonSuccess: this.onGetRepoSuccess.bind(this),
    //   ServcieonFailure: this.onGetRepoFailure.bind(this),
    //   ServiceTenant: undefined,
    // });
  }

  onGetMaterialInventorySuccess(res) {
    let defaultsample = {};
    let lstMaterialData = res.listedMaterial.slice(0);
    lstMaterialData.splice(res.listedMaterial, 0, defaultsample);
    let lstMaterialInventData = res.listedMaterialInventory.slice(0);
    lstMaterialInventData.splice(res.listedMaterialInventory, 0, defaultsample);

    this.setState({
      lstMaterial: lstMaterialData,
      selectedMaterial: lstMaterialData[0],
      lstMasterMaterialInventory: lstMaterialInventData,
      selectedMaterialInventory: lstMaterialInventData[0],
    })
  }

  onGetvalidationsheetsSuccess(response) {
    this.setState({
      lstvalsheet: response,
      selectedvalsheet:
        response !== undefined && response !== null && response.length > 0
          ? response[0]
          : undefined,
    });
    //kumaresan
    // if (response !== undefined && response !== null && response.length > 0) {
    //   response[0].versionno = 0;
    //   response[0].ismultitenant = isMultitenant;
    //   Servicecalls(
    //     "" + this.ELNurl + "/File/GetfileverContent",
    //     response[0],
    //     this.onGetELNfilecontent.bind(this),
    //     this.onGetELNfilecontentfailure.bind(this)
    //   );
    // }
  }

  onGetELNfilecontent(res) {
    let sheetcontant = this.state.selectedvalsheet;
    sheetcontant.filecontent = res;
    this.setState({ selectedvalsheet: sheetcontant });
  }

  onGetELNfilecontentfailure(res) { }

  // registerorder(
  //   ordertype,
  //   sheet,
  //   project,
  //   test,
  //   workflow,
  //   sample,
  //   inventory,
  //   inventorydata
  // ) {
  //   let inventoryselect = inventory
  //   let inventorydataselect = inventorydata
  //   if (this.state.isMoveParent === 4 && this.state.selectedTreeItem === undefined) {
  //     this.props.alert.error(this.props.t("Dashboard.Protocolorders.IDS_LBL_NOSELECTFOLDER"));
  //   } else if (this.state.isMoveParent === 1 && (this.state.selectedproject === undefined || this.state.selectedproject === null)) {
  //     this.props.alert.error(
  //       this.props.t("Dashboard.Sheetorders.IDS_MSG_SOMEOFTHEFIELDNOSELECTED")
  //     );
  //   } else if (this.state.isMoveParent === 2 && (this.state.selectedsample === undefined || this.state.selectedsample === null)) {
  //     this.props.alert.error(
  //       this.props.t("Dashboard.Sheetorders.IDS_MSG_SOMEOFTHEFIELDNOSELECTED")
  //     );
  //   }
  //   else {
  //     let silentaudit;
  //     let objsilentaudit;
  //     let passObjDet = {
  //       testcode: test !== undefined && test !== null ? test.testcode : null,
  //       testname: test !== undefined && test !== null ? test.testname : null,
  //       lsfile: sheet,
  //       lssamplefile: {

  //         createdate: GetutcDate(new Date()),
  //         createbyuser: store.getState().Loggeduser,
  //         processed: 0,
  //         versionno: 1,
  //         lssamplefileversion: [
  //           {
  //             createdate: GetutcDate(new Date()),
  //             createbyuser: store.getState().Loggeduser,
  //             versionno: 1,
  //             versionname: "1",
  //           },
  //         ],
  //       },
  //       filetype: parseInt(ordertype.type),
  //       lsuserMaster: store.getState().Loggeduser,
  //       lsprojectmaster: project !== undefined && project !== null ? project : null,
  //       assignedto:
  //         workflow !== null &&
  //           workflow !== undefined &&
  //           workflow.usercode !== null &&
  //           workflow.usercode > 0 ? workflow : null,
  //       lssamplemaster: sample !== undefined && sample.samplecode !== undefined ? sample : null,
  //       // (sample !== undefined & sample.samplecode !== undefined) & (sample !== null & sample.samplecode !== null) ? sample : null,
  //       objLoggeduser: store.getState().Loggeduser,
  //       objsilentaudit: silentaudit,
  //       objmanualaudit: Manualauditobject("registered", "Sheet Orders"),
  //       ismultitenant: isMultitenant,

  //       createdtimestamp: GetutcDate(new Date()),
  //       lsrepositories: !isPremiumTenant ? ((inventory !== undefined && inventory !== null) ? (inventory.repositorycode !== undefined ? inventory : null) : null) : null,
  //       lsrepositoriesdata: !isPremiumTenant ? ((inventorydata !== undefined && inventorydata !== null) ? (inventorydata.repositorydatacode !== undefined ? inventorydata : null) : null) : null
  //       ,

  //       viewoption:
  //         project !== undefined && project !== null
  //           ? 1
  //           : this.state.isshowtosite,
  //       directorycode: this.state.isMoveParent === 1 || this.state.isMoveParent === 2
  //         ? null
  //         : this.state.isMoveParent === 4 ?
  //           this.state.selectedTreeItem !== undefined || this.state.selectedTreeItem !== null
  //             ? this.state.selectedTreeItem.directorycode : null : null,
  //       orderdisplaytype: this.state.isMoveParent,

  //     };
  //     if (inventorydataselect.nmaterialcatcode === undefined && inventoryselect.nmaterialcode !== undefined) {
  //       passObjDet.material = isPremiumTenant ? ((inventory !== undefined && inventory !== null) ? inventory : null) : null
  //       passObjDet.materialinventory = isPremiumTenant ? ((inventorydata !== undefined && inventorydata !== null) ? inventorydata : null) : null
  //     }


  //     if (this.state.noworkflow) {
  //       passObjDet.assignedto = this.state.sitebaseduserscode

  //     }

  //     let keyWord = this.state.OrderKey.trim();

  //     this.setState({ OrderKey: "", });

  //     if (keyWord !== "") {
  //       passObjDet.keyword = keyWord;

  //       let Audit = AuditTrailValidation("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS", "IDS_TSK_REGISTER");

  //       if (Audit) {
  //         passObjDet.objmanualaudit = Manualauditobject(
  //           "registered",
  //           "Sheet Orders"
  //         );

  //         $("#DashboardModel").modal("show");

  //         this.setState({
  //           AuditUrl: "" + this.ELNurl + "/Instrument/InsertELNOrder",
  //           AuditObject: passObjDet,
  //           AuditPassfunction: this.onSuccessRegisterorder.bind(this),
  //           AuditFailfunction: this.onErrorRegisterorder.bind(this),
  //           isregpopoveron: false,
  //         });
  //       } else {

  //         this.setState({
  //           isregpopoveron: false,
  //         });

  //         let passObjDetAudit = { objsilentaudit: objsilentaudit };
  //         Servicecalls(
  //           "" + this.ELNurl + "/Instrument/InsertELNOrder",
  //           passObjDet,
  //           this.onSuccessRegisterorder.bind(this),
  //           this.onErrorRegisterorder.bind(this),

  //           "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
  //           passObjDetAudit,
  //           this.onAuditValidateError.bind(this),
  //           this.onAuditValidateFailure.bind(this)
  //         );
  //       }
  //     } else {
  //       this.props.alert.error(this.props.t("Dashboard.Protocolorders.IDS_MSG_KEYALERT"));
  //     }
  //   }

  // }

  onSuccessRegisterorder(response) {

    let dup_response = { ...response };
    let shortnedres = OrderSequence(dup_response);
    response.batchid = shortnedres.batchid;

    let todate = new Date(this.state.todate);
    let currentdate = new Date();
    if (
      todate.getUTCDay() === currentdate.getUTCDay() &&
      todate.getUTCMonth() === currentdate.getUTCMonth() &&
      todate.getUTCFullYear() === currentdate.getUTCFullYear()
    ) {
      todate = GetutcDateoncurenttime(this.state.todate);
      this.setState({ initpagenofororder: 0, isformatorder: 0 }, () => {
        setTimeout(() => {
          this.getordercount(this.state.fromdate, todate);
          this.GetDashboarddetails("1", this.state.fromdate, todate, false, false);
          let OrdersList = store.getState().OrdersList;
          if ((OrdersList && OrdersList.length > 0) && (response.filetype === 1 || response.filetype === 2)) {
            let Issamerecordprecent = OrdersList.some((items) =>
              (items.bc !== undefined ? items.bc : items.batchcode) === (response.batchcode)
            );
            if (!Issamerecordprecent) {
              OrdersList.unshift(response);
            }
            // store.dispatch(SheetandProtocolOrders(OrdersList));
          }
        }, 100);
      })
    }

    this.props.alert.success(this.props.t("Orders.Sheetorders.IDS_LBL_ORDERMSG", {
      screenname: this.props.t(isMultitenant === 2 ? "Orders.Sheetorders.IDS_LBL_TASK" : "Dashboard.IDS_LBL_ORDER"),
      orderid: response.batchid,
      param: ""
    }));

    let lsActiveWidgets = {
      screenname: "Sheet_Order",
      activityType: "Insert",
      userId: sessionStorage.User,
      activewidgetsdetailscode: response.batchcode || "",
      Activewidgetsdetails: response.batchid || "",
      sitecode: sessionStorage.Usersite
    };
    Onsaveactivewidgetsdata(lsActiveWidgets);

    this.setState({
      Activewidgets_Pulldata: true,
      selectedproject: undefined,
      selectedsample: undefined,
      sitebasedusers: [],
      noworkflow: false,
      isMoveParent: 4,
      isshowtosite: 1,
      selectedTreeItem: undefined
    });
    let objsilentaudit;
    if (response.assignedto !== undefined && response.assignedto.userstatus === "Locked") {
      // let passObjDetAudit = {};
      objsilentaudit = onAuditHandler(
        "assign",
        "Sheet Orders",
        this.props.t("Orders.Sheetorders.IDS_AUDIT_ASSIGNTOUSER", {
          // screen: orderType(response.orderdisplaytype),
          user1: response.batchid,
          user2: response.lockedusername
        }),

        "",
        "LSlogilablimsorderdetail"
      );
      let passObjDet = { objsilentaudit: objsilentaudit };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        (res) => { },
        (res) => { }
      );
    } else {
      objsilentaudit = onAuditHandler(
        "registered",
        "Sheet Orders",
        this.props.t("Orders.Sheetorders.IDS_AUDIT_SHEETINSERT", {
          user: $.session.get("Username"),
          orderid: response.batchid,
          moduleName: orderType(response.filetype),
          visible: response.viewoption === 1 ? "Site" : response.viewoption === 2 ? "Only me" : response.viewoption === 3 ? "Project Team" : ""

        })
      );
      let passObjDet = { objsilentaudit: objsilentaudit };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        (res) => { },
        (res) => { }
      );
    }

    // else {
    //   this.setState({ sitebaseduserscode: {} })
    //   passObjDetAudit.objsilentaudit = Silentauditobject(
    //     "assign",
    //     "Sheet Orders",
    //     this.props.t("Orders.Sheetorders.IDS_AUDIT_WORKFLOWASSIGNTOUSER", {

    //       screen: orderType(response.orderdisplaytype),
    //       user1: response.batchid,
    //       Username: this.state.selectedworkflow.username,
    //       user2: store.getState().Loggeduser.username

    //     }),
    //     "",
    //     "LSlogilablimsorderdetail"
    //   );
    // }
    // Servicecalls(
    //   "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
    //   passObjDetAudit,
    //   (res) => { },
    //   (res) => { }
    // );
  }

  onsheetcategorychange = (Value) => {
    this.setState({ sheetcategory: Value });
  }

  onshowtositetemp = (event) => {
    let teamuserscode = JSON.parse($.session.get("teamusercode"));
    if (teamuserscode.length > 0 && parseInt(event.target.value) === 3) {
      this.setState({ viewoptiontemplate: parseInt(event.target.value) });
    } else if (parseInt(event.target.value) === 2 || parseInt(event.target.value) === 1) {
      this.setState({ viewoptiontemplate: parseInt(event.target.value) });
    } else {
      if (this.state.Templatefor === 1) {
        this.props.alert.error(this.props.t("Orders.Sheetorders.IDS_LBL_NOTMAPPEDPROJECTTEAM", { showitem: "to me", }))
      } else {
        this.props.alert.error(this.props.t("Orders.Sheetorders.IDS_LBL_NOTMAPPEDPROJECTTEAM", { showitem: "to me", }))
      }
    }
  };

  onsheetnamechange(Value) {
    this.setState({ Sheetname: Value });
  }

  handleTestChange(test) {
    this.setState({
      selectedtest: test
    })
  }

  onprotocolnamechange(Value) {
    this.setState({ protocolname: Value });
  }

  saveSheet(props) {
    // let MethodsVal = [];
    // let ParametersVal = [];
    // let sheetdata = sheetDefaultContent;

    if (this.state.Sheetname.trim() === "") {
      this.props.alert.error(
        this.props.t("Dashboard.Sheettemplates.IDS_MSG_SAVESHEETERROR", { param: "" })
      );

    } else {

      this.onsheetorderclose();

      let passObjDet = {
        // filecontent: sheetdata,
        filenameuser: this.state.Sheetname,
        siteid: -1,
        lsmethods: [],
        lsparameter: [],
        lselnmethod: [],
        // lstest: [{ testtype: 0 }, { testtype: 1 }],
        lstest: [{ testtype: 1, testcode: (this.state.selectedtest && this.state.selectedtest !== null ? this.state.selectedtest.testcode : null) }],
        FileType: 0,
        lssitemaster: store.getState().Loggeduser.lssitemaster,
        lsuserMaster: store.getState().Loggeduser,
        objLoggeduser: store.getState().Loggeduser,
        isnewsheet: true,
        createby: store.getState().Loggeduser,
        approved: undefined,
        rejected: 0,
        createdate: GetutcDate(new Date()),
        ismultitenant: isMultitenant,
        viewoption: this.state.viewoptiontemplate,
        lselnmethod: [],
        modifieddate: null,
      };

      if (this.state.sheetcategory !== undefined && this.state.sheetcategory.trim() !== "") {
        passObjDet.category = this.state.sheetcategory;
      }

      let Audit = AuditTrailValidation("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATES", "IDS_TSK_SAVE");

      delete passObjDet.filecontent;
      const data = new FormData();
      data.append("file", JSON.stringify(passObjDet));
      const blob = new Blob([sheetDefaultContent], { type: "text/plain" });
      data.append("content", blob);

      if (Audit) {
        $("#DashboardModel").modal("show");
        passObjDet.objmanualaudit = Manualauditobject("create", "Sheet Templates");
        this.setState({
          Isrender: true,
          AuditUrl: "" + this.ELNurl + "/File/InsertupdateSheet",
          AuditObject: data,
          AuditPassfunction: this.onSheetsaveAsSuccess.bind(this),
          AuditFailfunction: this.onSheetsaveFaliure.bind(this),
          Servicecontenttype: "multipart"
        });
      } else {

        this.setState({
          ServiceToUrl: "" + this.ELNurl + "/File/InsertupdateSheet",
          ServiceHeaderobject: data,
          ServiceMethodType: "POST",
          ServcieonSuccess: this.onSheetsaveAsSuccess.bind(this),
          ServcieonFailure: this.onSheetsaveFaliure.bind(this),
          Servicecontenttype: "multipart"
        });

        // Servicecallsforfiles(
        //   "" + this.ELNurl + "/File/InsertupdateSheet", passObjDet, this.onSheetsaveAsSuccess.bind(this), this.onSheetsaveFaliure.bind(this),
        // );
      }
    }
  }
  onSheetsaveFaliure(response) { }

  onSheetsaveAsSuccess(response) {

    let todate = new Date(this.state.todate);
    let currentdate = new Date();
    let passObjDet = {};
    //let objsilentaudit;
    if (response.response.status === true) {
      this.setState({ Activewidgets_Pulldata: true })
      if (
        todate.getUTCDay() === currentdate.getUTCDay() &&
        todate.getUTCMonth() === currentdate.getUTCMonth() &&
        todate.getUTCFullYear() === currentdate.getUTCFullYear()
      ) {
        if (this.state.Templatefor === 1) {
          this.props.alert.success(
            this.props.t("Dashboard.Sheettemplates.IDS_MSG_SHEETMSG", { param: "" })
          );
          passObjDet.objsilentaudit = Silentauditobject(
            "create",
            "Sheet Templates",
            this.props.t("Dashboard.Sheettemplates.IDS_AUDIT_SHEETCREATION", {
              0: response.filenameuser,
              1: sessionStorage.Username,
              visible: response.viewoption === 1 ? "Site" : response.viewoption === 2 ? "Only me" : response.viewoption === 3 ? "Project Team" : ""
            }),
            "",
            "lsfile"
          );
          Servicecalls(
            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            (res) => { },
            (res) => { }
          );
        } else {
          this.props.alert.success(
            this.props.t("Templates.Protocoltemplates.IDS_MSG_PROTOCOLADDED", { param: "" })
          );

        }
        this.setState({
          protocolcategory: undefined,
          sheetcategory: undefined, initpagenofortemplate: 0, isformatemplate: 0
        }, () => {
          todate = GetutcDateoncurenttime(this.state.todate);
          setTimeout(() => {
            this.getsheets(this.state.fromdate, todate, this.state.initpagenofortemplate, true);
            // this.getordercount(this.state.fromdate, todate);
            this.getsheetsCount4Chart(this.state.fromdate, todate, this.state.viewChart);
          }, 50);

        })
        // todate = GetutcDateoncurenttime(this.state.todate);
        // setTimeout(() => {
        //   this.getsheets(this.state.fromdate, todate, this.state.initpagenofortemplate, true);
        //   this.getordercount(this.state.fromdate, todate);
        // }, 30);
      }
      if (this.state.Templatefor === 1) {
        let lsActiveWidgets = {
          screenname: "Sheet_Template",
          activityType: "Insert",
          userId: sessionStorage.User,
          activewidgetsdetailscode: response.filecode || "",
          Activewidgetsdetails: response.filenameuser || "",
          sitecode: sessionStorage.Usersite
        };
        Onsaveactivewidgetsdata(lsActiveWidgets);
      }

      setTimeout(() => {
        this.setState({ Activewidgets_Pulldata: true })
      }, 100);
    } else {
      if (this.state.Templatefor === 1) {
        this.props.alert.error(this.props.t("Templates.Sheettemplates.IDS_MSG_SHEET", { param: "" }));
        passObjDet.objsilentaudit = Silentauditobject(
          "warning",
          "Sheet Templates",
          this.props.t("Dashboard.Sheettemplates.IDS_AUDIT_SHEETEXISTS", {
            sheet: response.filenameuser
          }),

        );
      } else {
        this.props.alert.error(this.props.t("Templates.Protocoltemplates.IDS_MSG_ALREADY", { param: "" }));
        passObjDet.objsilentaudit = Silentauditobject(
          "warning",
          "Protocol Templates",
          this.props.t("Dashboard.Sheettemplates.IDS_AUDIT_SHEETEXISTS", {
            sheet: response.filenameuser
          }),

        );
      }
      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        (res) => { },
        (res) => { }
      );
    }


  }

  onAddprotocolNameClick = () => {
    const protocolNameTextBox = this.state.protocolname;
    if (protocolNameTextBox.trim() !== "") {
      this.onsheetorderclose();
      const similar = this.state.sheetlist.find(
        (item) => item.protocolmastername === protocolNameTextBox
      );
      if (similar === undefined) {
        // $("#NewProtocolAddPopup").modal("hide");
        let newProtocolMasterObj = {
          protocolmastername: this.state.protocolname,
          protocolstatus: 1,
          status: 1,
          createdby: parseInt(sessionStorage.User),
          ismultitenant: isMultitenant,
          lstest: [{ testtype: 1, testcode: (this.state.selectedtest && this.state.selectedtest !== null ? this.state.selectedtest.testcode : null) }],
          // approved: 0,
        };
        let rtnObj = {};

        let audit = Silentauditobject(
          "insert",
          "Protocol Templates",
          this.props.t("Templates.Protocoltemplates.IDS_AUDIT_PROTOCOLADDEDREQ", {
            protocol: this.state.protocolname,
            user: store.getState().Loggeduser.username,
            visible: this.state.viewoption === 1 ? "Site" : this.state.viewoption === 2 ? "Only me" : this.state.viewoption === 3 ? "Project Team" : ""

          }),
          "",
          "Lsprotocolmaster"
        );
        let passObjDet = {};

        let newStep = {
          protocolname: this.state.protocolNameTextBox,
          AI: {
            value: {
              data: []
            }
          },
          abstract: { value: "" },
          matrices: { value: undefined },
          material: { value: undefined },
          sections: [],
          result: {},
        };
        rtnObj["protocolData"] = newStep;

        rtnObj["newProtocolMasterObj"] = newProtocolMasterObj;
        passObjDet = {
          ...userdetails(),
          ...rtnObj,
          protocolmastername: this.state.protocolname,
          protocolstatus: 1,
          status: 1,
          createdby: parseInt(sessionStorage.User),
          ismultitenant: isMultitenant,
          objsilentaudit: audit,
          multiusergroups: $.session.get("multiusergroups"),
          objmanualaudit: Manualauditobject("insert", "Protocol Templates"),
          username: store.getState().Loggeduser.username,
          teamuserscode: JSON.parse($.session.get("teamusercode")),
          viewoption: this.state.viewoptiontemplate,
        };
        passObjDet.retirestatus = 0;
        passObjDet.lstest = [{ testtype: 0 }, { testtype: 1, testcode: (this.state.selectedtest && this.state.selectedtest !== null ? this.state.selectedtest.testcode : null) }];
        if (passObjDet.lstest !== undefined && passObjDet.lstest !== null) {
          passObjDet.lstest.map((test) => {
            if (test.testcode !== undefined) {
              passObjDet.testcode = test.testcode;
            }
            return test;
          })
        }
        passObjDet.LSprotocolmaster = {
          createdate: GetutcDate(new Date()),
        };
        let objsilentaudit = onAuditHandler(
          "insert",
          "Protocol Templates",
          this.props.t("Templates.Protocoltemplates.IDS_AUDIT_PROTOCOLADDEDREQ", {
            protocol: this.state.protocolname,
            user: store.getState().Loggeduser.username,
            visible: this.state.viewoption === 1 ? "Site" : this.state.viewoption === 2 ? "Only me" : this.state.viewoption === 3 ? "Project Team" : ""

          }),
          "",
          "Lsprotocolmaster"
        );

        let passObjDetAudit = { objsilentaudit: objsilentaudit };

        if (this.state.protocolcategory !== undefined && this.state.protocolcategory.trim() !== "") {
          passObjDet.category = this.state.protocolcategory
        }

        let Audit = AuditTrailValidation(
          "IDS_MDL_TEMPLATES",
          "IDS_SCN_PROTOCOLTEMP",
          "IDS_TSK_ADDPROTOCOL"
        );

        if (Audit) {
          $("#DashboardModel").modal("show");
          this.setState({
            AuditUrl: "" + this.ELNurl + "/protocol/addProtocolMaster",
            AuditObject: passObjDet,
            AuditPassfunction: this.onSheetsaveAsSuccess.bind(this),
            AuditFailfunction: this.onSheetsaveFaliure.bind(this),
          });
        } else {
          Servicecalls(
            "" + this.ELNurl + "/protocol/addProtocolMaster",
            passObjDet,
            this.onSheetsaveAsSuccess.bind(this),
            this.onSheetsaveFaliure.bind(this),

            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDetAudit,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
          );
        }
      } else {
        this.props.alert.error(this.props.t("Templates.Protocoltemplates.IDS_MSG_ALREADY"));
        let objsilentaudit = onAuditHandler(
          "warning",
          "Protocol template ",
          this.props.t("Templates.Protocoltemplates.IDS_MSG_ALREADY", {})
        );

        if (objsilentaudit !== null) {
          let passObjDet = { objsilentaudit: objsilentaudit };

          Servicecalls(
            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
          );
        }
      }
    } else {
      this.setState({ protocolNameValidcls: "invalid" });
      this.props.alert.error(this.props.t("Dashboard.Protocoltemplates.IDS_MSG_PROTOCOLNAMEEMPTY"));

      let objsilentaudit = onAuditHandler(
        "warning",
        "Protocol template",
        this.props.t("Dashboard.Protocoltemplates.IDS_MSG_PROTOCOLNAMEEMPTY", {})
      );

      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    }
  };

  onErrorRegisterorder(response) { }

  onGetTestFaliure(response) { }

  onGetDashboardSuccess(response) {
    if (this._isMounted === false) {
      return;
    }

    let orders = response.orders;
    let pendingorder = response.pendingorder;
    let completedorder = response.completedorder;
    let onproces = response.onproces;
    let activities = response.activities;
    let activitiescount = response.activitiescount;

    let Parameter = response.ParsedParameters;
    let comboParam = [];
    let paramtercount = 0;
    if (Parameter !== undefined && Parameter.length > 0) {
      for (let val = 0; val < Parameter.length; val++) {
        if (Parameter[val].fieldcode.trim() === "") {
          continue;
        }
        paramtercount++;
        $.extend(true, Parameter[val], JSON.parse(Parameter[val].value));

        if (
          !comboParam.some(
            (Paramval) => Paramval.Code === Parameter[val].fieldkey
          )
        ) {
          let methodvalue = "";
          if (IsJSON(Parameter[val].methodname)) {
            let methods = JSON.parse(Parameter[val].methodname);
            let instruments = JSON.parse(Parameter[val].instrumentnames);
            if (methods !== undefined && methods.length > 0) {
              for (let index = 0; index < methods.length; index++) {
                methodvalue += methods[index] + " (" + instruments[index] + ")";

                if (index !== methods.length - 1) {
                  methodvalue += "; ";
                }
              }
            }
          } else {
            methodvalue = Parameter[val].methodname;
          }

          let method =
            Parameter[val].instrumentid === "I1" ||
              Parameter[val].instrumentid === "G1" ||
              Parameter[val].instrumentid === "IC1"
              ? this.props.t("fields." + Parameter[val].methodname, {
                param: "",
              })
              : methodvalue;
          let instrument =
            Parameter[val].instrumentid === "I1" ||
              Parameter[val].instrumentid === "G1" ||
              Parameter[val].instrumentid === "IC1"
              ? this.props.t("fields." + Parameter[val].methodname, {
                param: "",
              })
              : Parameter[val].instrumentname;
          let Param = {
            Code: Parameter[val].fieldkey,
            Display:
              "" +
              Parameter[val].fieldname +
              " , " +
              this.props.t("Dashboard.ID_METHOD", { param: "" }) +
              " : " +
              method +
              " , " +
              this.props.t("Dashboard.Sheetorders.IDS_MSG_INSTRUM", { param: "" }) +
              " : " +
              instrument,
            Count: 1,
            data: [
              {
                resultvalue: parseFloat(Parameter[val].resultvalue),
                analysedate: Parameter[val].analysedate,
              },
            ],
          };
          comboParam.push(Param);
        } else {
          let index = comboParam.findIndex(
            (Combo) => Combo.Code === Parameter[val].fieldkey
          );
          comboParam[index].Count = comboParam[index].Count + 1;
          comboParam[index].data.push({
            resultvalue: parseFloat(Parameter[val].resultvalue),
            analysedate: Parameter[val].analysedate,
          });
        }
      }
    }

    let initparamter = {};
    if (comboParam !== undefined && comboParam.length > 0) {
      initparamter = comboParam[0];
      initparamter.data = comboParam[0].data.filter(function (obj) {
        obj.analysedate = new Date(obj.analysedate);
        return !isNaN(obj.resultvalue);
      });
    }

    let minDate = new Date();
    let maxDate = new Date();
    if (
      initparamter.data !== undefined &&
      initparamter.data !== null &&
      initparamter.data.length > 0
    ) {
      Math.min.apply(
        Math,
        initparamter.data.map(function (o) {
          return o.analysedate;
        })
      );
      maxDate = Math.max.apply(
        Math,
        initparamter.data.map(function (o) {
          return o.analysedate;
        })
      );
    }

    if (minDate !== undefined && minDate !== null) {
      minDate = new Date(minDate);
      minDate.setMonth(minDate.getMonth() - 1);
    }

    if (maxDate !== undefined && maxDate !== null) {
      maxDate = new Date(maxDate);
      maxDate.setMonth(maxDate.getMonth() + 1);
    }

    this.setState({
      Activitiescount: activitiescount !== null ? activitiescount : 0,
      TotalOrderCount: orders !== null ? orders : 0,
      Completedorders: completedorder !== null ? completedorder : 0,
      PendingOrders: pendingorder !== null ? pendingorder : 0,
      Inprogress: onproces !== null ? onproces : 0,
      Parameter: Parameter,
      paramcount: paramtercount,
      SelectedParam: initparamter,
      ParsedData: comboParam,
      Activities: activities,
      Ispiechartrender: true,
      Islinechartrender: true,
      orderlist: response.orderlst,
    });
  }

  updateuserrights(screenrights) {
    let sheetcreat = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATE");
    let protocolRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE");
    let temp = ControlRights("IDS_MDL_DASHBOARD", "IDS_TSK_TEMPLATEOVERVIEW");
    let order = ControlRights("IDS_MDL_DASHBOARD", "IDS_TSK_ORDEROVERVIEW");
    let Active = ControlRights("IDS_MDL_DASHBOARD", "IDS_TSK_ACTIVITIES");
    let ActiveWidget = ControlRights("IDS_MDL_DASHBOARD", "IDS_TSK_ACTIVIWIDGET");
    let dashboard = ControlRights("IDS_MDL_DASHBOARD");
    let inventory = ControlRights("IDS_MDL_DASHBOARD", "IDS_TSK_DASHBOARDINVENTORY");

    this.setState({
      sheetcreat: sheetcreat.UserGroupRights.save,
      protocolRights: protocolRights.UserGroupRights.save,
      tempvalue: temp.UserGroupRights.rights,
      Ordervalue: order.UserGroupRights.rights,
      actrights: Active.UserGroupRights.rights,
      actwidgetrights: ActiveWidget.UserGroupRights.rights,
      inventoryrights: inventory.UserGroupRights.rights,
      dashbordrights: dashboard.UserGroupRights.rights,
    });

    let protoRights = ControlRights("IDS_MDL_ORDERS", "IDS_SCN_PROTOCOLORDERS");
    let orderRights = ControlRights("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS");
    let sheetRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATE");
    let protoTemplRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE");
    let instrRights = ControlRights("IDS_MDL_SETUP", "IDS_SCN_INSTRUMENTMASTER");
    //let orderCreate = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNTASKORDER");
    let orderProCreate = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNPROTOCOL");

    this.setState({
      protorderRights: protoRights.UserGroupRights.rights,
      orderRights: orderRights.UserGroupRights.rights,
      sheetRights: sheetRights.UserGroupRights.rights,
      protoTemplRights: protoTemplRights.UserGroupRights.rights,
      instrRights: instrRights.UserGroupRights.rights,

      sheetSave: sheetRights.UserGroupRights.save,
      protocolSave: protoTemplRights.UserGroupRights.save,

      createOrder: orderRights.UserGroupRights.rights,

      createProOrder: orderProCreate.UserGroupRights.save,
    });
    if (screenrights !== undefined) {
      this.setState({ validurl: screenrights.Dashboard });
    }

  }

  onGetDashboardFailure(response) { }

  onfilterchange(e) {
    e.value.setHours(e.value.getHours() + new Date().getHours());
    e.value.setMinutes(e.value.getMinutes() + new Date().getMinutes());
    e.value.setSeconds(e.value.getSeconds() + new Date().getSeconds());
    this.setState({ initpagenofororder: 0, isformatorder: this.state.initpagenofororder > 0 ? 0 : this.state.isformatorder, initpagenofortemplate: 0, isformatemplate: this.state.initpagenofortemplate > 0 ? 0 : this.state.isformatemplate }, () => {
      this.GetDashboarddetails("1", e.value, e.value, true, true, true);
    })

    $.session.set("filterfrom", e.value);
    $.session.set("filterto", e.value);
    localStorage.setItem("daydiff", dateDiffInDays(e.value, e.value));
  }

  onfilterfromchange(fromdate, toDate) {
    let fromdate1 = GetutcDateaudi(fromdate);
    // let todateobj = GetutcDateaudi(toDate);
    this.setState({ initpagenofororder: 0, isformatorder: this.state.initpagenofororder > 0 ? 0 : this.state.isformatorder, fromdate: fromdate1, initpagenofortemplate: 0, isformatemplate: this.state.initpagenofortemplate > 0 ? 0 : this.state.isformatemplate }, () => {
      this.getordercount(this.state.fromdate, toDate);
      this.GetDashboarddetails("1", fromdate, toDate, true, true);
      $.session.set("filterfrom", fromdate1);
      localStorage.setItem("daydiff", dateDiffInDays(fromdate1, toDate));

    })
  }

  onfiltertochange(e) {
    this.setState({ initpagenofororder: 0, isformatorder: this.state.initpagenofororder > 0 ? 0 : this.state.isformatorder, todate: e, initpagenofortemplate: 0, isformatemplate: this.state.initpagenofortemplate > 0 ? 0 : this.state.isformatemplate }, () => {
      this.getordercount(this.state.fromdate, e);
      this.GetDashboarddetails("1", this.state.fromdate, e, true, true);
    })
    $.session.set("filterto", e);
    localStorage.setItem("daydiff", dateDiffInDays(this.state.fromdate, e));
  }

  onUpdatefilter(value) {
    this.setState({
      filtertype: value,
    });

    $.session.set("filtertype", value);
    localStorage.setItem("filtertype", value);
  }

  GetDashboarddetails(calvalue, fromdate, todate, ignoresheet, ignoretask, isCountchange) {

    if (this.state.filtertype === 1) {
      fromdate = GetutcDateaudi(fromdate);
      todate = GetutcDateoncurenttime(todate);
      todate.setHours(23);
      todate.setMinutes(59);
      todate.setSeconds(59);
      this.setState({ fromdate, todate })
    } else {
      todate = GetutcDateoncurenttime(todate);
      todate.setHours(23);
      todate.setMinutes(59);
      todate.setSeconds(59);
      this.setState({ todate })
    }
    switch (calvalue) {
      case "1":
        if (isCountchange !== undefined && isCountchange) {
          this.getordercount(fromdate, todate);
        }
        // if (ignoresheetorder === undefined) {
        this.getorders(fromdate, todate, this.state.initpagenofororder, true);
        // }
        if (ignoresheet) {
          this.getsheets(fromdate, todate, this.state.initpagenofortemplate, true);
          this.getsheetsCount4Chart(fromdate, todate, this.state.viewChart);
        }
        if (ignoretask) {
          this.getordersinworkflow(fromdate, todate);

        }
        this.setState({ fromdate: fromdate, todate: todate, });
        break;
      default:
        this.getorders(fromdate, todate, this.state.initpagenofororder, true);
        this.getsheets(fromdate, todate, this.state.initpagenofortemplate, true);
        if (ignoretask) {
          this.getordersinworkflow(fromdate, todate);
        }
        this.getsheetsCount4Chart(fromdate, todate, this.state.viewChart);
    }
    return true
  }

  getparameters(fromdate, todate) {
    let projects = Getuserprojectfromsession();
    let workflow = Getuserworkflowfromsession();
    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      lstproject: projects,
      lstworkflow: workflow,
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(fromdate),//.setUTCHours(0, 0, 0, 0),
        todate: GetutcDate(todate),//.setUTCHours(23, 59, 59, 999),
        orderselectiontype: this.state.Orderselectionontype,
        orderfor: this.state.Orderfor,
      },
      lssitemaster: store.getState().Loggeduser.lssitemaster,
    };

    Servicecalls(
      "" + this.ELNurl + "/DashBoard/Getdashboardparameters",
      passObjDet,
      this.getparameterssuccess.bind(this),
      this.onSheetsaveFaliure.bind(this)
    );
  }

  getparameterssuccess(response) {
    if (this._isMounted === false) {
      return;
    }
    let months = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

    let Parameter = response.ParsedParameters;
    let comboParam = [];
    let paramtercount = 0;
    if (Parameter !== undefined && Parameter.length > 0) {
      for (let val = 0; val < Parameter.length; val++) {
        if (Parameter[val].fieldcode.trim() === "") {
          continue;
        }
        paramtercount++;
        $.extend(true, Parameter[val], JSON.parse(Parameter[val].value));

        if (
          !comboParam.some(
            (Paramval) => Paramval.Code === Parameter[val].fieldkey
          )
        ) {
          let methodvalue = "";
          if (IsJSON(Parameter[val].methodname)) {
            let methods = JSON.parse(Parameter[val].methodname);
            let instruments = JSON.parse(Parameter[val].instrumentnames);
            if (methods !== undefined && methods.length > 0) {
              for (let index = 0; index < methods.length; index++) {
                methodvalue += methods[index] + " (" + instruments[index] + ")";

                if (index !== methods.length - 1) {
                  methodvalue += "; ";
                }
              }
            }
          } else {
            methodvalue = Parameter[val].methodname;
          }

          let method =
            Parameter[val].instrumentid === "I1" ||
              Parameter[val].instrumentid === "G1" ||
              Parameter[val].instrumentid === "IC1"
              ? this.props.t("fields." + Parameter[val].methodname, {
                param: "",
              })
              : methodvalue;
          let instrument =
            Parameter[val].instrumentid === "I1" ||
              Parameter[val].instrumentid === "G1" ||
              Parameter[val].instrumentid === "IC1"
              ? this.props.t("fields." + Parameter[val].methodname, {
                param: "",
              })
              : Parameter[val].instrumentname;
          let Param = {
            Code: Parameter[val].fieldkey,
            Display:
              "" +
              Parameter[val].fieldname +
              " , " +
              this.props.t("Dashboard.IDS_LBL_METHOD", { param: "" }) +
              " : " +
              method +
              " , " +
              this.props.t("Dashboard.IDS_MSG_INSTRUM", { param: "" }) +
              " : " +
              instrument,
            Count: 1,
            data: [
              {
                resultvalue: parseFloat(Parameter[val].resultvalue),
                analysedate: Parameter[val].analysedate,
              },
            ],
          };
          comboParam.push(Param);
        } else {
          let index = comboParam.findIndex(
            (Combo) => Combo.Code === Parameter[val].fieldkey
          );
          comboParam[index].Count = comboParam[index].Count + 1;
          comboParam[index].data.push({
            resultvalue: parseFloat(Parameter[val].resultvalue),
            analysedate: Parameter[val].analysedate,
          });
        }
      }
    }

    let initparamter = {};
    if (comboParam !== undefined && comboParam.length > 0) {
      initparamter = comboParam[0];
      initparamter.data = comboParam[0].data.filter(function (obj) {
        obj.analysedate = new Date(obj.analysedate);
        return !isNaN(obj.resultvalue);
      });
    }

    let minDate = new Date();
    let maxDate = new Date();
    if (
      initparamter.data !== undefined &&
      initparamter.data !== null &&
      initparamter.data.length > 0
    ) {
      Math.min.apply(
        Math,
        initparamter.data.map(function (o) {
          return o.analysedate;
        })
      );
      maxDate = Math.max.apply(
        Math,
        initparamter.data.map(function (o) {
          return o.analysedate;
        })
      );
    }

    if (minDate !== undefined && minDate !== null) {
      minDate = new Date(minDate);
      minDate.setMonth(minDate.getMonth() - 1);
    }

    if (maxDate !== undefined && maxDate !== null) {
      maxDate = new Date(maxDate);
      maxDate.setMonth(maxDate.getMonth() + 1);
    }

    this.setState({
      Parameter: Parameter,
      paramcount: paramtercount,
      SelectedParam: initparamter,
      ParsedData: comboParam,
      LineState: {
        description: "",
        padding: { left: 10, top: 5, right: 10, bottom: 5 },
        seriesGroups: [
          {
            series: [
              {
                dataField: "resultvalue",
                displayText: "Parameter",
                lineColor: "#5d9bfb",
              },
            ],
            type: "line",
          },
        ],
        source: initparamter,
        title: "",
        titlePadding: { left: 50, top: 0, right: 0, bottom: 0 },
        valueAxis: {
          tickMarks: { color: "#BCBCBC" },
          title: { text: "Value <br>" },
          visible: true,
          gridLines: { visible: false },
          //maxValue: 200,
          //minValue: 0
        },
        xAxis: {
          baseUnit: "month",
          dataField: "analysedate",
          formatFunction: (value) => {
            return (
              value.getDate() +
              "-" +
              months[value.getMonth()] +
              "-" +
              value.getFullYear()
            );
          },
          gridLines: {
            color: "#BCBCBC",
            interval: 3,
            visible: false,
          },
          labels: {
            angle: -45,
            offset: { x: 0, y: -25 },
            rotationPoint: "topright",
          },
          maxValue: maxDate,
          minValue: minDate,
          tickMarks: {
            color: "#BCBCBC",
            interval: 1,
            visible: false,
          },
          type: "date",
          // unitInterval: 1,
          valuesOnTicks: true,
        },
      },
      Ispiechartrender: false,
      Islinechartrender: true,
    });
  }

  getactivities(fromdate, todate) {
    let projects = Getuserprojectfromsession();
    let workflow = Getuserworkflowfromsession();
    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      lstproject: projects,
      lstworkflow: workflow,
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(fromdate),//.setUTCHours(0, 0, 0, 0),
        todate: GetutcDate(todate),//.setUTCHours(23, 59, 59, 999),
        orderselectiontype: this.state.Orderselectionontype,
        orderfor: this.state.Orderfor,
      },
    };

    Servicecalls(
      "" + this.ELNurl + "/DashBoard/Getdashboardactivities",
      passObjDet,
      this.getactivitiessuccess.bind(this),
      this.onSheetsaveFaliure.bind(this)
    );
  }

  getactivitiessuccess(response) {
    if (this._isMounted === false) {
      return;
    }

    let activities = response.activities;
    let activitiescount = response.activitiescount;

    this.setState({
      Activitiescount: activitiescount !== null ? activitiescount : 0,
      Activities: activities,
      Ispiechartrender: false,
      Islinechartrender: false,
    });
  }

  async getordercount(fromdate, todate) {
    if (this.state.filtertype === 1) {
      fromdate = GetutcDateaudi(fromdate);
      todate = GetutcDateoncurenttime(todate);
      todate.setHours(23);
      todate.setMinutes(59);
      todate.setSeconds(59);
      this.setState({ fromdate, todate })
    } else {
      todate = GetutcDateoncurenttime(todate);
      todate.setHours(23);
      todate.setMinutes(59);
      todate.setSeconds(59);
      this.setState({ todate })
    }
    let projects = Getuserprojectfromsession();
    let workflow = Getuserworkflowfromsession();

    let localFromdate = fromdate;
    let localtodate = todate;

    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      lssitemaster: {
        sitecode: $.session.get("Usersite"),
      },
      lstproject: projects,
      lstworkflow: workflow,
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(localFromdate),//.setUTCHours(0, 0, 0, 0),
        todate: GetutcDate(localtodate),//.setUTCHours(23, 59, 59, 999),
        orderselectiontype: this.state.Orderselectionontype,
        orderfor: this.state.Orderfor,
      },
      testcode: this.state.filtertest.testcode
    };
    if (this.state.filterproject.projectcode !== -1) {
      passObjDet.lstprojectforfilter = this.state.filterproject
    }
    passObjDet.usernotify = Getteamusersfromsession();
    // this.setState({
    //   ServiceToUrl: "" + this.ELNurl + "/DashBoard/Getdashboardordercount",
    //   ServiceHeaderobject: passObjDet,
    //   ServiceMethodType: "POST",
    //   ServcieonSuccess: this.getOrdercountsuccess.bind(this),
    //   ServcieonFailure: this.onSheetsaveFaliure.bind(this)
    // });
    Servicecalls(
      "" + this.ELNurl + "/DashBoard/Getdashboardordercount",
      passObjDet,
      this.getOrdercountsuccess.bind(this),
      this.onSheetsaveFaliure.bind(this)
    );
  }

  async getOrderCount4Chart(fromdate, todate, valueFor) {
    let projects = Getuserprojectfromsession();
    let workflow = Getuserworkflowfromsession();

    let localFromdate = fromdate;
    let localtodate = todate;

    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      lssitemaster: {
        sitecode: $.session.get("Usersite"),
      },
      lstproject: projects,
      lstworkflow: workflow,
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(localFromdate),//.setUTCHours(0, 0, 0, 0),
        todate: GetutcDate(localtodate),//.setUTCHours(23, 59, 59, 999),
        orderselectiontype: this.state.Orderselectionontype,
        orderfor: valueFor,
      },
    };
    Servicecalls(
      "" + this.ELNurl + "/DashBoard/Getdashboardordercount",
      passObjDet,
      (response) => {
        if (this._isMounted === false) {
          return;
        }
        if (!this.state.isfilter) {
          let orders = response.orders;
          let pendingorder = response.pendingorder;
          let completedorder = response.completedorder;
          let canceledOrder = response.canceledorder;
          let rejectedOrder = response.rejectedorder;
          let onproces = response.onproces;
          this.setState({
            TotalOrderCount: orders !== null ? orders : 0,
            Completedorders: completedorder !== null ? completedorder : 0,
            PendingOrders: pendingorder !== null ? pendingorder : 0,
            rejectedOrder: rejectedOrder !== null ? rejectedOrder : 0,
            canceledOrder: canceledOrder !== null ? canceledOrder : 0,
            Inprogress: onproces !== null ? onproces : 0,
            Islinechartrender: false,
          });

          this.setState({ Ispiechartrender: true, isChartView: true, isChartRender: true })
        }
      },
      this.onSheetsaveFaliure.bind(this)
    );
  }

  async getsheetsCount4Chart(fromdate, todate, templateFor) {
    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      lssitemaster: {
        sitecode: $.session.get("Usersite"),
      },
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(fromdate),
        todate: GetutctoDate(todate),
        orderselectiontype: this.state.Orderselectionontype,
        templatefor: templateFor,
        teamusers: Getteamusersfromsession(),
      },
    };
    if (this.ELNurl !== "") {
      Servicecalls(
        "" + this.ELNurl + "/DashBoard/getDashboardSheetCount",
        passObjDet,
        (res) => {
          if (res !== undefined) {
            this.setState({
              approvedTemplate: res.approvedTemplate !== null ? res.approvedTemplate : 0,
              createdTemplate: res.createdTemplate !== null ? res.createdTemplate : 0,
              rejectedTemplate: res.rejectedTemplate !== null ? res.rejectedTemplate : 0,
              inProgressTemplate: res.inprogressTemplate ? res.inprogressTemplate : 0,
              retiredTemplate: res.retiredTemplate ? res.retiredTemplate : 0
            })
            this.setState({ Ispiechartrender: true, isChartView: true, isChartRender: true })
          }
        },
        this.getdashboardsheetsfailure.bind(this)
      );
    }
  }

  getOrdercountsuccess(response) {
    if (this._isMounted === false) {
      return;
    }
    let orders = response.orders;
    let pendingorder = response.pendingorder;
    let completedorder = response.completedorder;
    let canceledOrder = response.canceledorder;
    let rejectedOrder = response.rejectedorder;
    let onproces = response.onproces;
    let total = parseInt(completedorder) + parseInt(pendingorder)
      + parseInt(rejectedOrder) + parseInt(canceledOrder)
    let orderstype = this.state.Orderselectionontype;
    this.setState({
      TotalOrderCount: orders !== null ? orders : 0,
      Completedorders: completedorder !== null ? completedorder : 0,
      PendingOrders: pendingorder !== null ? pendingorder : 0,
      rejectedOrder: rejectedOrder !== null ? rejectedOrder : 0,
      canceledOrder: canceledOrder !== null ? canceledOrder : 0,
      Inprogress: onproces !== null ? onproces : 0,
      Islinechartrender: false,
      totalordercountforsheetordergrid: orderstype === 1 ? total : orderstype === 3 ? parseInt(pendingorder) : orderstype === 2 ? parseInt(completedorder) : orderstype === 5 ? parseInt(rejectedOrder) : orderstype === 6 ? parseInt(canceledOrder) : 0,
      Ispiechartrender: true, isChartView: true, isChartRender: this.state.Orderselectionontype === 1 ? true : false
    });
  }

  getorders(fromdate, todate, page, isnew, pagerecords) {
    let projects = Getuserprojectfromsession();
    let workflow = Getuserworkflowfromsession();
    let Protcolorder_Workflow = Getprotocoluserworkflowfromsession();
    let localFromdate = fromdate;
    let localtodate = todate;

    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      lssitemaster: {
        sitecode: $.session.get("Usersite"),
      },
      lstproject: projects,
      // lstworkflow: workflow,
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(localFromdate),
        todate: GetutcDate(localtodate),
        orderselectiontype: this.state.Orderselectionontype,
        orderfor: this.state.Orderfor,
        multiusergroupcode: $.session.get("multiusergroups"),
      },
      testcode: this.state.filtertest.testcode
    };
    if (this.state.Orderfor === 1) {
      passObjDet.lstworkflow = workflow;
    } else {
      passObjDet.lstelnprotocolworkflow = Protcolorder_Workflow;
    }
    if (this.state.filterproject.projectcode !== -1) {
      passObjDet.lstprojectforfilter = this.state.filterproject
    }
    passObjDet.pagesize = page;
    passObjDet.pageperorder = pagerecords === undefined ? this.state.pageperrecors : pagerecords;
    passObjDet.usernotify = Getteamusersfromsession();
    if (this.ELNurl !== "") {
      Servicecalls(
        "" + this.ELNurl + "/DashBoard/Getdashboardorders",
        passObjDet,
        this.getdashboardorderssuccess.bind(this, isnew, pagerecords, false),
        this.getdashboardordersfailure.bind(this),
      );
      // this.setState({
      //   ServiceToUrl: "" + this.ELNurl + "/DashBoard/Getdashboardorders",
      //   ServiceHeaderobject: passObjDet,
      //   ServiceMethodType: "POST",
      //   ServcieonSuccess: this.getdashboardorderssuccess.bind(this, isnew, pagerecords, false),
      //   ServcieonFailure: this.getdashboardordersfailure.bind(this),
      // });
    }
  }


  getsharedbymeorders(fromdate, todate) {
    // let projects = Getuserprojectfromsession();
    // let workflow = Getuserworkflowfromsession();
    // let passObjDet = {
    //   usercode: $.session.get("User"),
    //   username: $.session.get("Username"),
    //   multiusergroups: $.session.get("multiusergroups"),
    //   lsusergroup: {
    //     usergroupcode: $.session.get("multiusergroups"),
    //     usergroupname: $.session.get("usergroupname"),
    //   },
    //   lstproject: projects,
    //   lstworkflow: workflow,
    //   objuser: {
    //     filtertype: this.state.filtertype,
    //     fromdate: GetutcDate(fromdate).setUTCHours(0, 0, 0, 0),
    //     todate: GetutcDate(todate).setUTCHours(23, 59, 59, 999),
    //     orderselectiontype: this.state.Orderselectionontype,
    //     orderfor: this.state.Orderfor,
    //   },
    // };
    // passObjDet.objsilentaudit = Silentauditobject(
    //   "view",
    //   "DashBoard",
    //   this.props.t("compareObjs.IDS_REPORTSSCREENLOADED", {
    //     screenName: AuditModuleNameEnum["DashBoard"],
    //   })
    // );
    // if (this.ELNurl !== "") {
    //   Servicecalls(
    //     "" + this.ELNurl + "/DashBoard/Getordersharebyme",
    //     passObjDet,
    //     this.getordersharebymesuccess.bind(this),
    //     this.getordersharebymefailure.bind(this)
    //   );
    // }
  }

  getordersharebymesuccess(response) {
    let sharedorders = response.orders;
    let tasklist = this.state.MyTask;
    if (sharedorders !== undefined && sharedorders.length > 0) {
      for (let index = 0; index < sharedorders.length; index++) {
        let task = {
          key: "shareby",
          code: sharedorders[index].sharedbycode,
          date:
            sharedorders[index].sharestatus === 1
              ? sharedorders[index].sharedon
              : sharedorders[index].unsharedon,
          template: this.sharebymetemplate(sharedorders[index]),
        };
        tasklist.push(task);
      }
      // tasklist = uniq(tasklist);
      this.sortmytaskondate(tasklist);
      const uniqueArray = tasklist.filter((value, index) => {
        const _value = JSON.stringify(value);
        return (
          index ===
          tasklist.findIndex((obj) => {
            return JSON.stringify(obj) === _value;
          })
        );
      });

      this.setState({ MyTask: uniqueArray });
    }
  }

  formatMyTask() {
    let task = [];
    if (this.state.MyTask !== undefined
      // && this.state.MyTask.length > 0
    ) {
      let mytask = [...this.state.MyTask];
      if (this.state.isfilter) {
        mytask = this.mytaskfilterlist()
      }
      // for (let index = 0; index < this.state.MyTask.length; index++) {
      //   task.push(this.state.MyTask[index].template);
      // }
      mytask.map((obj) => {
        if (obj.date !== undefined && typeof obj.date !== "string") {
          obj.date = setDateAsuserDefined(
            convertUTCDateToLocalDate(new Date(obj.date) || new Date()),
            $.session.get("userDefinedDate")
          )

        }
        // let month = [
        //   this.props.t("months.IDS_LBL_JAN", { param: "" }),
        //   this.props.t("months.IDS_LBL_FEB", { param: "" }),
        //   this.props.t("months.IDS_LBL_MAR", { param: "" }),
        //   this.props.t("months.IDS_LBL_APR", { param: "" }),
        //   this.props.t("months.IDS_LBL_MAY", { param: "" }),
        //   this.props.t("months.IDS_LBL_JUN", { param: "" }),
        //   this.props.t("months.IDS_LBL_JUL", { param: "" }),
        //   this.props.t("months.IDS_LBL_AUG", { param: "" }),
        //   this.props.t("months.IDS_LBL_SEP", { param: "" }),
        //   this.props.t("months.IDS_LBL_OCT", { param: "" }),
        //   this.props.t("months.IDS_LBL_NOV", { param: "" }),
        //   this.props.t("months.IDS_LBL_DEC", { param: "" }),
        // ];

        // let d = convertUTCDateToLocalDate(
        //   new Date(obj.date)
        // );
        // let day = d.getDate();
        // obj.month = month[d.getMonth()];
        // obj.year = d.getFullYear();
        // // let time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
        // obj.day = convertdoubledigitdate(day);
        // obj.time = convertdoubledigittime(
        //   d.getHours(),
        //   d.getMinutes(),
        //   d.getSeconds()
        // );
        // obj.Time_Zone = this.getCurrentTimeZone(d);

        // obj = (obj.hasOwnProperty("protoclordername") || obj.hasOwnProperty("pn")) ? ProtocolSequence(obj) : OrderSequence(obj);
        // // obj = OrderSequence(obj);
        return obj
      })
      let columns = [
        {
          header: this.props.t("Dashboard.IDS_LBL_ASSIGNDATE"),
          datatype: "date",
          rowselector: false,
          visible: true,
          doFilter: false,
          sortable: false,
          resizable: false,
          celltype: "dateColumn",
          className: "simple-grid-view",
          width: "100px"
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_ORDERID", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASK") : this.props.t("Dashboard.IDS_LBL_ORDER") }),
          datatype: "id",
          rowselector: false,
          visible: true,
          doFilter: false,
          resizable: false,
          sortable: false,
          className: "simple-grid-view",
          celltype: "orderGridView",
          pathName: "/registertask",
          width: "100px"
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_TASKNAME"),
          datatype: "testname",
          rowselector: false,
          visible: true,
          celltype: "noWrapColumn",
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          width: "100px"
        },
        {
          header: this.props.t("Dashboard.IDS_LBL_ASSIGNEDBY"),
          datatype: "assignedBy",
          rowselector: false,
          visible: true,
          celltype: "noWrapColumn",
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          width: "100px"
        },
        {
          header: this.props.t("Orders.Sheetorders.IDS_LBL_ASSIGEDNTO"),

          datatype: "assignedTo",
          rowselector: false,
          visible: true,
          celltype: "noWrapColumn",
          doFilter: true,
          resizable: false,
          className: "simple-grid-view",
          width: "100px"
        }

      ]
      // if (mytask && mytask.length > 0) {
      task = this.state.Loadershow && mytask.length === 0 ?
        <>
          <div className="no-data">
            <center>
              {loadingPanel}
            </center>
          </div>
        </> :
        mytask.length > 0 ?
          <KendoGridView
            enableTooltip={true}
            primaryKey="filecode"
            source={mytask}
            Columns={columns}
            DataSearchvisible={false}
            ShowDetailsVisible={false}
            height="300px"
            name="task_dashboard"
          /> : <div className="no-data"><center>
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <div>
              {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
            </div>
          </center></div>

      // } else {
      //   task = <div className="no-data"><center>
      //     <FontAwesomeIcon icon={faExclamationTriangle} />
      //     <div>
      //       {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
      //     </div>
      //   </center></div>

      // }

      // for (let index = 0; index < mytask.length; index++) {
      //   task.push(mytask[index].template);
      // }
    } else {
      task = <div className="no-data"><center>
        <FontAwesomeIcon icon={faExclamationTriangle} />
        <div>
          {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
        </div>
      </center></div>
    }
    return task;
  }

  mytaskfilterlist = () => {
    let mytask = [...this.state.MyTask];
    if ((this.state.isfilter && Object.keys(this.state.filtertest).length > 0 && this.state.filtertest.testcode !== -1) || (this.state.isfilter && Object.keys(this.state.filterproject).length > 0 && this.state.filterproject.projectcode !== -1)) {
      if (Object.keys(this.state.filtertest).length > 0) {
        if ((Object.keys(this.state.filterproject).length === 0 && this.state.filtertest.testcode !== -1) || (Object.keys(this.state.filterproject).length !== 0 && this.state.filterproject.projectcode === -1 && this.state.filtertest.testcode !== -1)) {
          mytask = mytask.filter((items) => items.testname !== undefined ? items.testname === this.state.filtertest.testname : items.testcode !== undefined ? items.testcode === parseInt(this.state.filtertest.testcode) : false)
        } else if ((Object.keys(this.state.filterproject).length > 0 && this.state.filtertest.testcode !== -1 && this.state.filterproject.projectcode !== -1)) {
          mytask = mytask.filter(
            (items) => items.projectname !== undefined && items.testname !== undefined ? items.projectname === this.state.filterproject.projectname && items.testname === this.state.filtertest.testname : items.projectname !== undefined && items.testcode !== undefined ? items.testcode === parseInt(this.state.filtertest.testcode) && items.projectname === this.state.filterproject.projectname : false)
        } else if ((Object.keys(this.state.filterproject).length > 0 && this.state.filterproject.projectcode === -1 && this.state.filtertest.testcode === -1) || (Object.keys(this.state.filterproject).length === 0 && this.state.filtertest.testcode === -1)) {
          // this.setState({ isfilter: false, }, () => {

          // }
          // )
        } else if (Object.keys(this.state.filterproject).length > 0 && this.state.filterproject.projectcode !== -1 && this.state.filtertest.testcode === -1) {
          mytask = mytask.filter((items) => items.projectname !== undefined ? items.projectname === this.state.filterproject.projectname : false)
        }
      } else {
        if ((Object.keys(this.state.filtertest).length === 0 && this.state.filterproject.projectcode !== -1) || ((Object.keys(this.state.filtertest).length !== 0 && this.state.filtertest.testcode === -1 && this.state.filterproject.projectcode !== -1))) {
          mytask = mytask.filter((items) => items.projectname !== undefined ? items.projectname === this.state.filterproject.projectname : false)
        } else if ((Object.keys(this.state.filtertest).length > 0 && this.state.filterproject.projectcode !== -1 && this.state.filtertest.testcode !== -1)) {
          mytask = mytask.filter((items) => items.projectname !== undefined && items.testname !== undefined ? items.projectname === this.state.filterproject.projectname && items.testname === this.state.filtertest.testname : items.projectname !== undefined && items.testcode !== undefined ? items.testcode === this.state.filtertest.testcode && items.projectname === this.state.filterproject.projectname : false)
        } else if ((Object.keys(this.state.filtertest).length > 0 && this.state.filtertest.testcode === -1 && this.state.filterproject.projectcode === -1) || (Object.keys(this.state.filtertest).length === 0 && this.state.filterproject.projectcode === -1)) {
          // this.setState({ isfilter: false, }, () => {
          // }
          // )
        } else if (this.state.filterproject.projectcode === -1 && Object.keys(this.state.filtertest).length > 0 && this.state.filtertest.testcode !== -1) {
          mytask = mytask.filter((items) => items.testname !== undefined ? items.testname === this.state.filtertest.testname : items.testcode !== undefined ? items.testcode === parseInt(this.state.filtertest.testcode) : false)
        }
      }
    }
    return mytask
  }

  formatInventory() {
    let invent = [];

    if (this.state.Inventory.length > 0) {
      for (let index = 0; index < this.state.Inventory.length; index++) {
        invent.push(
          <label key={"repo" + index} className={"radio "}>
            <input
              className="form-check-input"
              type="radio"
              value={this.state.Inventory[index].repositorycode}
              name="Templateforinventory"
              onChange={this.handleinventorychange.bind(this)}
              checked={
                this.state.SelectedInventory ===
                  this.state.Inventory[index].repositorycode
                  ? true
                  : false
              }
            />
            <span>{this.state.Inventory[index].repositoryname}</span>
          </label>
        );
      }
    }
    return invent;
  }

  sharebymetemplate(order) {
    let month = [];
    month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

    let d = convertUTCDateToLocalDate(
      new Date(order.sharestatus === 1 ? order.sharedon : order.unsharedon)
    );
    let day = d.getDate();
    let dayname = month[d.getMonth()];
    // let time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    day = convertdoubledigitdate(day);
    let time = convertdoubledigittime(
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    );

    let content = <p></p>;
    if (order.sharestatus === 1) {
      content = (
        <p>
          Shared sheet order{" "}
          <Orderdetail
            ordercode={order.sharebatchcode}
            orderid={order.sharebatchid}
          />{" "}
          to the user {order.sharetousername}
          {
            <Suspense fallback={<div></div>}>
              <Unshareorder
                order={order}
                index={-1}
                passbackorder={this.Getorderonunshare.bind(this)}
                props={this.props}
              />
            </Suspense>
          }
        </p>
      );
    } else {
      content = (
        <p>
          Unshared sheet order{" "}
          <Orderdetail
            ordercode={order.sharebatchcode}
            orderid={order.sharebatchid}
          />
          , which was shared to the user {order.sharetousername}
          {
            <Suspense fallback={<div></div>}>
              <Shareorder
                order={order}
                index={-1}
                passbackorder={this.Getorderonshare.bind(this)}
                isshared={true}
                toshare={order.sharetounifiedid}
                props={this.props}
              />
            </Suspense>
          }
        </p>
      );
    }

    return (
      <li
        className="list-group-item"
        aria-disabled="true"
        key={order.sharedbycode}
      >
        <div className="row no-gutters align-items-center">
          <div className="col-sm-2">
            <div className="calender-list">
              <span className="d-flex eln-stamp">{dayname}</span>
              <span className="d-flex eln-date">{day}</span>
              <span className="d-flex eln-stamp">{time}</span>
            </div>
          </div>
          <div className="col-sm-10">{content}</div>
        </div>
      </li>
    );
  }

  Getorderonunshare(order) {
    let orders = this.state.MyTask;
    let orderindex = orders.findIndex(
      (x) => x.key === "shareby" && x.code === order.sharedbycode
    );
    if (orderindex > -1) {
      let task = {
        key: "shareby",
        code: order.sharedbycode,
        date: order.sharestatus === 1 ? order.sharedon : order.unsharedon,
        template: this.sharebymetemplate(order),
        projectname: order.projectname !== undefined ? order.projectname : "",
        testname: order.testname !== undefined ? order.testname : ""
      };
      orders[orderindex] = task;

      // orders = uniq(orders);

      this.sortmytaskondate(orders);

      const uniqueArray = orders.filter((value, index) => {
        const _value = JSON.stringify(value);
        return (
          index ===
          orders.findIndex((obj) => {
            return JSON.stringify(obj) === _value;
          })
        );
      });

      this.setState({ MyTask: uniqueArray });
    }
  }

  sortmytaskondate(array) {
    return array
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
      .reverse();
  }

  Getorderonshare(orderval) {
    let order = orderval.order;
    let orders = this.state.MyTask;

    let orderindex = orders.findIndex(
      (x) => x.key === "shareby" && x.code === order.sharedbycode
    );
    if (orderindex > -1) {
      let task = {
        key: "shareby",
        code: order.sharedbycode,
        date: order.sharestatus === 1 ? order.sharedon : order.unsharedon,
        template: this.sharebymetemplate(order),
        projectname: order.projectname !== undefined ? order.projectname : "",
        testname: order.testname !== undefined ? order.testname : ""
      };
      orders[orderindex] = task;

      this.sortmytaskondate(orders);

      const uniqueArray = orders.filter((value, index) => {
        const _value = JSON.stringify(value);
        return (
          index ===
          orders.findIndex((obj) => {
            return JSON.stringify(obj) === _value;
          })
        );
      });

      this.setState({ MyTask: uniqueArray });
    }
  }

  getordersharebymefailure(response) { }

  getsharedtomeorders(fromdate, todate) {
    let projects = Getuserprojectfromsession();
    let workflow = Getuserworkflowfromsession();
    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      unifieduserid: sessionStorage.unifieduserid,
      lstproject: projects,
      lstworkflow: workflow,
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(fromdate),//.setUTCHours(0, 0, 0, 0),
        todate: GetutcDate(todate),//.setUTCHours(23, 59, 59, 999),
        orderselectiontype: this.state.Orderselectionontype,
        orderfor: this.state.Orderfor,
      },
      lssitemaster: {
        sitecode: sessionStorage.Usersite
      }
    };

    this.getdirectory()

    if (this.ELNurl !== "") {
      Servicecalls("" + this.ELNurl + "/DashBoard/Getordersharetome", passObjDet, this.getordersharetomesuccess.bind(this), this.getordersharetomefailure.bind(this));
    }
  }

  getordersharetomesuccess(response) {
    let sharedorders = response.orders;
    let Protocol_Assignedtome = response.Protocolorders || [];
    Protocol_Assignedtome = Protocol_Assignedtome?.map((item) => {
      const matchedTest = this.state.lsttest.find((object) => object.testcode === item?.protocolorders?.testcode);
      if (matchedTest) {
        item.protocolorders.testname = matchedTest.testname;
        return {
          ...item,
        };
      } else {
        return item;
      }
    }) || [];
    //     assignedTo: sharedorders[index].assignedto !== undefined && sharedorders[index].assignedto !== null ? sharedorders[index].assignedto.username : '-',
    //     assignedBy: sharedorders[index].assignedto !== undefined && sharedorders[index].lsuserMaster !== undefined ? sharedorders[index].lsuserMaster.username : "-"

    let tasklist = this.state.MyTask;
    if ((sharedorders !== undefined && sharedorders.length > 0) || Protocol_Assignedtome.length > 0) {
      for (let index = 0; index < sharedorders.length; index++) {
        let task = {
          key: "shareto",
          id: sharedorders[index].sharebatchid,
          code: sharedorders[index].sharebatchcode,
          pathName: "/registertask",
          date: sharedorders[index].sharedon,
          // template: this.sharetometemplate(sharedorders[index]),
          projectname: sharedorders[index].projectname !== undefined ? sharedorders[index].projectname : "",
          testname: sharedorders[index].testname !== undefined ? sharedorders[index].testname : "",
          assignedTo: "-",
          assignedBy: "-",
          ordercancell: sharedorders[index].ordercancell !== undefined ? sharedorders[index].ordercancell : undefined
        };
        tasklist.push(task);
      }

      Protocol_Assignedtome?.reduce((tasklist, items) => {
        const task = {
          ...items?.protocolorders,
          key: "ordertoprocess",
          id: items.shareprotoclordername,
          code: items.shareprotocolordercode,
          pathName: "/Protocolorder",
          date: items.sharedon,
          projectname: items.projectname || "",
          testname: items.protocolorders.testname || "",
          assignedTo: "-",
          assignedBy: "-",
          ordercancell: items.protocolorders.ordercancell !== undefined ? items.protocolorders.ordercancell : undefined
        };

        tasklist.push(task);
        return tasklist;
      }, tasklist);
      // tasklist = uniq(tasklist);
      tasklist = this.sortmytaskondate(tasklist);

      const uniqueArray = tasklist.filter((value, index) => {
        const _value = JSON.stringify(value);
        return (index === tasklist.findIndex((obj) => { return JSON.stringify(obj) === _value; }));
      });

      this.setState({ MyTask: uniqueArray });
    }
  }

  sharetometemplate(order) {
    let month = [];
    month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

    let d = convertUTCDateToLocalDate(new Date(order.sharedon));
    let day = d.getDate();
    let dayname = month[d.getMonth()];
    // obj.year = d.getFullYear();
    // let time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    day = convertdoubledigitdate(day);
    let time = convertdoubledigittime(
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    );
    let Time_Zone = this.getCurrentTimeZone(d);
    let content = (
      <p>
        {order.sharebyusername} shared the sheet order{" "}
        <Orderdetail
          ordercode={order.sharebatchcode}
          orderid={order.sharebatchid}
        />
      </p>
    );

    return (
      <li
        className="list-group-item"
        aria-disabled="true"
        key={order.sharedbycode}
      >
        <div className="row no-gutters align-items-center">
          <div className="col-sm-2">
            <div className="calender-list">
              <span className="d-flex eln-stamp">{dayname}</span>
              <span className="d-flex eln-date">{day}</span>
              <span className="d-flex eln-stamp">{time}</span>
              <span className="d-flex eln-stamp">{Time_Zone}</span>
            </div>
          </div>
          <div className="col-sm-10">{content}</div>
        </div>
      </li>
    );
  }

  getordersharetomefailure(response) { }

  getordersinworkflow(fromdate, todate) {
    let projects = Getuserprojectfromsession();
    let workflow = Getuserworkflowfromsession();
    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      lssitemaster: {
        sitecode: $.session.get("Usersite"),
      },
      lstelnprotocolworkflow: Getprotocoluserworkflowfromsession(),
      lstproject: projects,
      lstworkflow: workflow,
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(fromdate),//.setUTCHours(0, 0, 0, 0),
        todate: GetutcDate(todate),//.setUTCHours(23, 59, 59, 999),
        orderselectiontype: this.state.Orderselectionontype,
        orderfor: this.state.Orderfor,
      },
    };

    if (this.ELNurl !== "") {
      Servicecalls(
        "" + this.ELNurl + "/DashBoard/Getordersinuserworkflow",
        passObjDet,
        this.getordersinworkflowsuccess.bind(this),
        this.getordersinworkflowfailure.bind(this)
      );
    }
  }

  getordersinworkflowsuccess(response) {
    let sharedorders = response.orders;
    let Protocol_Assigned = response.protocolorders || [];

    sharedorders.map((item) => { item = OrderSequence(item); return item; });
    Protocol_Assigned.map((item) => { item = ProtocolSequence(item); return item; });

    Protocol_Assigned = Protocol_Assigned?.map((item) => {
      const matchedTest = this.state.lsttest.find((object) => object.testcode === item.testcode);
      if (matchedTest) {
        return {
          ...item,
          testname: matchedTest.testname,
        };
      } else {
        return item;
      }
    }) || [];
    let tasklist = [];
    if ((sharedorders !== undefined && sharedorders.length > 0) || (Protocol_Assigned.length > 0)) {
      for (let index = 0; index < sharedorders.length; index++) {
        let task = {
          key: "ordertoprocess",
          id: sharedorders[index].batchid,
          code: sharedorders[index].batchcode,
          batchcode: sharedorders[index].batchcode,
          date: sharedorders[index].createdtimestamp,
          pathName: "/registertask",
          // template: this.Ordertoprocesstemplate(sharedorders[index], "Sheetorder"),
          projectname: sharedorders[index].projectname !== undefined ? sharedorders[index].projectname : "",
          testname: sharedorders[index].testname !== undefined ? sharedorders[index].testname : "",
          assignedTo: sharedorders[index].assignedto !== undefined && sharedorders[index].assignedto !== null ? sharedorders[index].assignedto.username : '-',
          assignedBy: sharedorders[index].assignedto !== undefined && sharedorders[index].lsuserMaster !== undefined ? sharedorders[index].lsuserMaster.username : "-",
          ordercancell: sharedorders[index].ordercancell !== undefined ? sharedorders[index].ordercancell : undefined
        };
        tasklist.push(task);
      }

      Protocol_Assigned?.reduce((tasklist, items) => {
        const task = {
          ...items,
          key: "ordertoprocess",
          id: items.protoclordername,
          code: items.protocolordercode,
          pathName: "/Protocolorder",
          date: items.createdtimestamp,
          projectname: items.projectname || "",
          testname: items.testname || "",
          assignedTo: items.assignedto !== undefined && items.assignedto !== null ? items.assignedto.username : '-',
          assignedBy: items.assignedto !== undefined && items.lsuserMaster !== undefined ? items.lsuserMaster.username : "-",
          ordercancell: items.ordercancell !== undefined ? items.ordercancell : undefined
        };
        tasklist.push(task);
        return tasklist;
      }, tasklist);


      tasklist = this.sortmytaskondate(tasklist);
      const uniqueArray = tasklist.filter((value, index) => {
        const _value = JSON.stringify(value);
        return (
          index ===
          tasklist.findIndex((obj) => {
            return JSON.stringify(obj) === _value;
          })
        );
      });


      this.setState({ MyTask: uniqueArray }, () => {
        this.getsharedtomeorders(this.state.fromdate, this.state.todate)
      });
    } else if (sharedorders.length === 0) {
      // this.setState({ MyTask: sharedorders });
      this.getsharedtomeorders(this.state.fromdate, this.state.todate)
    }
  }

  onKeywordEnter(Value) {
    this.setState({
      keyName: Value,
    });
  }

  getinventory(fromdate, todate) {

    let todateLocal = GetutcDate(todate);//.setUTCHours(23, 59, 59, 999);

    let pass = {
      fromdate: GetutcDate(fromdate),//.setUTCHours(0, 0, 0, 0),
      todate: convertUTCDateToLocalDate(new Date(todateLocal)),
      sitecode: $.session.get("Usersite"),
    };

    if (this.ELNurl !== "") {
      Servicecalls(
        "" + this.ELNurl + "/Master/Getallrepositoriesondashboard",
        pass,
        this.getinventorysuccess.bind(this),
        this.getinventoryfailure.bind(this)
      );
    }
  }

  getinventorysuccess(response) {
    let inventList = response;

    this.setState({
      Inventory: inventList,
      SelectedInventory:
        inventList !== undefined && inventList.length > 0
          ? inventList[0].repositorycode
          : 0,
    });

    if (inventList !== undefined && inventList !== null) {
      let passObjDet = { repositorycode: inventList[0].repositorycode };

      Servicecalls(
        "" + this.ELNurl + "/Master/getrepositoryfields",
        passObjDet,
        this.onFieldGetSuccess.bind(this),
        this.onFieldGetFaliure.bind(this)
      );
    }
  }

  getinventoryfailure(response) { }

  Ordertoprocesstemplate(order, Screen) {
    let month = [];
    month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

    let d = convertUTCDateToLocalDate(new Date(order.createdtimestamp));
    let day = d.getDate();
    // obj.year = d.getFullYear();
    let dayname = month[d.getMonth()];
    // let time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    day = convertdoubledigitdate(day);
    let time = convertdoubledigittime(
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    );
    let Time_Zone = this.getCurrentTimeZone(d);
    let content = (
      <div>
        <p className="mytaskId">
          <Orderdetail ordercode={order.batchcode} orderid={order.batchid} />{" "}

          {this.props.t("Dashboard.IDS_LBL_ORDERASSIGNED", {
            user: $.session.get("Username"),
          })}
        </p>

        <NavLink
          className="ml-2 viewDetailIcon"
          to={{ pathname: "/registertask", state: order }}
          title={this.props.t("Dashboard.IDS_LBL_VIEW/PROCESSORDER")}
        >
          <i className="fas fa-18 fa-angle-double-right"></i>
        </NavLink>

      </div>
    );

    return (
      <li
        className="list-group-item list-group-item-action list-group-item-light"
        aria-disabled="true"
        key={order.batchcode}
      >
        <div className="row no-gutters align-items-center">
          <div className="col-sm-2">
            <div className="calender-list">
              <span className="d-flex eln-stamp">{dayname}</span>
              <span className="d-flex eln-date">{day}</span>
              <span className="d-flex eln-stamp">{time}</span>
              <span className="d-flex eln-stamp">{Time_Zone}</span>
            </div>
          </div>
          <div className="col-sm-10">{content}</div>
        </div>
      </li>
    );
  }

  getordersinworkflowfailure(response) { }

  getdashboardorderssuccess(isnew, pagerecords, ispropsdata, response) {

    if (this._isMounted === false) {
      return;
    }
    if (response.orderlst !== undefined && response.orderlst.length > 0) {
      response.orderlst.map((items) => {
        if (items.at !== undefined) {
          delete items.lsworkflow;
        }
        return items
      })
    }


    const filteredLstTest = this.state.lsttest.filter(obj => Object.keys(obj).length > 0);
    if (filteredLstTest.length > 0 && this.state.Orderfor === 2) {
      response.orderlst.forEach((items) => {
        return filteredLstTest.forEach(objects => {
          if (objects.testcode === items.testcode) {
            items.testname = objects.testname;
            return items;
          }
        });
      });
    }

    this.setState({
      Ispiechartrender: true,
      Islinechartrender: true,
      // dummyorderlist: response.orderlst,//kumu
    }
    );
    if (this.state.orderlist.length > 0 && !isnew) {
      let orders = [...this.state.orderlist]
      if ((pagerecords === undefined) || (pagerecords !== undefined && !this.state.isAllorders)) {
        orders = orders.concat(response.orderlst);
      } else {
        orders = response.orderlst
      }
      orders = [...new Map(orders.map(item => [JSON.stringify(item), item])).values()];
      this.setState({ orderlist: orders, isChartRender: false, isformatorder: this.state.Orderfor, Loadershow: false, isAllorders: false })

    } else {
      let orders = [...new Map(response.orderlst.map(item => [JSON.stringify(item), item])).values()];
      this.setState({ orderlist: orders, isformatorder: this.state.Orderfor, Loadershow: false, isAllorders: false })
    }
  }

  getdashboardordersfailure(response) { }

  getsheets(fromdate, todate, page, isnew) {
    let passObjDet = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      multiusergroups: $.session.get("multiusergroups"),
      lsusergroup: {
        usergroupcode: $.session.get("multiusergroups"),
        usergroupname: $.session.get("usergroupname"),
      },
      lssitemaster: {
        sitecode: $.session.get("Usersite"),
      },
      objuser: {
        filtertype: this.state.filtertype,
        fromdate: GetutcDate(fromdate),
        todate: GetutctoDate(todate),
        orderselectiontype: this.state.Orderselectionontype,
        templatefor: this.state.Templatefor,
        teamusers: Getteamusersfromsession(),
      },
    };
    passObjDet.pagesize = page;
    passObjDet.pageperorder = this.state.pageperrecors;
    if (this.ELNurl !== "") {
      Servicecalls(
        "" + this.ELNurl + "/DashBoard/Getdashboardsheets",
        passObjDet,
        this.getdashboardsheetssuccess.bind(this, isnew),
        this.getdashboardsheetsfailure.bind(this)
      );
    }
  }

  getdashboardsheetssuccess(isnew, response) {
    if (this._isMounted === false) {
      return;
    }
    let approvedsheet = [];
    if (response.Sheets !== undefined && response.Sheets.length > 0) {
      response.Sheets.map((item) => {
        if (item.approved === 1) {
          approvedsheet.push(item.filecode);
        }
        item.viewoptionstr = response.viewoption === 1 ? "Site" : response.viewoption === 2 ? "Only me" : "Project Team"
        return item
      })
    }
    if (Number(this.state.Templatefor) === 2) {
      response.Sheets = response.Sheets.filter((item) => item.status !== 0);
    }
    if (this.state.sheetlist.length > 0 && !isnew) {
      let sheetlist = this.state.sheetlist;
      let indexToConcat = this.state.initpagenofortemplate * this.state.pageperrecors;
      let firstindexvalues = sheetlist.slice(0, indexToConcat)
      let lastindexvalues = sheetlist.slice(indexToConcat + this.state.pageperrecors, sheetlist.length)
      firstindexvalues = firstindexvalues.concat(response.Sheets);
      if (lastindexvalues.length > 0) {
        firstindexvalues = firstindexvalues.concat(lastindexvalues);
      }
      this.setState({ sheetlist: firstindexvalues, isformatemplate: this.state.Templatefor, isChartRender: false }, () => {
        approvedsheet.unshift(this.state.Templatefor);
        // this.setState({
        //   ServiceToUrl: "" + this.ELNurl + "/DashBoard/Getapprovedsheet",
        //   ServiceHeaderobject: approvedsheet,
        //   ServiceMethodType: "POST",
        //   ServcieonSuccess: this.Getallrepositoriesssuccess.bind(this),
        //   ServcieonFailure: this.Getallrepositoriesailure.bind(this),
        // });
        Servicecalls(
          "" + this.ELNurl + "/DashBoard/Getapprovedsheet",
          approvedsheet,
          this.Getallrepositoriesssuccess.bind(this),
          this.Getallrepositoriesailure.bind(this)
        );
      })
    } else {
      let count = response.Sheets.length;
      count = response.count - count;
      const arr = Array(count).fill(null).map((_, index) => []);
      let dublicate = response.Sheets.concat(arr);
      this.setState({
        totalordercountfortemplategrid: response.count,
        Ispiechartrender: true,
        Islinechartrender: true,
        issheetpopoveron: false,
        sheetlist: dublicate, isformatemplate: this.state.Templatefor
      }, () => {
        approvedsheet.unshift(this.state.Templatefor);
        // this.setState({
        //   ServiceToUrl: "" + this.ELNurl + "/DashBoard/Getapprovedsheet",
        //   ServiceHeaderobject: approvedsheet,
        //   ServiceMethodType: "POST",
        //   ServcieonSuccess: this.Getallrepositoriesssuccess.bind(this),
        //   ServcieonFailure: this.Getallrepositoriesailure.bind(this),
        // });

        Servicecalls(
          "" + this.ELNurl + "/DashBoard/Getapprovedsheet",
          approvedsheet,
          this.Getallrepositoriesssuccess.bind(this),
          this.Getallrepositoriesailure.bind(this)
        );
      })
      this.setState({ Loadershowsheet: false });
    }
    // this.setState({
    //   Ispiechartrender: true,
    //   Islinechartrender: true,
    //   issheetpopoveron: false,
    //   sheetlist: response.Sheets,
    //   // dummytemplatelist: response.Sheets,
    // }, () => {
    //   approvedsheet.unshift(this.state.Templatefor);
    //   Servicecalls(
    //     "" + this.ELNurl + "/DashBoard/Getapprovedsheet",
    //     approvedsheet,
    //     this.Getallrepositoriesssuccess.bind(this),
    //     this.Getallrepositoriesailure.bind(this)
    //   );
    // });
  }
  Getallrepositoriesailure() { }
  Getallrepositoriesssuccess = (responce) => {
    let sheetlist = this.state.sheetlist;
    let responseval = responce;
    if (this.state.Templatefor === 1) {
      responseval = responce.Sheet;
    } else {
      responseval = responce.Protocol;
    }
    if (responseval.length > 0) {
      sheetlist = sheetlist.map((items) => {
        responseval.map((newitem) => {
          if (newitem.filecode === items.filecode) {
            items = newitem;
            return items
          }
          return items
        })
        return items
      })
    }
    this.setState({ sheetlist }, () => {
      let dubsheetlist = [...this.state.sheetlist];
      this.setState({ dubsheetlist })
    })

  }

  getdashboardsheetsfailure(response) { }

  onParameterChange(value) {
    let lineseries = this.state.LineState;
    let data = [];
    if (value !== undefined && value !== null) {
      data = value.data.filter(function (obj) {
        obj.analysedate = new Date(obj.analysedate);
        return !isNaN(obj.resultvalue);
      });
    }
    lineseries.source = data;

    let minDate = new Date();
    let maxDate = new Date();
    if (data !== undefined && data !== null && data.length > 0) {
      minDate = Math.min.apply(
        Math,
        data.map(function (o) {
          return o.analysedate;
        })
      );
      maxDate = Math.max.apply(
        Math,
        data.map(function (o) {
          return o.analysedate;
        })
      );
    }

    if (minDate !== undefined && minDate !== null) {
      minDate = new Date(minDate);
      minDate.setMonth(minDate.getMonth() - 1);
    }

    if (maxDate !== undefined && maxDate !== null) {
      maxDate = new Date(maxDate);
      maxDate.setMonth(maxDate.getMonth() + 1);
    }

    lineseries.xAxis.maxValue = maxDate;
    lineseries.xAxis.minValue = minDate;

    this.setState({
      LineState: lineseries,
      SelectedParam: value,
      Ispiechartrender: false,
      Islinechartrender: true,
    });
  }

  formatParamterProgress() {
    let Progress = [];
    if (
      this.state.ParsedData !== undefined &&
      this.state.ParsedData.length > 0
    ) {
      for (let index = 0; index < this.state.ParsedData.length; index++) {
        let Percentage = Math.round(
          PercentageCalculator(
            parseInt(this.state.paramcount),
            parseInt(this.state.ParsedData[index].Count)
          )
        );
        Progress.push(
          <div key={this.state.ParsedData[index].Code}>
            <h4 className="small font-weight-bold">
              {this.state.ParsedData[index].Display}{" "}
              <span className="float-right">{Percentage}%</span>
            </h4>
            <div className="progress mb-4">
              <div
                className="progress-bar bg-info"
                role="progressbar"
                aria-valuenow="80"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: Percentage + "%" }}
              ></div>
            </div>
          </div>
        );
      }
    }
    return Progress;
  }

  onactivitiyscrolled(e) {
    if (
      e.target.clientHeight + e.target.scrollTop === e.target.scrollHeight &&
      this.state.Activities !== undefined &&
      this.state.Activities.length > 0 &&
      this.state.Activities.length < this.state.Activitiescount
    ) {
      let passObjDet = this.state.Activities[this.state.Activities.length - 1];

      Servicecalls(
        "" + this.ELNurl + "/DashBoard/GetActivitiesonLazy",
        passObjDet,
        this.onGetActivitySuccess.bind(this),
        this.onGetActivityFaliure.bind(this)
      );
    }
  }

  onGetActivitySuccess(response) {
    if (response !== undefined && response.length > 0) {
      let activity = this.state.Activities;
      this.setState({
        Activities: activity.concat(response),
        Ispiechartrender: false,
        Islinechartrender: false,
      });
    }
  }

  onGetActivityFaliure(response) { }

  showSettings(event) {
    event.preventDefault();
  }


  // kumu
  onfilterchangefororders = (value, type, Orderselectionontype) => {
    this.setState({ isfilter: true })
    if (type === 1) {
      this.setState({ filtertest: value, initpagenofororder: 0, isformatorder: this.state.initpagenofororder > 0 ? 0 : this.state.isformatorder, initpagenofortemplate: 0, isformatemplate: this.state.initpagenofortemplate > 0 ? 0 : this.state.isformatemplate }, () => {
        this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, true, false, true);
      })
    } else if (type === 2) {
      this.setState({ filterproject: value, initpagenofororder: 0, isformatorder: this.state.initpagenofororder > 0 ? 0 : this.state.isformatorder, initpagenofortemplate: 0, isformatemplate: this.state.initpagenofortemplate > 0 ? 0 : this.state.isformatemplate }, () => {
        this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, true, false, true);
      })
    } else {
      this.setState({ filtertest: { "testcode": -1 }, filterproject: { projectcode: -1 }, initpagenofororder: 0, isformatorder: this.state.initpagenofororder > 0 ? 0 : this.state.isformatorder, initpagenofortemplate: 0, isformatemplate: this.state.initpagenofortemplate > 0 ? 0 : this.state.isformatemplate }, () => {
        this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, true, false, true);
      })
    }

  }

  changeMenuFilter = (index) => {
    let key = this.searchCriteria[index].value;
    let defaultsample = {}
    if (key === 2) {
      // let obj = {
      //   testname: this.props.t("-- select an option--"),
      //   testcode: -2,
      //   disabled: true,
      // }

      this.setState({ selecttaskandprojectvalues: [...this.state.lsttest], searchCriteriaType: defaultsample })


    } else if (key === 3) {

      // let obj = {
      //   projectname: this.props.t("-- select an option--"),
      //   projectcode: -3,
      //   disabled: true,
      // }
      this.setState({ selecttaskandprojectvalues: [...this.state.lstproject], searchCriteriaType: defaultsample }
        //   , () => {
        //   this.setState({ searchCriteriaType: this.state.selecttaskandprojectvalues[0] })
        // }
      )

    } else {
      this.setState({
        selecttaskandprojectvalues: [
          //   {
          //   projectname: this.props.t("-- select an option--"),
          //   projectcode: -4,
          //   disabled: true,
          // },
          {
            projectname: this.props.t("Dashboard.IDS_LBL_SEARCHBYALL"),
            projectcode: -1,
          }]
      },
        // () => {
        //   this.setState({ searchCriteriaType: this.state.selecttaskandprojectvalues[0] })
        // }
      )
    }
    this.setState({ filtertestorprojectkey: key, showDashboardFilter: !this.state.showDashboardFilter, })


  }


  filteropenstatus = (e) => {
    if (this.props.filteropenstatus !== undefined) {
      this.props.filteropenstatus(true);
    }

    this.setState({
      isregpopoveron: false,
      Ispiechartrender: false,
      Islinechartrender: false,
      issheetpopoveron: false,
    });

  };

  onAuditValidateError(res) { }

  onAuditValidateFailure(res) { }


  convertdoubledigitdate = (value) => (value < 10 ? `0${value}` : value);

  // Utility function to get the current time zone string
  getCurrentTimeZone = (d) => {
    const timeZoneOffset = d.getTimezoneOffset();
    const hoursOffset = Math.floor(Math.abs(timeZoneOffset) / 60);
    const minutesOffset = Math.abs(timeZoneOffset) % 60;
    const timeZoneSign = timeZoneOffset < 0 ? '+' : '-';
    return `GMT${timeZoneSign}${this.convertdoubledigitdate(hoursOffset)}:${this.convertdoubledigitdate(minutesOffset)}`;
  };

  gridRefreshUpdateevent = () => {
    this.setState({
      gridRefresh: false,
    });
  };

  formatorders() {
    let orders = [];
    // if (this.state.orderRights && this.state.Orderfor === 1) {
    if (
      this.state.orderlist !== undefined &&
      this.state.orderlist !== null
      // &&
      // this.state.orderlist.length > 0
    ) {
      // let month = [
      //   this.props.t("months.IDS_LBL_JAN", { param: "" }),
      //   this.props.t("months.IDS_LBL_FEB", { param: "" }),
      //   this.props.t("months.IDS_LBL_MAR", { param: "" }),
      //   this.props.t("months.IDS_LBL_APR", { param: "" }),
      //   this.props.t("months.IDS_LBL_MAY", { param: "" }),
      //   this.props.t("months.IDS_LBL_JUN", { param: "" }),
      //   this.props.t("months.IDS_LBL_JUL", { param: "" }),
      //   this.props.t("months.IDS_LBL_AUG", { param: "" }),
      //   this.props.t("months.IDS_LBL_SEP", { param: "" }),
      //   this.props.t("months.IDS_LBL_OCT", { param: "" }),
      //   this.props.t("months.IDS_LBL_NOV", { param: "" }),
      //   this.props.t("months.IDS_LBL_DEC", { param: "" }),
      // ];
      if (this.state.Orderfor === 1
        // && this.state.isformatorder === 1
      ) {

        let lstOrders = []
        for (
          let orderindex = 0;
          orderindex < this.state.orderlist.length;
          orderindex++
        ) {
          let order = this.state.orderlist[orderindex];

          order.ordercode = order.batchcode;
          order.isprocess = true;
          order.pathName = "/registertask";

          order.batchcode = order.bc;
          order.batchid = order.bi;
          order.workflowcode = order.wc;
          order.testname = order.tn;
          order.filename = order.fn;
          order.projectname = order.pn;
          order.samplename = order.sn;
          order.filetype = order.ft;
          order.filecode = order.fc;
          order.orderflag = order.of ? order.of : order.orderflag;
          order.createdtimestamp = order.ct;
          order.completedtimestamp = order.cot;
          order.keyword = order.kw;
          order.lsworkflow = order.lsw;
          order.ordercancell = order.oc ? order.oc : order.ordercancell;
          order.assignedto = order.at;
          order.testcode = order.tc;
          order.viewoption = order.vo;
          order.createdby = order.cb;
          order.approvelstatus = order.as ? order.as : order.approvelstatus;
          order.lsordernotification = order.on;
          order.ordersaved = order.os;
          order.repeat = order.r;
          order.lsautoregisterorders = order.ar;
          order.sentforapprovel = order.sfa;
          order.approvelaccept = order.aa;
          order.autoregistercount = order.arc;
          order.materialname = order.mn;
          order.approved = order.ap ? order.ap : order.approved;

          order = convertshorthandtooriginal(order);

          order.status =

            order?.lsordernotification !== undefined && order?.lsordernotification?.isduedateexhausted && order?.lsordernotification?.isduedateexhausted === true && order?.lsordernotification?.iscompleted && order?.lsordernotification?.iscompleted !== true ? "OverDue" :
              order.approvelstatus === 1 && order?.approved !== 1 && order.orderflag.trim() === "N" && order?.ordercancell === undefined
                ? "In-Progress" :
                (order.orderflag?.trim() === "R" && order?.ordercancell === undefined && order.approvelstatus === 1) || (order.orderflag?.trim() === "R" && order.approvelstatus !== 3)
                  ? "Completed" : order.orderflag?.trim() === "N" && order?.ordercancell !== undefined && order?.ordercancell === 1 ? "Cancelled" : order.orderflag?.trim() === "N" && order.approvelstatus === 1 && order?.approved === 1 ? "Approved" : order.approvelstatus === 3 && order?.ordercancell === undefined
                    ? "Rejected" : "Created"

          order.ordercancell = order.ordercancell !== undefined ? order.ordercancell : undefined
          lstOrders.push(order)
        }
        lstOrders = lstOrders.sort(function (a, b) { return b.createdtimestamp - a.createdtimestamp; });
        lstOrders.map((obj) => {
          if (obj.createdtimestamp !== undefined && typeof obj.createdtimestamp !== "string") {
            obj.createdtimestampobj = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(obj.createdtimestamp) || new Date()),
              $.session.get("userDefinedDate")
            )

          }
          if (obj?.completedtimestamp !== undefined && typeof obj.completedtimestamp !== "string") {
            obj.completedtimestampobj = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(obj.completedtimestamp) || new Date()),
              $.session.get("userDefinedDate")
            )
          }
          if (obj?.lsordernotification?.duedate !== undefined && typeof obj.lsordernotification?.duedate !== "string") {
            obj.lsordernotification.duedateobj = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(obj.lsordernotification.duedate) || new Date()),
              $.session.get("userDefinedDate")
            )
          }
          if (obj.projectname === undefined && obj.lsworkflow !== undefined) {
            delete obj.lsworkflow
          }

          if (obj.modifieddate !== undefined && obj.modifieddate !== null && typeof obj.modifieddate !== "string") {
            obj.modifieddateobj = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(obj.modifieddate) || new Date()),
              $.session.get("userDefinedDate")
            )
          }
          // obj.isDateTimeUpdate = true;
          return obj
        })
        // let orderstype = this.state.Orderselectionontype;
        orders = this.state.Loadershow && this.state.orderlist.length === 0 ? <>
          <div className="no-data">
            <center>
              {loadingPanel}
            </center>
          </div>
        </> : this.state.orderlist.length > 0 ?
          <KendoGridView
            enableTooltip={true}
            name="order_dashboard"
            primaryKey="batchcode"
            source={lstOrders}
            Columns={this.state.Sheetorders_Customcolumn?.filter(Items => Items.Isshow)}
            DataSearchvisible={false}
            ShowDetailsVisible={false}
            height="300px"
            // pageSizeable={true}
            pageperrecors={this.state.pageperrecors}
            total={this.state.totalordercountforsheetordergrid}//{300} //this.state.totalordercountforsheetordergrid}
            pagechangeeevent={this.pagechangeeevent.bind(this)}
            Gridname={"orders"}
            initpagenofororder={this.state.initpagenofororder}
            Onstoredatetoredux={this.Onstoredatetoredux.bind(this)}
            gridRefresh={this.state.gridRefresh}
            gridRefreshUpdateevent={this.gridRefreshUpdateevent.bind(this)}
          /> : <div className="no-data">
            <center>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              <div>
                {this.props.t("Dashboard.IDS_LBL_NORECFOUND")}
              </div>
            </center>
          </div>


      } else if (this.state.Orderfor === 2
        // && this.state.isformatorder === 2
      ) {

        let index = 0;
        let lstOrders = []
        for (index; index < this.state.orderlist.length; index++) {
          let orderpro = this.state.orderlist[index];
          orderpro.isprotocolprocess = true;

          // orderpro = convertprotocolshorthandtooriginal(orderpro);

          orderpro.status =
            orderpro?.lsordernotification !== undefined && orderpro?.lsordernotification?.isduedateexhausted && orderpro?.lsordernotification?.iscompleted !== true ? "OverDue" :
              orderpro.approved !== undefined && orderpro.approved === 0 && orderpro.orderflag.trim() === "N" && orderpro?.ordercancell === undefined && orderpro?.rejected === undefined
                ? "In-Progress" : orderpro.orderflag.trim() === "N" && orderpro?.ordercancell !== undefined && orderpro?.ordercancell === 1 ? "Cancelled" : orderpro.approved !== undefined && orderpro.approved === 1 && orderpro.orderflag.trim() === "N" ? "Approved" :
                  orderpro.orderflag?.trim() === "R" && orderpro.rejected === undefined && orderpro?.ordercancell === undefined
                    ? "Completed" : orderpro?.rejected !== undefined && orderpro?.rejected === 1 && orderpro?.ordercancell === undefined
                      ? "Rejected" : "Created"


          if (orderpro?.completedtimestamp !== undefined && typeof orderpro.completedtimestamp !== "string") {
            // let d = convertUTCDateToLocalDate(
            //   new Date(orderpro.completedtimestamp)
            // );
            // let day = d.getDate();
            // orderpro.Year_Complete = d.getFullYear();
            // orderpro.Month_Complete = month[d.getMonth()];
            // orderpro.Day_Complete = convertdoubledigitdate(day);
            // orderpro.Time_Complete = convertdoubledigittime(
            //   d.getHours(),
            //   d.getMinutes(),
            //   d.getSeconds()
            // );
            // orderpro.Time_Zone = this.getCurrentTimeZone(d);

            orderpro.completedtimestamp = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(orderpro.completedtimestamp) || new Date()),
              $.session.get("userDefinedDate")
            )
          }

          orderpro.pathName = "/Protocolorder";

          orderpro = convertprotocolshorthandtooriginal(orderpro);

          if (orderpro.versionUpdate === undefined && orderpro?.templateversionno !== undefined && orderpro?.templateversionno !== null && orderpro?.templateversionno !== "" && orderpro?.protocolmastername !== undefined && orderpro?.protocolmastername !== null && orderpro?.protocolmastername !== "") {
            orderpro.protocolmastername = orderpro?.protocolmastername + " _v" + orderpro.templateversionno;
            orderpro.versionUpdate = true;
          }

          lstOrders.push(orderpro)
        }
        lstOrders.map((obj) => {
          if (obj.createdtimestamp !== undefined && typeof obj.createdtimestamp !== "string") {
            obj.createdtimestamp = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(obj.createdtimestamp) || new Date()),
              $.session.get("userDefinedDate")
            )
          }
          if (obj.lsordernotification?.duedate !== undefined && typeof obj.lsordernotification?.duedate !== "string") {
            obj.lsordernotification.duedate = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(obj.lsordernotification.duedate) || new Date()),
              $.session.get("userDefinedDate")
            )
          }
          if ((obj.projectname === undefined || obj.projectname === "") && obj.lsworkflow !== undefined) {
            delete obj.lsworkflow
          }
          if (obj.modifieddate !== undefined && obj.modifieddate !== null && typeof obj.modifieddate !== "string") {
            obj.modifieddate = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(obj.modifieddate) || new Date()),
              $.session.get("userDefinedDate")
            )
          }
          return obj
        })

        orders = this.state.Loadershow && this.state.orderlist.length === 0 ? <>
          <div className="no-data">
            <center>
              {loadingPanel}
            </center>
          </div>
        </> : this.state.orderlist.length > 0 ?
          <KendoGridView
            enableTooltip={true}
            name="listorder_dashboard"
            primaryKey="protocolordercode"
            source={lstOrders}
            Columns={this.state.Protocolorder_Customcolumn?.filter(Items => Items.Isshow)}
            DataSearchvisible={false}
            ShowDetailsVisible={false}
            height="300px"
            // pageSizeable={true}
            pageperrecors={this.state.pageperrecors}
            total={this.state.totalordercountforsheetordergrid}
            pagechangeeevent={this.pagechangeeevent.bind(this)}
            Gridname={"orders"}
            initpagenofororder={this.state.initpagenofororder}
            Onstoredatetoredux={this.Onstoredatetoredux.bind(this)}
            gridRefresh={this.state.gridRefresh}
            gridRefreshUpdateevent={this.gridRefreshUpdateevent.bind(this)}

          /> : <div className="no-data">
            <center>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              <div>
                {this.props.t("Dashboard.IDS_LBL_NORECFOUND")}
              </div>
            </center>
          </div>

      } else {
        orders =
          <div className="no-data">
            <center>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              <div>
                {this.props.t("Dashboard.IDS_LBL_NORECFOUND")}
              </div>
            </center>
          </div>
      }
    } else {
      orders =
        <div className="no-data">
          <center>
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <div>
              {this.props.t("Dashboard.IDS_LBL_NORECFOUND")}
            </div>
          </center>
        </div>
    }

    return orders;
  }


  Onstoredatetoredux = () => {
    let DashboardDetailsObj = {
      orderlist: this.state.orderlist,
      MyTask: this.state.MyTask,
      Orderfor: this.state.Orderfor,
      Templatefor: this.state.Templatefor,
      sheetlist: this.state.sheetlist,
      Completedorders: this.state.Completedorders,
      PendingOrders: this.state.PendingOrders,
      rejectedOrder: this.state.rejectedOrder,
      canceledOrder: this.state.canceledOrder,
      Orderselectionontype: this.state.Orderselectionontype
    }
    store.dispatch(DashboardDetails(DashboardDetailsObj));
  }

  pagechangeeevent(pageno, totalrecord, Gridname) {

    if (Gridname !== undefined && Gridname === "orders" && totalrecord === this.state.pageperrecors) {
      let totalpage = Math.ceil(this.state.totalordercountforsheetordergrid / totalrecord);
      // Math.round(this.state.totalordercountforsheetordergrid / totalrecord);
      let indexToConcat = pageno * totalrecord;
      if (this.state.orderlist.length < indexToConcat + totalrecord && this.state.totalordercountforsheetordergrid > this.state.orderlist.length) {
        if (this.state.initpagenofororder + 1 === pageno && pageno + 1 <= totalpage) {
          let perrecord = undefined;
          if (totalpage === (pageno + 1)) {
            perrecord = Math.abs(this.state.totalordercountforsheetordergrid - this.state.orderlist.length)
          }
          this.setState({ initpagenofororder: pageno, pageperrecors: totalrecord, isChartRender: false }, () => {
            this.getorders(this.state.fromdate, this.state.todate, pageno, false, perrecord)
          });
        } else {
          let perrecord = (pageno + 1) * totalrecord;
          if (totalpage === (pageno + 1)) {
            perrecord = this.state.totalordercountforsheetordergrid
          }
          this.setState({ initpagenofororder: pageno, pageperrecors: totalrecord, isChartRender: false, isAllorders: true }, () => {
            this.getorders(this.state.fromdate, this.state.todate, 0, false, perrecord);
          });

        }
      } else {
        this.setState({
          initpagenofororder: pageno
        })
      }
    } else if (Gridname !== undefined && Gridname === "template" && totalrecord === this.state.pageperrecors) {
      let indexToConcat = pageno * this.state.pageperrecors;
      indexToConcat = this.state.sheetlist.slice(indexToConcat, indexToConcat + this.state.pageperrecors);
      if (indexToConcat.length > 0) {
        indexToConcat = indexToConcat.filter((item) => item.ordercode === undefined)
        if (indexToConcat.length > 0) {
          this.setState({ initpagenofortemplate: pageno, pageperrecors: totalrecord, isChartRender: false }, () => {
            this.getsheets(this.state.fromdate, this.state.todate, pageno, false);
          });
        }

      }
    } else if (totalrecord !== this.state.pageperrecors) {
      this.setState({ initpagenofortemplate: pageno, initpagenofororder: pageno, pageperrecors: totalrecord, isChartRender: false }, () => {
        if (Gridname === "orders") {
          this.getorders(this.state.fromdate, this.state.todate, pageno, true)
        } else if (Gridname === "template") {
          this.getsheets(this.state.fromdate, this.state.todate, pageno, true);
        }
      });
    }

  }



  formatsheets() {
    let sheets = [];
    if (this.state.sheetlist !== undefined && this.state.sheetlist !== null
      // && this.state.sheetlist.length > 0
    ) {
      let month = [
        this.props.t("months.IDS_LBL_JAN", { param: "" }),
        this.props.t("months.IDS_LBL_FEB", { param: "" }),
        this.props.t("months.IDS_LBL_MAR", { param: "" }),
        this.props.t("months.IDS_LBL_APR", { param: "" }),
        this.props.t("months.IDS_LBL_MAY", { param: "" }),
        this.props.t("months.IDS_LBL_JUN", { param: "" }),
        this.props.t("months.IDS_LBL_JUL", { param: "" }),
        this.props.t("months.IDS_LBL_AUG", { param: "" }),
        this.props.t("months.IDS_LBL_SEP", { param: "" }),
        this.props.t("months.IDS_LBL_OCT", { param: "" }),
        this.props.t("months.IDS_LBL_NOV", { param: "" }),
        this.props.t("months.IDS_LBL_DEC", { param: "" }),
      ];
      if (this.state.Templatefor === 1) {
        let listSheet = []
        for (
          let sheetindex = 0;
          sheetindex < this.state.sheetlist.length;
          sheetindex++
        ) {
          let sheet = this.state.sheetlist[sheetindex];
          sheet.ordercode = sheet.filecode;
          sheet.isprocess = true;
          sheet.status = sheet.retirestatus === 1 ? this.props.t("Templates.Protocol.IDS_LBL_RETIRED") : sheet.rejected === 1 ? "Rejected" : sheet.approved === 1 ? "Approved" : sheet.approved === 0 ? "In-Progress" : "Created"
          if (sheet.modifieddate !== undefined && sheet.modifieddate !== null && typeof sheet.modifieddate !== "string") {
            // sheet.modifieddate = convertUTCDateToLocalDate(
            //   new Date(sheet.modifieddate)
            // );
            sheet.modifieddate = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(sheet.modifieddate) || new Date()),
              $.session.get("userDefinedDate")
            )
          }
          if (sheet.createdate !== undefined && sheet.createdate !== null && typeof sheet.createdate !== "string") {
            sheet.createdateview = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(sheet.createdate) || new Date()),
              $.session.get("userDefinedDate")
            )
            // let d = convertUTCDateToLocalDate(
            //   new Date(sheet.createdate)
            // );
            // let day = d.getDate();
            // sheet.year = d.getFullYear();
            // sheet.month = month[d.getMonth()];
            // sheet.day = convertdoubledigitdate(day);
            // sheet.time = convertdoubledigittime(
            //   d.getHours(),
            //   d.getMinutes(),
            //   d.getSeconds()
            // );
            // sheet.Time_Zone = this.getCurrentTimeZone(d);
          }

          sheet.pathName = "/sheetcreation";
          listSheet.push(sheet)
        }



        sheets = this.state.Loadershowsheet && this.state.sheetlist.length === 0 ? <>
          <div className="no-data">
            <center>
              {loadingPanel}
            </center>
          </div>
        </> : this.state.sheetlist.length > 0 ?
          <KendoGridView
            enableTooltip={true}
            name="sheets_dashboard"
            primaryKey="filecode"
            source={listSheet}
            Columns={this.state.Sheettemplate_Customcolumn?.filter(Items => Items.Isshow)
            }
            DataSearchvisible={false}
            ShowDetailsVisible={false}
            height="300px"
            template={true}
            // pageSizeable={true}
            pageperrecors={this.state.pageperrecors}
            total={this.state.totalordercountfortemplategrid}
            pagechangeeevent={this.pagechangeeevent.bind(this)}
            gridRefresh={this.state.gridRefresh}
            gridRefreshUpdateevent={this.gridRefreshUpdateevent.bind(this)}

            Gridname={"template"}
          /> : <div className="no-data">
            <center>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              <div>
                {this.props.t("Dashboard.IDS_LBL_NORECFOUND")}
              </div>
            </center>
          </div>
      } else if (this.state.Templatefor === 2) {
        let listProtocol = []
        for (let index = 0; index < this.state.sheetlist.length; index++) {
          let sheetpro = this.state.sheetlist[index];
          sheetpro.Protocolordervisible = true;
          sheetpro.ordercode = sheetpro.protocolmastercode;
          sheetpro.isprotocolprocess = true;
          if (sheetpro.modifieddate !== undefined && sheetpro.modifieddate !== null && typeof sheetpro.modifieddate !== "string") {
            sheetpro.modifieddate = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(sheetpro.modifieddate) || new Date()),
              $.session.get("userDefinedDate")
            )
          }
          if (sheetpro.createdate !== undefined && sheetpro.createdate !== null && typeof sheetpro.createdate !== "string") {
            // let d = convertUTCDateToLocalDate(
            //   new Date(sheetpro.createdate)
            // );
            // let day = d.getDate();
            // sheetpro.year = d.getFullYear();
            // sheetpro.month = month[d.getMonth()];
            // sheetpro.day = convertdoubledigitdate(day);
            // sheetpro.time = convertdoubledigittime(
            //   d.getHours(),
            //   d.getMinutes(),
            //   d.getSeconds()
            // );
            // sheetpro.Time_Zone = this.getCurrentTimeZone(d);
            sheetpro.createdateprotocol = setDateAsuserDefined(
              convertUTCDateToLocalDate(new Date(sheetpro.createdate) || new Date()),
              $.session.get("userDefinedDate")
            )

          }
          sheetpro.pathName = "/protocols";
          listProtocol.push(sheetpro)
        }


        sheets = this.state.Loadershowsheet && this.state.sheetlist.length === 0 ? <>
          <div className="no-data">
            <center>
              {loadingPanel}
            </center>
          </div>
        </> : this.state.sheetlist.length > 0 ?
          <KendoGridView
            enableTooltip={true}
            name="listsheets_dashboard"
            primaryKey="filecode"
            source={listProtocol}
            Columns={this.state.Protocoltemplate_Customcolumn?.filter(Items => Items.Isshow)}
            DataSearchvisible={false}
            ShowDetailsVisible={false}
            height="300px"
            template={true}
            // pageSizeable={true}
            pageperrecors={this.state.pageperrecors}
            total={this.state.totalordercountfortemplategrid}
            pagechangeeevent={this.pagechangeeevent.bind(this)}
            Gridname={"template"}
            gridRefresh={this.state.gridRefresh}
            gridRefreshUpdateevent={this.gridRefreshUpdateevent.bind(this)}

          /> : <div className="no-data"><center>
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <div>
              {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
            </div>
          </center></div>
      } else {
        sheets = <div className="no-data"><center>
          <FontAwesomeIcon icon={faExclamationTriangle} />
          <div>
            {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
          </div>
        </center></div>

      }
    } else {
      sheets = <div className="no-data"><center>
        <FontAwesomeIcon icon={faExclamationTriangle} />
        <div>
          {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
        </div>
      </center></div>

    }
    return sheets;
  }

  onOpenorder() { }

  onOrdertypeChange = (key, id, text, value) => {
    if (value !== undefined) {
      let orderCreate = ControlRights(
        "IDS_MDL_DASHBOARD",
        value.name
      );
      this.setState({ createOrder: orderCreate.UserGroupRights.save });

      //** This for no sheet (Research Activity order) */
      /**start */
      if (value.type === 3) {
        let sheetLst = this.state.lstsheet;

        let noSheet = {
          filecode: 1,
          filenameuser: "Default Template",
        };
        sheetLst.unshift(noSheet);

        let nodata = {};
        sheetLst.unshift(nodata);

        let selectedsheet =
          sheetLst !== undefined && sheetLst !== null && sheetLst.length > 0
            ? sheetLst[0]
            : undefined;

        this.setState({ lstsheet: sheetLst, selectedsheet: selectedsheet });
      } else {

        let sheetLst = this.state.lstsheet;

        let nodata = {};
        sheetLst.unshift(nodata);

        sheetLst = sheetLst.filter((item) => item.filecode !== 1);

        let selectedsheet =
          sheetLst !== undefined && sheetLst !== null && sheetLst.length > 0
            ? sheetLst[0]
            : undefined;

        this.setState({ lstsheet: sheetLst, selectedsheet: selectedsheet });
      }
      /**end */

      let displayvalue = { selectedorder: value };
      if (id === "4") {
        displayvalue.testdisplay = "none";
        displayvalue.sheetdisplay = "none";
        displayvalue.sampledisplay = "block";
        displayvalue.valsheetdisplay = "none";
      } else if (id === "5") {
        displayvalue.testdisplay = "none";
        displayvalue.sheetdisplay = "none";
        displayvalue.sampledisplay = "none";
        displayvalue.valsheetdisplay = "block";
      } else {
        displayvalue.testdisplay = "block";
        displayvalue.sheetdisplay = "block";
        displayvalue.sampledisplay = "block";
        displayvalue.valsheetdisplay = "none";
      }
      this.setState(displayvalue);
    }
  };

  onChartTypeChange = () => {
    this.setState({ selectedChartOrderType: this.state.selectedChartOrderType === 'bar' ? 'donut' : 'bar' })
  };
  onChartTypeTemplateChange = () => {
    this.setState({ selectedChartTemplateType: this.state.selectedChartTemplateType === 'bar' ? 'donut' : 'bar' })
    // setTimeout(() => {
    //   this.setState({ isChartView: true, isChartRender: true })
    // }, 10);
  };
  onChartModeChange = () => {
    // if (value !== null) {
    //   const chartMode = value;
    //   this.setState({ selectedChartMode: chartMode })
    // if (chartMode.chartMode === 1) {
    //order
    // setTimeout(() => {
    this.getOrderCount4Chart(this.state.fromdate, this.state.todate, this.state.viewChart);
    // }, 10);
    // } else {
    //template
    // setTimeout(() => {
    this.getsheetsCount4Chart(this.state.fromdate, this.state.todate, this.state.viewChart);
    // }, 10);
    //   }
    // }
  };

  onProtocolOrdertypeChange = (key, id, text, value) => {
    if (value !== undefined) {
      let orderProCreate = ControlRights(
        "IDS_MDL_ORDERS",
        value.name
      );

      this.setState({ createProOrder: orderProCreate.UserGroupRights.save });

      this.setState({
        AssigntProtocolfor: value.type,
        selectedprotocolorder: value,
        keyName: "",
      });

      if (parseInt(value.type) === 2) {
        // let dynamictest = {
        //   testcode: -2,
        //   testname: "Default",
        // };
        // this.state.lsttest.unshift(dynamictest);
        // this.setState({ SelectedTest: undefined });
        this.setState({ selectedtest: this.state.lsttest[0] });
        // if (this.state.lsttest[0].testcode === -2) {
        let dynamicprotocolitem = [
          {
            protocolmastercode: -2,
            protocolmastername: "Default Template",
          },
        ];
        this.state.lstProtocolName.unshift(dynamicprotocolitem[0])
        this.setState({
          // lstProtocolName: dynamicprotocolitem,
          Protocolcode: dynamicprotocolitem[0].protocolmastercode,
          selectedprotocolname: dynamicprotocolitem[0],
        });
        // }
      } else {
        // let elntest = this.state.lsttest.filter((item) => item.testcode !== -2);
        let lstProtocolName1 = this.state.lstProtocolName.filter((item) => item.protocolmastercode !== -2);
        this.setState({ lstProtocolName: lstProtocolName1 });
        // if (this.state.selectedtest.testcode === -2) {
        this.setState({ selectedprotocolname: lstProtocolName1[0] });
        // }
      }
    }
  };
  onTestChange = (key, id, text, value) => {
    this.setState({ selectedtest: value });
    // if (this.state.Orderfor === 2 && value.testcode === -2) {
    //   let dynamicprotocolitem = [
    //     {
    //       protocolmastercode: -2,
    //       protocolmastername: "Default Template",
    //     },
    //   ];
    //   this.setState({
    //     lstProtocolName: dynamicprotocolitem,
    //     Protocolcode: dynamicprotocolitem[0].protocolmastercode,
    //     selectedprotocolname: dynamicprotocolitem[0],
    //   });
    // } else {
    this.getfileontest(value);
    // }
  };

  onSheetChange = (key, id, text, value) => {
    value.ismultitenant = isMultitenant;
    this.setState({
      ServiceToUrl: "" + this.ELNurl + "/File/getfileoncode",
      ServiceHeaderobject: value,
      ServiceMethodType: "POST",
      ServcieonSuccess: this.onGetfileSuccess.bind(this),
      ServcieonFailure: this.onGetfileFailure.bind(this),
      ServiceTenant: undefined,
    });
  };
  onGetfileSuccess(responce) {
    this.setState({ selectedsheet: responce });
  }
  onGetfileFailure(res) { }

  onvalSheetChange = (key, id, text, value) => {
    this.setState({ selectedvalsheet: value });
    value.versionno = 0;
    value.ismultitenant = isMultitenant;

    this.setState({
      ServiceToUrl: "" + this.ELNurl + "/File/GetfileverContent",
      ServiceHeaderobject: value,
      ServiceMethodType: "POST",
      ServcieonSuccess: (reponse) => {
        let sheetcontant = this.state.selectedvalsheet;
        sheetcontant.filecontent = JSON.stringify(reponse);
        this.setState({ selectedvalsheet: sheetcontant, isregpopoveron: true });
      },
      ServcieonFailure: this.onErrorRegisterorder.bind(this),
      ServiceTenant: undefined,
      isregpopoveron: false,
      Ispiechartrender: false,
      Islinechartrender: false,
    });
  };

  onProjectChange = (key, id, text, value) => {
    this.setState({ selectedproject: value, isMoveParent: 1 });
    if (value === undefined && this.state.selectedsample !== undefined) {
      this.setState({ isMoveParent: 2 });
    } else if (value === undefined) {
      this.setState({ isMoveParent: 4 });
    }
  };

  onSheetOrderSampleChange = (key, id, text, value) => {
    this.setState({ selectedsample: value });
    if (value !== undefined) {
      this.setState({ isMoveParent: 2 });
    } else if (this.state.selectedproject !== undefined) {
      this.setState({ isMoveParent: 1 });
    } else {
      this.setState({ isMoveParent: 4 });
    }
  }

  onWorkflowChange = (key, id, text, value) => {
    this.setState({ selectedworkflow: value });

    if (value.usercode === -2) {
      let passObjDet = store.getState().Loggeduser;
      Servicecalls(
        "" + this.ELNurl + "/User/GetUsers",
        passObjDet,
        this.onGetUserUpdateSuccess.bind(this),
        this.onGetUserUpdateFaliure.bind(this)
      );
    } else {
      this.setState({
        sitebasedusers: [],
        sitebaseduserscode: {},
        noworkflow: false,
      });
      // this.getdirectory()
    }
  };

  onOrderKeywordEnter(Value) {
    this.setState({
      OrderKey: Value,
    });
  }

  onGetUserUpdateSuccess(responce) {
    if (responce !== undefined) {
      responce = responce.filter((item) => item.userstatus === this.props.t("Setup.Usermaster.IDS_LBL_ACTIVE"));
      this.setState({
        sitebasedusers: responce,
        sitebaseduserscode: responce[0],
        noworkflow: true,
      });
      // this.getdirectory(true, responce[0])
    }
  }
  onGetUserUpdateFaliure(res) { }

  ProjectsiteUserchange = (key, id, text, user) => {
    if (user !== null && user !== undefined && user.usercode !== undefined) {
      this.setState({ sitebaseduserscode: user });
      // this.getdirectory(true, user)
    } else {
      this.setState({ sitebaseduserscode: null });
      // this.getdirectory()
    }
  };

  onInventoryChange = (key, id, text, value) => {
    this.setState({ selectedinventory: value });

    let repositoryitem = {
      repositorycode: value.repositorycode,
      sitecode: $.session.get("Usersite"),
    };
    this.setState({
      ServiceToUrl: "" + this.ELNurl + "/Master/Getallrepositoriesdata",
      ServiceHeaderobject: repositoryitem,
      ServiceMethodType: "POST",
      ServcieonSuccess: this.onGetRepoSuccess.bind(this),
      ServcieonFailure: this.onGetRepoFailure.bind(this),
      ServiceTenant: undefined,
    });
  };

  onMaterialChange = (k, i, t, value) => {
    if (value !== null) {
      const lstMaterialInventory = this.state.lstMasterMaterialInventory.filter((x) => {
        return x.nmaterialcode === value.nmaterialcode
      })
      this.setState({
        selectedMaterial: value,
        lstMaterialInventory: lstMaterialInventory,
        selectedMaterialInventory: lstMaterialInventory[0],
      });
    }
  }

  onMaterialInventoryChange = (k, i, t, value) => {
    if (value !== null) {
      this.setState({
        selectedMaterialInventory: value,
      });
    }
  }

  onInventoryDataChange = (key, id, text, value) => {
    this.setState({ selectedinventorydata: value });
  };

  onGetRepoSuccess(res) {

    this.setState({
      lstinventorydata: res,
      selectedinventorydata: res[0],
    });

  }

  onGetRepoFailure(response) { }

  onProtocolNameChange = (key, id, text, value) => {
    this.setState({ selectedprotocolname: value });
  };

  getfileontest(value) {
    if (value !== undefined && value !== null && value.testcode !== undefined) {
      this.setState({
        selectedtest: value,
      });

      if (this.state.Orderfor === 1) {
        let passObjDet = {
          testcode: value.testcode,
          testtype: 1,
          objLoggeduser:
            store.getState().Loggeduser !== undefined &&
              store.getState().Loggeduser !== null &&
              Object.keys(store.getState().Loggeduser).length > 0
              ? store.getState().Loggeduser
              : {
                usercode: $.session.get("User"),
                username: $.session.get("Username"),
              },
          ismultitenant: isMultitenant,
          lssitemaster: {
            sitecode: sessionStorage.Usersite,
            sitename: sessionStorage.Usersitename,
          }
        };

        Servicecalls(
          "" + this.ELNurl + "/File/GetfilesOnTestcode",
          passObjDet,
          (response) => {
            //** This for no sheet (Research Activity order) */
            if (this.state.selectedorder.type === 3) {
              let noSheet = {
                filecode: 1,
                filenameuser: "Default Template",
              };
              response.unshift(noSheet);
            }
            let selectedsheet =
              response !== undefined && response !== null && response.length > 0 ? response[0] : undefined;
            if (response.length === 0) {
              this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_NOSHEET"));
            } else if (response.length !== 1) {
              response.unshift({})
              selectedsheet = undefined
            }


            this.setState({ lstsheet: response, selectedsheet: selectedsheet });
          },
          this.onGetELNfileontestFailure.bind(this)
        );
      } else {
        let passobj = {
          testcode: value.testcode,
          testtype: 1,
          objLoggeduser: store.getState().Loggeduser,
          sitecode: sessionStorage.Usersite,
        };
        Servicecalls(
          "" + this.ELNurl + "/protocol/getProtocolOnTestcode",
          passobj,
          this.onGetProtocolInitialSuccess.bind(this),
          this.onGetTestFaliure.bind(this)
        );
      }
    }
  }

  onGetELNfileontestFailure(response) { }

  toggle = (e) => {
    document.body.classList.add('overflow');
    this.setState({
      isregpopoveron: !this.state.isregpopoveron,
      Ispiechartrender: false,
      Islinechartrender: false,
      issheetpopoveron: false, isChartRender: false
    });
  };

  togglesheet = (e) => {

    // if (isMultitenant === 2) {
    //   let url = "";
    //   if (this.state.Templatefor === 1) {
    //     url = "" + this.ELNurl + "/File/Validatesheetcountforfreeuser";
    //   }
    //   else {
    //     url = "" + this.ELNurl + "/protocol/Validateprotocolcountforfreeuser";
    //   }
    //   Servicecalls(url, { sitecode: sessionStorage.getItem("Usersite") }, (res) => {
    //     if (!res) {
    //       this.setState({
    //         issheetpopoveron: !this.state.issheetpopoveron,
    //         isregpopoveron: false,
    //         Sheetname: "",
    //         protocolname: "",
    //         isChartRender: false

    //       });
    //     }
    //     else {
    //       this.setState({
    //         isupgradeopen: true,
    //         isChartRender: false
    //       });
    //     }
    //   }, (res) => { });
    // }
    // else {

    this.setState({
      issheetpopoveron: !this.state.issheetpopoveron,
      isregpopoveron: false,
      Sheetname: "",
      protocolname: "", isChartRender: false

    });
    // }
  };

  handleContextMenuView = (event) => { };
  handleTreeItemClick = (event) => {
    const newSelectedItem = searchTreeItem(this.state.Orderfor === 1 ?
      this.state.stateCDFData
      : this.state.stateCDFData1, event.item);
    newSelectedItem.expanded =
      event.item.expanded !== undefined ? !event.item.expanded : true;
    this.setState({ selectedTreeItem_Addnewfolder: newSelectedItem }, () => {
      if (this.state.Orderfor === 1) {
        let stateCDFData = getFolderTree(
          this.state.stateCDFData,
          this.state.selectedTreeItem_Addnewfolder
        )
        this.setState({ stateCDFData })
      } else {
        let stateCDFData1 = getFolderTree(
          this.state.stateCDFData1,
          this.state.selectedTreeItem_Addnewfolder
        )
        this.setState({ stateCDFData1 })
      }
    });

  }
  onshowtosite = (event) => {

    if (this.state.selectedTreeItem !== undefined && this.state.selectedTreeItem.viewoption === 3 && (parseInt(event.target.value) !== 3 || parseInt(event.target.value) !== 2)) {
      this.props.alert.error(this.props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWSITEVAL", { showitem: "to Team", }))
    } else if (this.state.selectedTreeItem !== undefined && this.state.selectedTreeItem.viewoption === 2 && (parseInt(event.target.value) !== 2 || parseInt(event.target.value) !== 3)) {
      this.props.alert.error(this.props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWOPTION", { showitem: "to me", }))
    } else {
      // setSelectuserteam(undefined);
      if (parseInt(event.target.value) === 3) {
        let usermasterobj = JSON.parse(sessionStorage.teamusercode);
        if (usermasterobj.length > 0) {
          this.setState({ isshowtosite: parseInt(event.target.value) })
        } else {
          this.props.alert.error(this.props.t("Orders.Sheetorders.IDS_LBL_NOTMAPPEDPROJECTTEAM", { showitem: "to me", }))
        };
      } else {
        this.setState({ isshowtosite: parseInt(event.target.value) })
      }
    }
  }



  onsaveonsample = (event) => {
    this.setState({ isMoveParent: parseInt(event.target.value) })
  };

  onselectfolder = (event) => {
    this.setState({ isMoveParent: parseInt(event.target.value), selectedTreeItem: event })
    // setSelectedTreeItem(event);
    // setIsMoveParent(parseInt(event.target.value));
  };
  onregorderclose = (e) => {

    if (this.state.selectedworkflow !== undefined && this.state.selectedworkflow.usercode === -2) {
      this.getdirectory()
    }
    this.setState({
      isregpopoveron: false,
      Ispiechartrender: false,
      Islinechartrender: false,
      selectedsample: undefined,
      selectedinventorydata: null,
      lstinventorydata: [],
      selectedinventory: undefined,
      OrderKey: false,
      keyName: false,
      //newly added
      selectedorder: "",
      selectedsheet: null,
      selectedtest: "",
      lstsheet: [],
      selectedproject: undefined,
      isshowtosite: 1,
      selectedTreeItem: undefined,
      isMoveParent: 4,
      selectedworkflow: this.state.lstworkflowuser[0],
      noworkflow: false,
      sitebaseduserscode: {},
    });
  };

  onsheetorderclose = (e) => {
    this.setState({
      issheetpopoveron: false,
      protocolcategory: undefined,
      sheetcategory: undefined
    });
  };

  // onRegisterorderclick = (e) => {

  //   if (
  //     this.state.selectedorder !== undefined &&
  //     this.state.selectedorder !== null
  //   ) {
  //     if (
  //       this.state.selectedorder.type === 2 &&
  //       this.state.selectedsheet !== undefined &&
  //       this.state.selectedsheet !== null &&
  //       // this.state.selectedproject !== undefined &&
  //       // this.state.selectedproject !== null &&
  //       this.state.selectedtest !== undefined &&
  //       this.state.selectedtest !== null &&
  //       this.state.selectedworkflow !== undefined &&
  //       this.state.selectedworkflow !== null
  //     ) {
  //       this.registerorder(
  //         this.state.selectedorder,
  //         this.state.selectedsheet,
  //         this.state.selectedproject,
  //         this.state.selectedtest,
  //         this.state.selectedworkflow,
  //         this.state.selectedsample,
  //         !isPremiumTenant ? this.state.selectedinventory : this.state.selectedMaterial,
  //         !isPremiumTenant ? this.state.selectedinventorydata : this.state.selectedMaterialInventory
  //       );
  //     } else if (
  //       this.state.selectedorder.type === 3 &&
  //       this.state.selectedsheet !== undefined &&
  //       this.state.selectedsheet !== null &&
  //       // this.state.selectedproject !== undefined &&
  //       // this.state.selectedproject !== null &&
  //       this.state.selectedtest !== undefined &&
  //       this.state.selectedtest !== null &&
  //       this.state.selectedworkflow !== undefined &&
  //       this.state.selectedworkflow !== null
  //     ) {
  //       this.registerorder(
  //         this.state.selectedorder,
  //         this.state.selectedsheet,
  //         this.state.selectedproject,
  //         this.state.selectedtest,
  //         this.state.selectedworkflow,
  //         this.state.selectedsample,
  //         !isPremiumTenant ? this.state.selectedinventory : this.state.selectedMaterial,
  //         !isPremiumTenant ? this.state.selectedinventorydata : this.state.selectedMaterialInventory
  //       );
  //     } else if (
  //       this.state.selectedorder.type === 4 &&
  //       // this.state.selectedproject !== undefined &&
  //       // this.state.selectedproject !== null &&
  //       this.state.selectedworkflow !== undefined &&
  //       this.state.selectedworkflow !== null
  //     ) {
  //       this.registerorder(
  //         this.state.selectedorder,
  //         this.state.selectedsheet,
  //         this.state.selectedproject,
  //         this.state.selectedtest,
  //         this.state.selectedworkflow,
  //         this.state.selectedsample,
  //         !isPremiumTenant ? this.state.selectedinventory : this.state.selectedMaterial,
  //         !isPremiumTenant ? this.state.selectedinventorydata : this.state.selectedMaterialInventory
  //       );
  //     } else if (
  //       this.state.selectedorder.type === 5 &&
  //       this.state.selectedvalsheet !== undefined &&
  //       this.state.selectedvalsheet !== null &&
  //       // this.state.selectedproject !== undefined &&
  //       // this.state.selectedproject !== null &&
  //       this.state.selectedworkflow !== undefined &&
  //       this.state.selectedworkflow !== null
  //     ) {
  //       this.registerorder(
  //         this.state.selectedorder,
  //         this.state.selectedvalsheet,
  //         this.state.selectedproject,
  //         this.state.selectedtest,
  //         this.state.selectedworkflow,
  //         this.state.selectedsample
  //       );
  //     } else {
  //       this.props.alert.error(
  //         this.props.t("Dashboard.Sheetorders.IDS_MSG_SOMEOFTHEFIELDNOSELECTED")
  //       );
  //     }
  //   } else {
  //     this.props.alert.error(this.props.t("Dashboard.IDS_SELECTORDERTYPE"));
  //   }
  // };

  onRegisterorderclick = (response) => {
    let selectedorder = response.selectOrderData;
    let selectedtest = response.selectTestData;
    let selectedsheet = response.selectSheetData;
    let selectedproject = response.selectProjectData;
    let selectedsample = response.selectSampleData;
    let selectedrepository = response.selectRepoData;
    let selectedrepositorydata = response.selectRepodataData;
    // let selectedworkflow = response.selectWflowData;
    let selectedkeyword = response.selectOrderKey;
    let selectedfolder = response.selectFolderData;
    let selectassigneduser = response.selectassigneduser;
    let viewoption = response.viewoption;
    let selectedMaterial = response.selectMaterial;
    let selectedMaterialInventory = response.selectMaterialInventory;
    let duedate = response.duedate;
    let cautiondate = response.cautiondate;
    let period = response.period;
    let Repeat = response.Repeat;
    let Interval = response.Interval;
    let timespan = response.timespan;
    let autocreatedate = response.autocreatedate;
    let Autoregister_Count = response?.Autoregister_Count;
    let selectedprojectteam = response?.selectedprojectteam;
    let teamselected = response?.selectedprojectteam.length > 0 ? true : false;

    let lsautoregisterorderdetail = {
      repeat: Repeat,
      interval: Interval,
      timespan: timespan !== undefined ? timespan.name : "",
      screen: "Sheet_Order",
      autocreatedate: autocreatedate,
      ismultitenant: isMultitenant,
    };

    // let teamcode = response.projectteamcode !== undefined ? response.projectteamcode.teamcode : undefined

    let contentparsed =
      selectedsheet !== undefined &&
        selectedsheet.filecontent === undefined &&
        selectedsheet.filecontent !== null
        ? extractValuefromsheet(selectedsheet.filecontent)
        : extractValuefromsheet(sheetDefaultContent);

    if (parseInt(selectedorder.type) === 4) {
      selectedsheet = { filecode: 1, filecontent: sheetDefaultContent }
    }
    let sequence = getsequenceoncode(1);
    let passObjDet = {
      testcode: selectedtest !== undefined && selectedtest !== null ? selectedtest.testcode : null,
      testname: selectedtest !== undefined && selectedtest !== null ? selectedtest.testname : null,
      lstestmasterlocal: selectedtest !== undefined && selectedtest !== null && Object.keys(selectedtest).length > 0 ? selectedtest : null,
      lsfile: selectedsheet,
      sheetversionno: selectedsheet?.versionno || 1,
      lssamplefile: {
        filecontent: selectedsheet !== undefined ? selectedsheet.filecontent : sheetDefaultContent,
        contentvalues: contentparsed.contentvalues,
        contentparameter: contentparsed.contentparameter,
        createdate: GetutcDate(new Date()),
        createbyuser: store.getState().Loggeduser,
        processed: 0,
        versionno: 1,
        lssamplefileversion: [
          {
            filecontent:
              selectedsheet !== undefined
                ? selectedsheet.filecontent
                : sheetDefaultContent,
            createdate: GetutcDate(new Date()),
            createbyuser: store.getState().Loggeduser,
            versionno: 1,
            versionname: "version_1",
          },
        ],
      },
      filetype: parseInt(selectedorder.type),
      lsuserMaster: store.getState().Loggeduser,
      lsprojectmaster: selectedproject,
      assignedto: selectassigneduser,
      lssamplemaster:
        selectedsample !== undefined && selectedsample !== null
          ? selectedsample
          : null,
      objLoggeduser: store.getState().Loggeduser,
      //  objsilentaudit: silentaudit,
      objmanualaudit: Manualauditobject("insert", "Sheet Orders"),
      ismultitenant: isMultitenant,
      createdtimestamp: GetutcDate(new Date()),
      lsrepositories: !isPremiumTenant ? selectedrepository : null,
      lsrepositoriesdata: !isPremiumTenant ? selectedrepositorydata : null,
      elnmaterial: isPremiumTenant ? selectedMaterial?.matcode ? { nmaterialcode: selectedMaterial.matcode } : null : null,
      elnmaterialinventory: isPremiumTenant ? selectedMaterialInventory : null,
      keyword: selectedkeyword,
      tittle: response.selectOrdertittle,
      directorycode: selectedfolder === undefined || selectedfolder === null ? null : selectedfolder.directorycode,
      orderdisplaytype: response.orderdisplaytype,
      viewoption: selectedproject !== undefined && selectedproject !== null ? 1 : viewoption,
      notificationdate: convertUTCDateToLocalDate(new Date()),
      lstworkflow: workflow,
      duedate: GetutcDate(duedate),
      cautiondate: GetutcDate(cautiondate),
      period: period !== undefined ? period.name : "",
      repeat: Repeat,
      lsselectedTeam: selectedprojectteam,
      teamselected: teamselected,
      sequenceid: sequence && formsequenceformatview(JSON.parse(sequence.sqf), sequence.sep, "g", {
        projectname: selectedproject && selectedproject.projectname ? selectedproject.projectname : "",
        projectcode: selectedproject && selectedproject.projectid ? selectedproject.projectid : "",
        task: selectedtest && selectedtest.testname ? selectedtest.testname : "",
        ordertype: getordertype(parseInt(selectedorder.type))
      })
    };

    if (Repeat) {
      passObjDet.autoregistercount = Autoregister_Count;
    }
    passObjDet.lsautoregisterorderdetail = Repeat
      ? lsautoregisterorderdetail
      : null;

    // passObjDet.lsActiveWidgets = {
    //   screenname: "Sheet_Order",
    //   activityType: "Insert",
    //   userId: sessionStorage.User,
    // }
    passObjDet.keyword = selectedkeyword;
    passObjDet.sitecode = sessionStorage.Usersite;
    // if (viewoption === 3) {
    //   passObjDet.teamcode = teamcode
    // }

    let objsilentaudit;
    // let ordersuccess = false;
    // if (response.selectWflowData !== undefined) {
    //   ordersuccess = true;
    // }
    let Audit = AuditTrailValidation("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS", "IDS_TSK_REGISTER");
    passObjDet.sitecode = sessionStorage.Usersite;
    passObjDet.isDefault = orderdefaultcheck();

    if (Audit) {
      passObjDet.objmanualaudit = Manualauditobject(
        "registered",
        "Sheet Orders"
      );

      $("#DashboardModel").modal("show");

      this.setState({
        AuditUrl: "" + this.ELNurl + "/Instrument/InsertELNOrder",
        AuditObject: passObjDet,
        AuditPassfunction: this.onSuccessRegisterorder.bind(this),
        AuditFailfunction: this.onErrorRegisterorder.bind(this),
        isregpopoveron: false,
        Activewidgets_Pulldata: true
      });
    } else {

      this.setState({
        isregpopoveron: false,
        Activewidgets_Pulldata: true
      });

      let passObjDetAudit = { objsilentaudit: objsilentaudit };
      Servicecalls(
        "" + this.ELNurl + "/Instrument/InsertELNOrder",
        passObjDet,
        this.onSuccessRegisterorder.bind(this),
        this.onErrorRegisterorder.bind(this),

        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDetAudit,
        this.onAuditValidateError.bind(this),
        this.onAuditValidateFailure.bind(this)
      );
    }

  };

  Onresetwidgetsdata = (values) => {
    this.setState({ Activewidgets_Pulldata: values });
  }


  handleorderforChange = (e) => {
    if (this.state.selectedChartMode.chartMode === 1) {
      this.setState({
        viewChart: parseInt(e.target.value), isChartRender: true
      })
    }

    localStorage.setItem("dashorderselect", e.target.value);

    this.setState({
      Orderfor: parseInt(e.target.value),
      // Orderselectionontype: 1, 
      Loadershow: true, orderlist: [],
      selectedtest: this.state.lsttest !== undefined && this.state.lsttest !== null && this.state.lsttest.length > 0 ? this.state.lsttest[0] : undefined,
      selectedworkflow:
        this.state.lstworkflowuser !== undefined && this.state.lstworkflowuser !== null && this.state.lstworkflowuser.length > 0 ? this.state.lstworkflowuser[0] : undefined,
      noworkflow: false, sitebaseduserscode: {}, isMoveParent: 4,
      isshowtosite: 1, selectedTreeItem: undefined, initpagenofororder: 0, isChartRender: true
    }, () => {
      this.getorders(this.state.fromdate, this.state.todate, this.state.initpagenofororder, true);
      this.getordercount(this.state.fromdate, this.state.todate);
    });
  };


  itemRender = (props) => {
    return <em onClick={(e) => e.stopPropagation()}><CheckBox
      onChange={this.handlecolumnselectchange}
      checked={props?.item?.Isshow ? true : false}
      disabled={props?.item?.Desabled && "disabled"}
      value={props.item?.header}>
    </CheckBox>{" " + props.item?.header}</em>;
  };

  Itemrender_Ordersscreen = (props) => {
    return <em onClick={(e) => e.stopPropagation()}><CheckBox
      onChange={this.Onchangecheckbox_Customcolumn}
      checked={props?.item?.Isshow ? true : false}
      disabled={(this.state.Orderselectionontype === 2 && props.item?.datatype === "completedtimestamp") || (this.state.Orderselectionontype === 5 && props.item?.datatype === "completedtimestamp") ? "" : (props.item?.datatype === "completedtimestamp" || props?.item?.Desabled) ? "disabled" : ""}
      value={props.item?.header}>
    </CheckBox>{" " + props.item?.header}</em>;
  };

  Itemrender_Dashboardview = (props) => {
    return <em
    // onClick={(e) => { this.onDashboardselect(props) }}
    >
      <Label> {props.item?.viewname}</Label>
    </em>
  };

  onDashboardselect = (data) => {
    this.setState({ selecteddashview: data.item });
    localStorage.setItem("dashview", data.item.viewcode)
  }

  Onchangecheckbox_Customcolumn = (event) => {
    let Custom_Column = [];

    if (this.state.Orderfor === 1) {
      if ((this.state.Sheetorders_Customcolumn.filter(items => items.Isshow).length < 6 && event.target.checked) || (!event.target.checked)) {
        Custom_Column = this.state.Sheetorders_Customcolumn.map((items) => {
          if (items?.header === event.target.value) {
            items.Isshow = event.target.checked
          }
          return items
        });
        this.setState({ Sheetorders_Customcolumn: Custom_Column, isChartRender: false, gridRefresh: true })

      } else {
        this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_CUSTOMCOLUMN"));
      }

    } else {
      if ((this.state.Protocolorder_Customcolumn.filter(items => items.Isshow).length < 6 && event.target.checked) || (!event.target.checked)) {
        Custom_Column = this.state.Protocolorder_Customcolumn.map((items) => {
          if (items?.header === event.target.value) {
            items.Isshow = event.target.checked
          }
          return items
        });
        this.setState({ Protocolorder_Customcolumn: Custom_Column, isChartRender: false, gridRefresh: true })
      } else {
        this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_CUSTOMCOLUMN"));
      }
    }
    if (Custom_Column.length > 0) {
      const currentLocalStorageKey = this.state.Orderfor === 1 ? "Sheetorders_Customcolumn" : "Protocolorder_Customcolumn";
      const localStorageData = JSON.parse(localStorage.getItem('Dashboard_Customcolumn')) || {};
      const updatedLocalStorageData = {
        ...localStorageData,
        [currentLocalStorageKey]: Custom_Column.filter(items => items.Isshow).map(items => items.datatype)
      };
      localStorage.setItem('Dashboard_Customcolumn', JSON.stringify(updatedLocalStorageData));
    }
  }

  handlecolumnselectchange = (event) => {
    let Custom_Column = [];
    if (this.state.Templatefor === 1) {
      if ((this.state.Sheettemplate_Customcolumn.filter(items => items.Isshow).length < 6 && event.target.checked) || (!event.target.checked)) {
        Custom_Column = this.state.Sheettemplate_Customcolumn.map((items) => {
          if (items?.header === event.target.value) {
            items.Isshow = event.target.checked
          }
          return items
        });
        this.setState({ Sheettemplate_Customcolumn: Custom_Column, isChartRender: false, gridRefresh: true })
      } else {
        this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_CUSTOMCOLUMN"));
      }
    } else {
      if ((this.state.Protocoltemplate_Customcolumn.filter(items => items.Isshow).length < 6 && event.target.checked) || (!event.target.checked)) {
        Custom_Column = this.state.Protocoltemplate_Customcolumn.map((items) => {
          if (items?.header === event.target.value) {
            items.Isshow = event.target.checked
          }
          return items
        });
        this.setState({ Protocoltemplate_Customcolumn: Custom_Column, isChartRender: false, gridRefresh: true })
      } else {
        this.props.alert.error(this.props.t("Dashboard.Sheetorders.IDS_MSG_CUSTOMCOLUMN"));
      }
    }
    if (Custom_Column.length > 0) {
      const currentLocalStorageKey = this.state.Templatefor === 1 ? "Sheettemplate_Customcolumn" : "Protocoltemplate_Customcolumn";
      const localStorageData = JSON.parse(localStorage.getItem('Dashboard_Customcolumn')) || {};
      const updatedLocalStorageData = {
        ...localStorageData,
        [currentLocalStorageKey]: Custom_Column.filter(items => items.Isshow).map(items => items.datatype)
      };
      localStorage.setItem('Dashboard_Customcolumn', JSON.stringify(updatedLocalStorageData));
    }
  }

  handletemplateforChange = (e) => {
    const type = parseInt(e.target.value);
    localStorage.setItem("dashtempselect", e.target.value);
    this.setState({ Templatefor: type, viewoptiontemplate: 1, viewChart: type, isChartRender: true, initpagenofortemplate: 0, Loadershowsheet: true, sheetlist: [] }, () => {
      this.getsheets(this.state.fromdate, this.state.todate, this.state.initpagenofortemplate, true);
      this.getsheetsCount4Chart(this.state.fromdate, this.state.todate, type);
    });
  };

  handleinventorychange = (value) => {
    if (value !== null) {
      let column = this.state.Columns;
      column.length = 4;

      this.setState({
        SelectedInventory: value.repositorycode,
        SelectedRepository: value,
        lstCustomFields: [],
        repositorycode: value.repositorycode,
        defaultCustomField: [],
        Columns: column,
      });

      let passObjDet = { repositorycode: value.repositorycode };

      Servicecalls(
        "" + this.ELNurl + "/Master/getrepositoryfields",
        passObjDet,
        this.onFieldGetSuccess.bind(this),
        this.onFieldGetFaliure.bind(this)
      );

      let objsilentaudit = onAuditHandler(
        "view",
        "DashBoard",
        this.props.t("Dashboard.IDS_REQUESTOCHANGEINVNT", {
          user: $.session.get("Username"),
        })
      );
      objsilentaudit = onAuditHandler(
        "view",
        "DashBoard",
        this.props.t("Dashboard.IDS_REQUESTTOREPOSITORYFIELD", {
          user: $.session.get("Username"),
        })
      );
      if (objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    }
  };

  // handleinventorychange = (e) => {
  //   let column = this.state.Columns;
  //   column.length = 4;

  //   this.setState({
  //     SelectedInventory: parseInt(e.target.value),
  //     lstCustomFields: [],
  //     repositorycode: parseInt(e.target.value),
  //     defaultCustomField: [],
  //     Columns: column,
  //   });

  //   let passObjDet = { repositorycode: parseInt(e.target.value) };

  //   Servicecalls(
  //     "" + this.ELNurl + "/Master/getrepositoryfields",
  //     passObjDet,
  //     this.onFieldGetSuccess.bind(this),
  //     this.onFieldGetFaliure.bind(this)
  //   );
  onFieldGetSuccess(res) {
    if (res !== undefined) {
      this.setState({
        repositorydata: res.inventoryMaster,
        customFields: res.inventoryMaster.lstFields,
      });

      this.onFieldviewer();

      let formatedresponse = res.repositoryData.map((obj) => {
        return this.formatobject(obj);
      });
      formatedresponse.map((item) => {
        item.Inventoryid =
          res.inventoryMaster.repositoryname.toUpperCase() +
          item.repositorydatacode;
        item.Addedonview = setDateAsuserDefined(
          item.Addedon,
          $.session.get("userDefinedDate")
        );
        return item;
      });
      this.setState({ repositoryitem: formatedresponse });
    }
  }

  onFieldGetFaliure(res) { }

  formatobject(object) {
    let modifiedobj = {};
    modifiedobj.repositorydatacode = object.repositorydatacode;
    modifiedobj.repositorycode = object.repositorycode;

    let repositroyfields = JSON.parse(object.repositorydatafields);
    let staticfields = repositroyfields.staticfields;
    let dynamicfields = repositroyfields.dynamicfields;

    if (
      this.state.repositorydata.isonexpireddatefield !== "" &&
      this.state.repositorydata.isexpiredate
    ) {
      let todaydate = new Date();
      todaydate = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date());
      let exdate = "";
      let datevalues = "";
      exdate = dynamicfields.filter(
        (items) =>
          this.state.repositorydata.isonexpireddatefield === items.fieldkey
      );
      if (
        exdate[0] !== undefined &&
        exdate[0] !== null &&
        exdate[0].datatypevalue === "Date"
      ) {
        exdate = new Date(exdate[0].valueOf);
        datevalues = new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(exdate);
        if (todaydate >= datevalues) {
        } else {
          let myFutureDate = new Date();

          let Difference_In_Time = exdate - myFutureDate;
          let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

          if (Math.round(Difference_In_Days) <= 2) {

            object.expireddatecount = Math.round(Difference_In_Days);
            // this.state.notificationdata.push(object)
          }
        }
      }
    }

    if (staticfields.length !== 0 && dynamicfields.length !== 0) {
      staticfields.map((obj) => {
        modifiedobj[
          obj.fieldkey !== undefined
            ? obj.fieldkey
            : obj.fieldname.replace(/ /g, "")
        ] = obj.value;
        return obj;
      });
      dynamicfields.map((obj) => {
        if (obj.datatype !== undefined && obj.datatype.toString() === "2") {
          modifiedobj[
            obj.fieldkey !== undefined
              ? obj.fieldkey
              : obj.fieldname.replace(/ /g, "")
          ] = replacedotwithdecimal(obj.value);
        } else {
          modifiedobj[
            obj.fieldkey !== undefined
              ? obj.fieldkey
              : obj.fieldname.replace(/ /g, "")
          ] = obj.value;
        }
        return obj;
      });
    }

    return modifiedobj;
  }


  handleOrderClick = (orderType, auditRequest) => {
    let total = parseInt(this.state.Completedorders) + parseInt(this.state.PendingOrders)
      + parseInt(this.state.rejectedOrder) + parseInt(this.state.canceledOrder);
    localStorage.setItem("dashorderselecttype", orderType);
    this.setState({
      Orderselectionontype: orderType,
      isChartRender: false,
      initpagenofororder: 0,
      isformatorder: 1,
      Loadershow: true,
      orderlist: [],
      totalordercountforsheetordergrid: orderType === 1 ? total : orderType === 3 ? parseInt(this.state.PendingOrders) : orderType === 2 ? parseInt(this.state.Completedorders) : orderType === 5 ? parseInt(this.state.rejectedOrder) : orderType === 6 ? parseInt(this.state.canceledOrder) : 0,
    }, () => {
      let isOrderGet = false;
      const orderCounts = {
        1: parseInt(this.state.Completedorders) + parseInt(this.state.PendingOrders) +
          parseInt(this.state.rejectedOrder) + parseInt(this.state.canceledOrder),
        2: parseInt(this.state.Completedorders),
        3: parseInt(this.state.PendingOrders),
        5: parseInt(this.state.rejectedOrder),
        6: parseInt(this.state.canceledOrder)
      };
      if (orderCounts[orderType] > 0) {
        isOrderGet = true;
      }
      if (isOrderGet) {
        this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, false, false);
      } else {
        this.setState({ Loadershow: false })
      }
    });

    // let objsilentaudit = onAuditHandler(
    //   "view",
    //   "DashBoard",
    //   this.props.t(auditRequest, {
    //     user: $.session.get("Username"),
    //   })
    // );
    //audit comments.
    // if (objsilentaudit !== null) {
    //   let passObjDet = { objsilentaudit: objsilentaudit };

    //   Servicecalls(
    //     "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
    //     passObjDet,
    //     this.onAuditValidateError.bind(this),
    //     this.onAuditValidateFailure.bind(this)
    //   );

    // }
  };

  onTotalordersclick = (e) => {
    setTimeout(() => {
      this.handleOrderClick(1, "Dashboard.IDS_AUDIT_REQUESTOLOADLOADTOTALORSERS");
    }, 1000);
  };

  onCompleteordersclick = (e) => {
    this.handleOrderClick(2, "Dashboard.IDS_AUDIT_REQUESTOLOADLOADCMPORSERS");
  };

  onPendingordersclick = (e) => {
    this.handleOrderClick(3, "Dashboard.IDS_AUDIT_REQUESTOLOADLOADPENORSERS");
  };

  onRejectedordersclick = (e) => {
    this.handleOrderClick(5, "Dashboard.IDS_AUDIT_REQUESTOLOADLOADPENORSERS");
  };

  onCanceledordersclick = (e) => {
    this.handleOrderClick(6, "Dashboard.IDS_AUDIT_REQUESTOLOADLOADPENORSERS");
  };


  // onTotalordersclick = (e) => {
  //   this.setState({
  //     Orderselectionontype: 1, isChartRender: false, initpagenofororder: 0, isformatorder: 0
  //   }, () => {
  //     this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, false, false);
  //   });
  //   let objsilentaudit = onAuditHandler(
  //     "view",
  //     "DashBoard",
  //     this.props.t("Dashboard.IDS_AUDIT_REQUESTOLOADLOADTOTALORSERS", {
  //       user: $.session.get("Username"),
  //     })
  //   );

  //   if (objsilentaudit !== null) {
  //     let passObjDet = { objsilentaudit: objsilentaudit };

  //     Servicecalls(
  //       "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
  //       passObjDet,
  //       this.onAuditValidateError.bind(this),
  //       this.onAuditValidateFailure.bind(this)
  //     );
  //   }
  // };

  // onCompleteordersclick = (e) => {
  //   this.setState({
  //     Orderselectionontype: 2, isChartRender: false, initpagenofororder: 0, isformatorder: 0, isChartRender: false
  //   }, () => {
  //     this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, false, false);
  //   });

  //   let objsilentaudit = onAuditHandler(
  //     "view",
  //     "DashBoard",
  //     this.props.t("Dashboard.IDS_AUDIT_REQUESTOLOADLOADCMPORSERS", {
  //       user: $.session.get("Username"),
  //     })
  //   );

  //   if (objsilentaudit !== null) {
  //     let passObjDet = { objsilentaudit: objsilentaudit };

  //     Servicecalls(
  //       "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
  //       passObjDet,
  //       this.onAuditValidateError.bind(this),
  //       this.onAuditValidateFailure.bind(this)
  //     );
  //   }
  // };

  // onPendingordersclick = (e) => {
  //   this.setState({
  //     Orderselectionontype: 3, isChartRender: false, initpagenofororder: 0, isformatorder: 0, isChartRender: false
  //   }, () => {
  //     this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, false, false);
  //   });
  //   let objsilentaudit = onAuditHandler(
  //     "view",
  //     "DashBoard",
  //     this.props.t("Dashboard.IDS_AUDIT_REQUESTOLOADLOADPENORSERS", {
  //       user: $.session.get("Username"),
  //     })
  //   );

  //   if (objsilentaudit !== null) {
  //     let passObjDet = { objsilentaudit: objsilentaudit };
  //     Servicecalls(
  //       "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
  //       passObjDet,
  //       this.onAuditValidateError.bind(this),
  //       this.onAuditValidateFailure.bind(this)
  //     );
  //   }
  // };

  // onRejectedordersclick = (e) => {
  //   this.setState({
  //     Orderselectionontype: 5, isChartRender: false, initpagenofororder: 0, isformatorder: 0, isChartRender: false
  //   }, () => {
  //     this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, false, false);
  //   });
  //   let objsilentaudit = onAuditHandler(
  //     "view",
  //     "DashBoard",
  //     this.props.t("Dashboard.IDS_AUDIT_REQUESTOLOADLOADPENORSERS", {
  //       user: $.session.get("Username"),
  //     })
  //   );

  //   if (objsilentaudit !== null) {
  //     let passObjDet = { objsilentaudit: objsilentaudit };

  //     Servicecalls(
  //       "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
  //       passObjDet,
  //       this.onAuditValidateError.bind(this),
  //       this.onAuditValidateFailure.bind(this)
  //     );
  //   }
  // };

  // onCanceledordersclick = (e) => {
  //   this.setState({
  //     Orderselectionontype: 6, isChartRender: false, initpagenofororder: 0, isformatorder: 0, isChartRender: false
  //   }, () => {
  //     this.GetDashboarddetails("1", new Date(this.state.fromdate), this.state.todate, false);
  //   });
  //   let objsilentaudit = onAuditHandler(
  //     "view",
  //     "DashBoard",
  //     this.props.t("Dashboard.IDS_AUDIT_REQUESTOLOADLOADPENORSERS", {
  //       user: $.session.get("Username"),
  //     })
  //   );

  //   if (objsilentaudit !== null) {
  //     let passObjDet = { objsilentaudit: objsilentaudit };

  //     Servicecalls(
  //       "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
  //       passObjDet,
  //       this.onAuditValidateError.bind(this),
  //       this.onAuditValidateFailure.bind(this)
  //     );
  //   }
  // };

  // onInprogressordersclick = (e) => {
  //   this.setState({
  //     Orderselectionontype: 4,
  //   });
  //   const fromdate = this.state.fromdate;
  //   const fDate = new Date(fromdate);

  //   const tDate = this.state.todate;

  //   setTimeout(() => {
  //     this.GetDashboarddetails("1", fDate, tDate);
  //   }, 100);

  //   let objsilentaudit = onAuditHandler(
  //     "view",
  //     "DashBoard",
  //     this.props.t("Dashboard.IDS_REQUESTOLOADLOADINPORSERS", {
  //       user: $.session.get("Username"),
  //     })
  //   );

  //   if (objsilentaudit !== null) {
  //     let passObjDet = { objsilentaudit: objsilentaudit };

  //     Servicecalls(
  //       "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
  //       passObjDet,
  //       this.onAuditValidateError.bind(this),
  //       this.onAuditValidateFailure.bind(this)
  //     );
  //   }
  // };

  onFieldviewer() {
    if (
      this.state.customFields !== undefined &&
      this.state.customFields !== null
    ) {
      return this.state.customFields.map((data) => ({
        label: data.fieldname,
        value: data.fieldkey,
      }));
    }
  }

  onCloseCustomeFieldSelect() {
    if (
      this.state.lstCustomFields !== undefined &&
      this.state.lstCustomFields !== "" &&
      this.state.lstCustomFields.length > 0
    ) {
      let dynamicCustomFields = this.parseCustomFields(
        this.state.lstCustomFields
      );
      let columnarray = this.state.Columns;
      columnarray.length = 4;
      if (dynamicCustomFields.length !== 0) {
        for (let i = 0; i < dynamicCustomFields.length; i++) {
          let column = {
            header: dynamicCustomFields[i].fieldname,
            datatype:
              dynamicCustomFields[i].fieldkey !== undefined
                ? dynamicCustomFields[i].fieldkey
                : dynamicCustomFields[i].fieldname.replace(/ /g, ""),
            rowselector: false,
            visible: true,
            doFilter: true,
            resizable: false,
            className: "clsModulename",
            width: "200px",
          };
          columnarray.push(column);
        }
      }
      columnarray = [
        ...new Map(
          columnarray.map((item) => [JSON.stringify(item), item])
        ).values(),
      ];
      this.setState({ Columns: columnarray });
    }
  }

  onCloseCustomeFieldSelectField(lstCustomFields) {
    if (
      lstCustomFields !== undefined &&
      lstCustomFields !== "" &&
      lstCustomFields.length > 0
    ) {
      let dynamicCustomFields = this.parseCustomFields(lstCustomFields);
      let columnarray = this.state.Columns;
      columnarray.length = 4;
      if (dynamicCustomFields.length !== 0) {
        for (let i = 0; i < dynamicCustomFields.length; i++) {
          let column = {
            header: dynamicCustomFields[i].fieldname,
            datatype:
              dynamicCustomFields[i].fieldkey !== undefined
                ? dynamicCustomFields[i].fieldkey
                : dynamicCustomFields[i].fieldname.replace(/ /g, ""),
            rowselector: false,
            visible: true,
            doFilter: true,
            resizable: false,
            className: "clsModulename",
            width: "200px",
          };
          columnarray.push(column);
        }
      }
      columnarray = [
        ...new Map(
          columnarray.map((item) => [JSON.stringify(item), item])
        ).values(),
      ];
      this.setState({ Columns: columnarray });
    }
  }

  parseCustomFields(lstFields) {
    let customArray = [];

    let lstDynamicFields = this.state.customFields;

    for (let i = 0; i < lstFields.length; i++) {
      let filterCustomFields = lstDynamicFields.filter(
        (items) => items.fieldkey === lstFields[i]
      );

      if (filterCustomFields.length !== 0) {
        customArray.push(filterCustomFields[0]);
      }
    }

    return customArray;
  }

  onCustomFieldSelect(val) {
    let objsilentaudit = onAuditHandler(
      "view",
      "DashBoard",
      this.props.t("Dashboard.IDS_REQUESTTOCUSTOMFIELD", {
        user: $.session.get("Username"),
      })
    );

    if (objsilentaudit !== null) {
      let passObjDet = { objsilentaudit: objsilentaudit };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        this.onAuditValidateError.bind(this),
        this.onAuditValidateFailure.bind(this)
      );
    }

    let fields = [];

    fields = val.split(",");

    if (fields.length === 1 && fields[0] === "") {
      let columnarray = this.state.Columns;
      columnarray.length = 4;
      this.setState({ Columns: columnarray });
    } else {
      this.setState({ lstCustomFields: fields });

      if (fields.length > 0) {
        this.onCloseCustomeFieldSelectField(fields);
      }
    }
  }

  fromDateChange(val) {
    this.setState({
      inventFromDate: val,
    });

    if (this.state.repositorydata.repositorycode !== undefined) {
      let passObjDet = {
        repositorycode: this.state.repositorydata.repositorycode,
        fromdate: val,
        todate:
          this.state.inventToDate === undefined
            ? new Date()
            : this.state.inventToDate,
      };

      this.setState({ fromdate: val });

      Servicecalls(
        "" + this.ELNurl + "/Master/GetrepositoriesdataonFilter",
        passObjDet,
        this.onRepogetonFilterSuccess.bind(this),
        this.onRepogetonFilterFailure.bind(this)
      );
    }
  }

  toDateChange(val) {

    this.setState({ inventToDate: val });

    if (this.state.repositorydata.repositorycode !== undefined) {
      let passObjDet = {
        repositorycode: this.state.repositorydata.repositorycode,
        fromdate:
          this.state.inventFromDate === undefined
            ? new Date()
            : this.state.inventFromDate,
        todate: val,
      };

      this.setState({ fromdate: val });

      Servicecalls(
        "" + this.ELNurl + "/Master/GetrepositoriesdataonFilter",
        passObjDet,
        this.onRepogetonFilterSuccess.bind(this),
        this.onRepogetonFilterFailure.bind(this)
      );
    }
  }

  onRepogetonFilterSuccess(res) {
    let objsilentaudit = onAuditHandler(
      "view",
      "DashBoard",
      this.props.t("Dashboard.IDS_AUDIT_REQUESTINSTRUMENTDATE", {
        user: $.session.get("Username"),
      })
    );

    if (objsilentaudit !== null) {
      let passObjDet = { objsilentaudit: objsilentaudit };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        this.onAuditValidateError.bind(this),
        this.onAuditValidateFailure.bind(this)
      );
    }

    let formatedresponse = res.map((obj) => {
      return this.formatobject(obj);
    });

    let repositoryName = this.state.repositorydata.repositoryname;

    formatedresponse.map((item) => {
      item.Inventoryid = repositoryName.toUpperCase() + item.repositorydatacode;
      item.Addedonview = setDateAsuserDefined(
        item.Addedon,
        $.session.get("userDefinedDate")
      );
      return item;
    });

    this.setState({ repositoryitem: formatedresponse });
  }

  onRepogetonFilterFailure(res) {
  }



  Onenablenewfolder = (values) => {
    this.setState({ Addnewfolder_Onregister: values })
  }

  handleDialogClick = (event) => {
    if (event.type === "save") {
      this.setState({ Addnewfolder_Onregister: false })

      let newData = {
        usercode: $.session.get("User"),
        username: $.session.get("Username"),
        lssitemaster: { sitecode: $.session.get("Usersite") },
        lsuserMaster: {
          usercode: $.session.get("User"),
          username: $.session.get("Username"),
        },
        token: $.session.get("Token"),
        tenant: $.session.get("tenantid")
      };
      newData.directoryname = event.value.trim();
      newData.viewoption = event.folderplace;
      newData.sitemaster = { sitecode: sessionStorage.Usersite };
      newData.createdby = { usercode: sessionStorage.User };

      let Selected_Treeitems = this.state.selectedTreeItem_Addnewfolder;
      if (Selected_Treeitems) {
        if (Selected_Treeitems !== undefined && Selected_Treeitems.filefor === "DR") {
          let parts = Selected_Treeitems?.directorycode?.toString().split(".");
          if (parts?.length === 2) {
            newData.parentdircode = parts[0];
            newData.floatvalues = parts[1];
          } else {
            newData.parentdircode = Selected_Treeitems.directorycode;
          }

        } else if (Selected_Treeitems !== undefined && Selected_Treeitems.filefor === "HF") {
          newData.parentdircode = -1;
        }
        // else {
        //   newData.parentdircode = stateData[0].parentdircode;
        // }
      }
      // else {
      //   newData.parentdircode = stateData[0].parentdircode;
      // }

      if (Object.keys(event?.FOlder_Type).length > 0 && Object.keys(event?.Onselected_Foldertype).length > 0) {
        const folderTypeCode = event.FOlder_Type.code;
        const folderMapValues = folderTypeCode === 1
          ? event.Onselected_Foldertype.projectname
          : folderTypeCode === 2
            ? event.Onselected_Foldertype.testname
            : event.Onselected_Foldertype.smaterialname;

        newData.foldermapping = `${event.FOlder_Type.Folder_Type} - ${folderMapValues}`;
      } else if (Object.keys(event?.FOlder_Type).length > 0) {
        const folderTypeCode = event.FOlder_Type.code;
        if (folderTypeCode === 0) {
          newData.foldermapping = `${event.FOlder_Type.Folder_Type}`;
        }
      }
      let Insertdirectoru_Url = this.state.Orderfor === 1 ? "" + this.ELNurl + "/Instrument/Insertdirectory" : "" + this.ELNurl + "/Instrument/Insertdirectoryonprotocol"

      Servicecalls(
        Insertdirectoru_Url,
        newData,
        this.onfoldersuccess.bind(this, newData),
        () => { }
      );


    } if (event.type === "cancel add") {
      this.setState({ Addnewfolder_Onregister: false })
      const element = document.getElementById('Order_Registration');
      if (element) {
        element.style.position = '';
        element.style.zIndex = '';
      }
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "cancel",
          this.state.Orderfor === 1 ? "Sheet Orders" : "Protocol Orders",
          this.state.Orderfor === 1 ? this.props.t("Orders.Sheetorders.IDS_AUDIT_REQCANCELNEWFOLDER", {
            user: $.session.get("Username"),
          }) : this.props.t("Orders.Protocolorders.IDS_AUDIT_REQCANCELNEWFOLDER", {
            user: sessionStorage.Username,
          })
        ),
      };
      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        () => { },
        () => { },
      );
    }
  }


  onfoldersuccess = (event, response) => {
    let screen = this.state.Orderfor === 1 ? "Sheet" : "Protocol"
    let passObjDet = {};
    let validData = response.response.status;
    let newData = {
      usercode: $.session.get("User"),
      username: $.session.get("Username"),
      lssitemaster: { sitecode: $.session.get("Usersite") },
      lsuserMaster: {
        usercode: $.session.get("User"),
        username: $.session.get("Username"),
      },
      token: $.session.get("Token"),
      tenant: $.session.get("tenantid")
    };
    response.parentdircode = response.parentdircode + "." + event.floatvalues;
    newData.sitemaster = { sitecode: sessionStorage.Usersite };
    newData.createdby = { usercode: sessionStorage.User };
    let Selected_Treeitems = this.state.selectedTreeItem_Addnewfolder;
    let stateData = this.state.Orderfor === 1 ? this.state.stateCDFData : this.state.stateCDFData1;
    if (validData) {
      if (Selected_Treeitems && (Selected_Treeitems?.filefor === "DR" || Selected_Treeitems.filefor === "TMP" || Selected_Treeitems.filefor === "TMS" || Selected_Treeitems.filefor === "TMM")) {
        newData = getFolderToSave(
          stateData,
          Selected_Treeitems,
          this.intl,
          response.directoryname,
          screen,
          response
        );
      } else {
        newData = getFolderToSave(
          stateData,
          null,
          this.intl,
          response.directoryname,
          screen,
          response,

        );
      }
      newData.parentdircode = event.parentdircode;
      newData.floatvalues = event.floatvalues;
      let Audit = this.state.Orderfor === 1 ? AuditTrailValidation(
        "IDS_MDL_ORDERS",
        "IDS_SCN_SHEETORDERS",
        "IDS_TSK_NEWFOLDER"
      ) : AuditTrailValidation(
        "IDS_MDL_ORDERS",
        "IDS_SCN_PROTOCOLORDERS",
        "IDS_TSK_NEWFOLDER"
      );
      let Insertdirectoru_Url = this.state.Orderfor === 1 ? "" + this.ELNurl + "/Instrument/Insertnewdirectory" : "" + this.ELNurl + "/Instrument/Insertnewdirectoryonprotocol"
      if (Audit) {
        $("#DashboardModel").modal("show");
        newData.objmanualaudit = this.state.Orderfor === 1 ? Manualauditobject("create", "Sheet Orders") : Manualauditobject("create", "Protocol Orders");
        this.setState({
          AuditUrl: Insertdirectoru_Url,
          AuditObject: newData,
          AuditPassfunction: this.oninsertfoldersuccess.bind(this),
          AuditFailfunction: this.onErrorRegisterorder.bind(this),
          isregpopoveron: false,
          Activewidgets_Pulldata: true
        });
      }
      else {
        Servicecalls(
          Insertdirectoru_Url,
          newData,
          this.oninsertfoldersuccess.bind(this),
          () => { }
        );

      }
    } else {
      this.props.alert.error(this.state.Orderfor === 1 ? this.props.t("Orders.Sheetorders.IDS_MSG_FOLDEREXIST") : this.props.t("Orders.Protocolorders.IDS_MSG_FOLDEREXIST"));
      passObjDet = {
        objsilentaudit: Silentauditobject(
          "warning",
          this.state.Orderfor === 1 ? "Sheet Orders" : "Protocol Orders",
          this.state.Orderfor === 1 ? this.props.t("Orders.Protocolorders.IDS_AUDIT_FOLDEREXIST", {
            folder: response.directoryname,
          }) : this.props.t("Orders.Protocolorders.IDS_AUDIT_FOLDEREXIST", {
            folder: response.directoryname,
          })
        ),
      };

    }

    Servicecalls(
      this.state.Orderfor === 1 ? "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler" : "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      () => { },
      () => { }
    );

  }

  oninsertfoldersuccess = (response) => {
    if (response.floatvalues !== undefined) {
      response.parentdircode = parseFloat(response.parentdircode + "." + response.floatvalues);
    }
    $("#DashboardModel").modal("hide");

    let newData;
    this.props.alert.success(this.props.t("Orders.Sheetorders.IDS_MSG_FOLDERADDED"));
    if (response !== undefined) {
      response.icon = convertExtensionToIcon(response.directoryname, null);
      response.dateCreated = convertDateFormat(
        convertUTCDateToLocalDate(new Date(response.dateCreated)),
        this.intl
      );
      response.dateModified = convertDateFormat(
        convertUTCDateToLocalDate(new Date(response.dateModified)),
        this.intl
      );

      response.filefor = "DR";
      response.Created_By = sessionStorage.Username;
    }
    let Selected_Treeitems = this.state.selectedTreeItem_Addnewfolder;
    let stateCDFData = this.state.Orderfor === 1 ? this.state.stateCDFData : this.state.stateCDFData1;
    if (Selected_Treeitems && Selected_Treeitems?.filefor === "DR") {
      newData = addFolderonObj(stateCDFData, Selected_Treeitems, this.intl, response);
    } else {
      newData = addFolderonObj(stateCDFData, null, this.intl, response);
    }
    if (Selected_Treeitems && Selected_Treeitems?.filefor === "DR") {
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "create",
          this.state.Orderfor === 1 ? "Sheet Orders" : "Protocol Orders",
          this.props.t(this.state.Orderfor === 1 ? "Orders.Sheetorders.IDS_AUDIT_WITHINANOTHERFOLDER" : "Orders.Protocolorders.IDS_AUDIT_WITHINANOTHERFOLDER", {
            user: $.session.get("Username"),
            folder2: response.directoryname,
            folder1: Selected_Treeitems.directoryname,
            visible: response.viewoption === 1 ? "Site" : response.viewoption === 2 ? "Only me" : "Project Team"

          })
        ),
      };
      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        () => { },
        () => { }
      );
    } else {
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "create",
          this.state.Orderfor === 1 ? "Sheet Orders" : "Protocol Orders",
          this.props.t(this.state.Orderfor === 1 ? "Orders.Sheetorders.IDS_AUDIT_REQADDNEWFOLDER" : "Orders.Protocolorders.IDS_AUDIT_REQADDNEWFOLDER", {
            user: $.session.get("Username"),
            folder: response.directoryname,
            visible: response.viewoption === 1 ? "Site" : response.viewoption === 2 ? "Only me" : "Project Team",
            screenname: isMultitenant === 2 ? this.props.t("Orders.Sheetorders.IDS_LBL_LABSHEETTASKS") : this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDER")

          })
        ),
      };
      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        () => { },
        () => { }
      );
    }

    let screen = this.state.Orderfor === 1 ? "Sheet" : "Protocol"
    const newTreeItem = searchTreeItem(newData, response);
    this.setState({ selectedTreeItem_Addnewfolder: newTreeItem, selectedTreeItem: newTreeItem })
    let Allstate_Data = this.flattenHierarchy(JSON.parse(JSON.stringify(newData)));

    if (this.state.Orderfor === 1) {
      let Statevalues_update = this.expandPathInHierarchy(Allstate_Data, response.path, stateCDFData, screen);
      this.setState({ stateCDFData: Statevalues_update, folderdata: Statevalues_update })
    } else {
      let Statevalues_update = this.expandPathInHierarchyforprotocol(Allstate_Data, response.path, stateCDFData, screen);
      this.setState({ stateCDFData1: Statevalues_update, folderdataprotocol: Statevalues_update })
    }
  }

  expandPathInHierarchy = (stateDataobj, path, stateData, screen) => {
    const pathSegments = path.split('/');
    let currentLevel = stateDataobj;
    pathSegments.reduce((Path, Items) => {
      Path = Path ? `${Path}/${Items}` : Items;
      const matchingFolder = currentLevel.find((folder) => folder.path === Path);
      if (matchingFolder) {
        let State_updateddata = Onsetfolderexpande(stateData, matchingFolder?.directorycode, screen);
        stateData = State_updateddata;
      }
      return Path;
    }, "");
    return stateData;
  };

  expandPathInHierarchyforprotocol = (stateDataobj, path, stateData, screen) => {
    const pathSegments = path.split('/');
    let currentLevel = stateDataobj;
    pathSegments.reduce((Path, Items, index) => {
      if (index === 0 && Items === "ProtocolOrder") {
        Items = "Protocol"
      }
      Path = Path ? `${Path}/${Items}` : Items;
      const matchingFolder = currentLevel.find((folder) => folder.path === Path);
      if (matchingFolder) {
        let State_updateddata = Onsetfolderexpande(stateData, matchingFolder?.directorycode, screen);
        stateData = State_updateddata;
      }
      return Path;
    }, "");
    return stateData;
  };

  flattenHierarchy = (stateDataobj) => {
    return stateDataobj?.reduce((result, currentValue) => {
      result.push(currentValue);
      if (currentValue.items) {
        result = result.concat(this.flattenHierarchy(currentValue.items));
      }
      return result;
    }, []);
  }

  RegisterProtoclSample = (response) => {
    let selectprotocolOrderData = response.selectprotocolOrderData;
    let selectedtest = response.selectTestData;
    let SelectedProtocol = response.SelectedProtocol;
    let selectedproject = response.selectProjectData;
    let selectedsample = response.selectSampleData;
    let selectedrepository = response.selectRepoData;
    let selectedrepositorydata = response.selectRepodataData;
    let selectedworkflow = response.selectWflowData;
    let selectedkeyword = response.selectOrderKey;
    let selectedfolder = response.selectFolderData;
    let selectassigneduser = response.selectassigneduser;
    let viewoption = response.viewoption;
    let selectedMaterial = response.selectMaterial;
    let selectedMaterialInventory = response.selectMaterialInventory;
    let duedate = response.duedate;
    let cautiondate = response.cautiondate;
    let period = response.period;
    let Repeat = response.Repeat;
    let Interval = response.Interval;
    let timespan = response.timespan;
    let autocreatedate = response.autocreatedate;
    let Autoregister_Count = response?.Autoregister_Count;
    let selectedprojectteam = response?.selectedprojectteam;
    let teamselected = response?.selectedprojectteam.length > 0 ? true : false;
    // let teamcode = response.projectteamcode !== undefined ? response.projectteamcode.teamcode : undefined
    // if (selectedfolder !== undefined && selectedfolder !== null && response.orderdisplaytype === 4) {
    //     setSelectedTreeItem(selectedfolder);
    //     setDetailsData(selectedfolder);
    //     setSelectedGridItem({});
    //     setGridSelection({});
    // }

    let silentaudit = Silentauditobject(
      "warning",
      "Protocol Orders",
      this.props.t("Orders.Protocolorders.IDS_MSG_PROTOALERT")
    );
    let sequence = getsequenceoncode(2);
    let passObjDet = {
      testcode: selectedtest !== undefined && selectedtest !== null ? selectedtest.testcode : null,
      lstestmasterlocal: selectedtest !== undefined && selectedtest !== null ? selectedtest : null,
      sitecode: sessionStorage.Usersite,
      lssamplemaster: selectedsample !== undefined && selectedsample !== null ? selectedsample : null,
      lsprojectmaster: selectedproject,
      protocoltype: selectprotocolOrderData.type,
      lsprotocolmaster: SelectedProtocol,
      templateversionno: SelectedProtocol?.versionno ? SelectedProtocol?.versionno : 1,
      testname: selectedtest !== undefined && selectedtest !== null ? selectedtest.testname : null,
      lsfile: SelectedProtocol,
      keyword: selectedkeyword,
      tittle: response.selectOrdertittle,
      ismultitenant: isMultitenant,
      createdtimestamp: GetutcDate(new Date()),
      objsilentaudit: silentaudit,
      createdbyusername: sessionStorage.Username,
      objmanualaudit: Manualauditobject("insert", "Protocol Orders"),
      objuser: { multiusergroupcode: sessionStorage.multiusergroups },
      multiusergroupcode: sessionStorage.multiusergroups,
      createby: sessionStorage.User,
      lsuserMaster: store.getState().Loggeduser,
      lsrepositories: !isPremiumTenant ? selectedrepository : null,
      lsrepositoriesdata: !isPremiumTenant ? selectedrepositorydata : null,
      elnmaterial: isPremiumTenant ? selectedMaterial?.matcode ? { nmaterialcode: selectedMaterial.matcode } : null : null,
      elnmaterialinventory: isPremiumTenant ? selectedMaterialInventory : null,
      lstworkflow: workflow,
      assignedto:
        selectedworkflow !== null &&
          selectedworkflow !== undefined &&
          selectedworkflow.usercode !== null &&
          selectedworkflow.usercode > 0
          ? selectedworkflow
          : null,
      directorycode:
        selectedfolder === undefined || selectedfolder === null
          ? null
          : selectedfolder.directorycode,
      orderdisplaytype: response.orderdisplaytype,
      viewoption:
        selectedproject !== undefined && selectedproject !== null
          ? 1
          : viewoption,
      content: selectprotocolOrderData.type === 2 ? JSON.stringify(protocolordercontent) : "",
      duedate: GetutcDate(duedate),
      cautiondate: GetutcDate(cautiondate),
      period: period !== undefined ? period.name : "",
      repeat: Repeat,
      lsprotocolselectedTeam: selectedprojectteam,
      teamselected: teamselected,
      isclone: false,
      sequenceid: sequence && formsequenceformatview(JSON.parse(sequence.sqf), sequence.sep, "g", {
        projectname: selectedproject && selectedproject.projectname ? selectedproject.projectname : "",
        projectcode: selectedproject && selectedproject.projectid ? selectedproject.projectid : "",
        task: selectedtest && selectedtest.testname ? selectedtest.testname : "",
        ordertype: getprotocolordertype(parseInt(selectprotocolOrderData.type))
      })
    };

    if (Repeat) {
      passObjDet.autoregistercount = Autoregister_Count;
    }

    passObjDet.lsautoregisterorder =
      Repeat === true
        ? {
          repeat: Repeat,
          interval: Interval,
          timespan: timespan !== undefined ? timespan.name : "",
          //screen: "Protocol_Order",
          autocreatedate: autocreatedate,
          ismultitenant: isMultitenant,
          isautoreg: false,
        }
        : null;

    if (passObjDet.lsautoregisterorder !== null) {
      passObjDet.lsautoregisterorder.screen = "Protocol_Order";
    }

    if (selectassigneduser !== undefined) {
      passObjDet.assignedto =
        selectassigneduser !== null &&
          selectassigneduser !== undefined &&
          selectassigneduser.usercode !== null &&
          selectassigneduser.usercode > 0
          ? selectassigneduser
          : null;
    }

    passObjDet.lsActiveWidgets = {
      screenname: "Protocol_Order",
      activityType: "Insert",
      userId: sessionStorage.User,
    }
    passObjDet.isDefault = protocoldefaultcheck();

    let Audit = AuditTrailValidation(
      "IDS_MDL_ORDERS",
      "IDS_SCN_PROTOCOLORDERS",
      "IDS_TSK_REGPROTOCOL"
    );
    if (Audit) {
      $("#DashboardModel").modal("show");
      this.setState({
        AuditUrl: "" + this.ELNurl + "/protocol/addProtocolOrder",
        AuditObject: passObjDet,
        AuditPassfunction: this.onAddProtocolDetailSuccess.bind(this),
        AuditFailfunction: this.onAddProtocolDetailFailure.bind(this),
        isregpopoveron: false,
      });
    } else {
      this.setState({
        isregpopoveron: false,
      });

      Servicecalls(
        "" + this.ELNurl + "/protocol/addProtocolOrder",
        passObjDet,
        this.onAddProtocolDetailSuccess.bind(this),
        this.onAddProtocolDetailFailure.bind(this)
      );
    }


  };
  onAddProtocolDetailSuccess(res) {

    let dup_response = { ...res };
    let shortnedres = ProtocolSequence(dup_response.AddedProtocol);
    res.protoclordername = shortnedres.protoclordername;

    this.setState({
      keyName: "", Activewidgets_Pulldata: true
    });

    let objsilentaudit = onAuditHandler(
      "registered",
      "Protocol Orders",
      this.props.t("Dashboard.Protocolorders.IDS_AUDIT_REQUESTOREGPRTORDER", {
        screen: orderTypeforprotocol(this.state.AssigntProtocolfor),
        user: $.session.get("Username"),
        user1: res.AddedProtocol.protoclordername,
        visible: res.viewoption === 1 ? "Site" : res.viewoption === 2 ? "Only me" : res.viewoption === 3 ? "Project Team" : ""

      })
    );

    if (objsilentaudit !== null) {
      let passObjDet = { objsilentaudit: objsilentaudit };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        this.onAuditValidateError.bind(this),
        this.onAuditValidateFailure.bind(this)
      );
      let passObjDetAudit = {};
      if (this.state.selectedworkflow.usercode === -2) {
        passObjDetAudit.objsilentaudit = Silentauditobject(
          "assign",
          "Protocol Orders",
          this.props.t("Dashboard.Protocolorders.IDS_AUDIT_ASSIGNTOUSER", {

            screen: orderTypeforprotocol(this.state.AssigntProtocolfor),
            user1: res.AddedProtocol.protoclordername,
            Username: this.state.selectedworkflow.username,
            user2: this.state.sitebaseduserscode.username
          }),

        );
      }
      else if (this.state.noworkflow === false) {
        passObjDetAudit.objsilentaudit = Silentauditobject(
          "assign",
          "Protocol Orders",
          this.props.t("Orders.Protocolorders.IDS_AUDIT_WORKFLOWASSIGNTOUSER", {

            screen: orderTypeforprotocol(this.state.AssigntProtocolfor),
            user1: res.AddedProtocol.protoclordername,
            Username: this.state.selectedworkflow.username,
            user: store.getState().Loggeduser.username
          }),

        );
      }
      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDetAudit,
        (res) => { },
        (res) => { }
      );
      if (res !== undefined) {
        this.setState({
          selectedproject: undefined,
          selectedsample: undefined,
          sitebasedusers: [],
          sitebaseduserscode: {},
          noworkflow: false,
          isMoveParent: 4,
          isshowtosite: 1,
          selectedTreeItem: undefined
        });


        let passobj = res.AddedProtocol;
        passobj.fromdate = this.state.fromdate;
        passobj.todate = this.state.todate;
        passobj.lsuserMaster = { usercode: $.session.get("User") };
        passobj.ismultitenant = isMultitenant;
        if (passobj.protocoltype === 1) {
          let copyinfo = [];
          if (isMultitenant === 1 || isMultitenant === 2) {
            copyinfo = passobj.cloudLsLogilabprotocolstepInfo;
          } else {
            copyinfo = passobj.lsLogilabprotocolstepInfo;
          }
          if (copyinfo !== undefined) {
            copyinfo = copyinfo.map((item) => {
              if (item.id !== undefined && item.lsprotocolstepInfo === undefined) {
                item.lsprotocolstepInfo = JSON.stringify("<p><br></p>");
              }
              let info = "";
              if (isMultitenant === 1 || isMultitenant === 2) {
                if (
                  item.id !== undefined &&
                  item.lsprotocolstepInfo === undefined
                ) {
                  item.lsprotocolstepInfo = JSON.stringify("<p><br></p>");
                }
                info = JSON.parse(item.lsprotocolstepInfo);
                if (info.protocolstepinfo !== undefined) {
                  info = info.protocolstepinfo;
                }
              } else {
                if (item.id !== undefined && item.content === undefined) {
                  item.content = JSON.stringify("<p><br></p>");
                }
                info = JSON.parse(item.content);
                if (info.protocolstepinfo !== undefined) {
                  info = info.protocolstepinfo;
                }
              }
              if (info.protocolstepinfo !== undefined) {
                info = info.protocolstepinfo;
              }
              const parser = new DOMParser();
              info = info.replaceAll(
                'hidden="" hiddenmode="register"',
                'hiddenmode="register"'
              );
              const doc = parser.parseFromString(info, 'text/html');

              // Find all elements that are not <span> with class 'restrict-edit'
              // const elementsToChange = Array.from(doc.body.querySelectorAll('*:not(.restrict-edit)'));
              // const elementsToChange = Array.from(doc.body.querySelectorAll('*:not(.restrict-edit):not(td):not(td :not(yourChildTagHere)):not(td :not(img):not(a):not(span)):not(tr):not(table):not(tbody)'));
              // elementsToChange.forEach((element) => {
              //   element.contentEditable = false;
              //   element.classList.add('prevent-select');
              //   if (element.className === "timer-delete btn btn-link prevent-select") {
              //     element.style.display = 'none';
              //   }

              // });
              // const elementsToChangecontentedittru = Array.from(doc.body.querySelectorAll('td'));
              // elementsToChangecontentedittru.forEach((element) => {
              //   element.contentEditable = true;
              // });
              const elementsToChange = Array.from(doc.body.querySelectorAll('*:not(.restrict-edit'));
              elementsToChange.forEach((element) => {
                if (element.className === "timer-delete btn btn-link prevent-select") {
                  element.style.display = 'none';
                }
              });

              // Serialize the modified HTML back to a string
              info = doc.body.innerHTML;
              // info = info.replaceAll("<p", '<p contenteditable="false"');
              // info = info.replaceAll(
              //   "<p contenteditable='false' <br></p>",
              //   "<p><br></p>"
              // );
              // info = info.replaceAll(
              //   'hidden="" hiddenmode="register"',
              //   'hiddenmode="register"'
              // );
              // // info = info.replaceAll(
              // //   "<span class="restrict-edit">",
              // //   "<span contenteditable='true' class='restrict-edit' >"
              // // );
              // info = info.replaceAll(
              //   '<span class="restrict-edit">',
              //   "<span contenteditable='true' class=\"restrict-edit\" >"
              // );
              // info = info.replaceAll(
              //   '<span class="restrict-edit">',
              //   "<span contenteditable='true' class=\"restrict-edit\" >"
              // );
              // info = info.replaceAll(
              //   '<ul',
              //   "<ul contenteditable='false'"
              // );
              // info = info.replaceAll(
              //   '<li',
              //   "<li contenteditable='false'"
              // );

              // info = info.replaceAll(
              //   '<span',
              //   "<span class='prevent-select' contenteditable='false'"
              // );
              // info = "<div disabled='true' class='prevent-select'> " + info.substring(0, info.length) + "</div>";
              // info = "<p><br></p>" + info.substring(0, info.length) + "<p><br></p>";
              info = JSON.stringify({ "protocolstepinfo": info });
              if (isMultitenant === 1 || isMultitenant === 2) {
                item.lsprotocolstepInfo = info;
              } else {
                item.content = info;
              }
              return item;
            });
          }
          if (isMultitenant === 1 || isMultitenant === 2) {
            passobj.CloudLsLogilabprotocolstepInfo = copyinfo;
          } else {
            passobj.LsLogilabprotocolstepInfo = copyinfo;
          }
        } else {
          delete passobj.cloudLsLogilabprotocolstepInfo;
          delete passobj.lsLogilabprotocolstepInfo;
        }
        setTimeout(() => {
          this.setState({
            ServiceToUrl:
              "" + this.ELNurl + "/protocol/addProtocolOrderafterfirstofter",
            ServiceHeaderobject: passobj,
            ServiceMethodType: "POST",
            ServcieonSuccess:
              this.onaddProtocolOrderafterfirstofterSuccess.bind(this),
            ServcieonFailure:
              this.onaddProtocolOrderafterfirstofterFaliure.bind(this),
          });
        }, 0);
        // let passobj = res.AddedProtocol;
        // passobj.fromdate = this.state.fromdate;
        // passobj.todate = this.state.todate;
        // // passobj.orderflag = this.state.activekey === "3" ? "A" : "M";
        // // passobj.assignedto = { usercode: $.session.get("User") };
        setTimeout(() => {
          Servicecalls(
            "" + this.ELNurl + "/protocol/addProtocolOrderafter",
            passobj,
            this.onaddProtocolOrderafterSuccess.bind(this),
            this.onaddProtocolOrderafterFaliure.bind(this)
          );
        }, 20);


        let todate = new Date(this.state.todate);
        let currentdate = new Date();
        if (
          todate.getUTCDay() === currentdate.getUTCDay() &&
          todate.getUTCMonth() === currentdate.getUTCMonth() &&
          todate.getUTCFullYear() === currentdate.getUTCFullYear()
        ) {
          this.setState({ initpagenofororder: 0, isformatorder: 0 }, () => {
            this.getordercount(this.state.fromdate, new Date());
            this.GetDashboarddetails("1", this.state.fromdate, new Date(), false, false, false);
          })
          // this.GetDashboarddetails("2", this.state.fromdate, this.state.todate);
        }
      }

      let protocolType =
        this.state.AssigntProtocolfor === 1
          ? "IDS_MSG_ELNPROTOCOLORDERSUCCESS"
          : "IDS_AUDIT_DYNAMICPROTOCOLORDERSUCCESS";

      this.props.alert.success(
        this.props.t("Orders.Protocolorders." + protocolType, {
          orderid: res.AddedProtocol.protoclordername,
          screenname: isMultitenant === 2 ? this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDERS"),
          param: ""
        })
      );
    }

  }
  onaddProtocolOrderafterfirstofterSuccess(responce) {
    // this.state.orderlist.unshift(responce.addprotocl);
  }
  onaddProtocolOrderafterfirstofterFaliure(res) { }
  onaddProtocolOrderafterSuccess(res) { }

  onaddProtocolOrderafterFaliure(res) { }

  onAddProtocolDetailFailure(res) { }

  returoption() {
    return this.state.UserGroupVal.map((data) => ({
      label: data.usergroupname,
      value: data.usergroupcode,
    }));
  }

  render() {


    if (!this.state.validurl) {
      // return <Redirect to="/Home" />;
    }

    const fDate = setDateAsuserDefined(
      this.state.fromdate,
      $.session.get("userDefinedDate")
    );
    const tDate = setDateAsuserDefined(
      this.state.todate,
      $.session.get("userDefinedDate")
    );

    let filtercontent = "";
    if (this.state.filtertype === 1) {
      filtercontent = (
        <span className="inline-filter-bread">
          <span className="inline-filter-group">
            <span className="label-filter">
              {this.props.t("Dashboard.IDS_LBL_FILTERBYDATE")}:
            </span>
            <span className="value-filter">{fDate.toString()}</span>
          </span>
        </span>
      );
    } else {
      filtercontent = (
        <span className="inline-filter-bread">
          <span className="inline-filter-group">
            <span className="label-filter">
              {this.props.t("Dashboard.IDS_LBL_FILTERFROMDATE")}{" "}
            </span>
            <span className="value-filter">
              {fDate.toString()}
            </span>
          </span>
          <span className="inline-filter-group">
            <span className="label-filter">
              {this.props.t("Dashboard.IDS_LBL_TO")}{" "}:
            </span>
            <span className="value-filter">{tDate.toString()}{" "}</span>
          </span>
          <span className="inline-filter-group">
            <span className="label-filter">
              {this.props.t("Dashboard.IDS_LBL_TESTCODE")}{" "}:
            </span>
            <span className="value-filter">
              {this.state.isfilter ? this.state.filtertest.testname !== undefined ? this.state.filtertest.testname : this.props.t("Dashboard.IDS_LBL_SEARCHBYALL") : this.props.t("Dashboard.IDS_LBL_SEARCHBYALL")}
            </span>
          </span>
          <span className="inline-filter-group">
            <span className="label-filter">
              {this.props.t("Dashboard.IDS_LBL_PROJECT")}{" "}:
            </span>
            <span className="value-filter">
              {this.state.isfilter ? this.state.filterproject.projectname !== undefined ? this.state.filterproject.projectname : this.props.t("Dashboard.IDS_LBL_SEARCHBYALL") : this.props.t("Dashboard.IDS_LBL_SEARCHBYALL")}
            </span>
          </span>
        </span>
      );
    }

    return (
      <>
        <Service
          Tourl={this.state.ServiceToUrl}
          MethodType={this.state.ServiceMethodType}
          onSuccess={this.state.ServcieonSuccess}
          onFailure={this.state.ServcieonFailure}
          Headerobject={this.state.ServiceHeaderobject}
          onReseturl={() => {
            this.setState({ ServiceToUrl: "" });
          }}
          contenttype={this.state.Servicecontenttype}
        />
        <Suspense fallback={<div></div>}>
          <Audit
            AuditId="DashboardModel"
            AuditUrl={this.state.AuditUrl}
            AuditObject={this.state.AuditObject}
            AuditPassfunction={this.state.AuditPassfunction}
            AuditFailfunction={this.state.AuditFailfunction}
            alert={this.props.alert}
          />
        </Suspense>
        <Tooltip openDelay={100} position="bottom">
          <div className="filter-top-full">
            <div className="btn-group-cutom p-sm dashboard-title" style={{ display: "inline-block", width: "100%" }}>
              <div style={{ display: "inline-block" }}>{filtercontent}

              </div>
              <button id="id-dashboard-filteropen"
                className="edit-filter"
                onClick={this.filteropenstatus}
              >
                <svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <title>Date Filter</title>
                  <g id="Welcome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Dashboard" transform="translate(-782.000000, -71.000000)" fill="#1967E3" fillRule="nonzero">
                      <path d="M788.143591,74.3444444 L788.654631,74.8555556 L783.621997,79.8888889 L783.110957,79.8888889 L783.110957,79.3777778 L788.143591,74.3444444 M790.143313,71 C790.004444,71 789.860019,71.0555556 789.754479,71.1611111 L788.737953,72.1777778 L790.820997,74.2611111 L791.837523,73.2444444 C792.054159,73.0277778 792.054159,72.6777778 791.837523,72.4611111 L790.537703,71.1611111 C790.426607,71.05 790.287738,71 790.143313,71 L790.143313,71 Z M788.143591,72.7722222 L782,78.9166667 L782,81 L784.083044,81 L790.226635,74.8555556 L788.143591,72.7722222 Z" id="Shape"></path>
                    </g>
                  </g>
                </svg>
                <span title={this.props.t("Dashboard.IDS_LBL_EDITFILTER")} className="label-filter">
                  {this.props.t("Dashboard.IDS_LBL_EDITFILTER", { param: "", })}
                </span>
              </button>
              {/* <div id="dashboardsplitbutton" className="dashboard-title" style={{ "float": "right" }}>
                <SplitButton
                  // imageUrl={"./images/eyeicon.png"}
                  text={this.state.selecteddashview && this.state.selecteddashview.viewname}
                  textField={"viewname"}
                  itemRender={this.Itemrender_Dashboardview}
                  className=" btn_white_bg btn_white_bg dropdown-bg mg-r-half "
                  onItemClick={this.onDashboardselect}
                  // items={this.state.Orderfor === 1 ? this.state.Sheetorders_Customcolumn?.filter(items => items.pathName === undefined) : this.state.Protocolorder_Customcolumn?.filter(items => items.pathName === undefined)}
                  items={this.state.dashboardviews}
                ></SplitButton>
              </div> */}
            </div>

          </div>

        </Tooltip>
        {this.state.selecteddashview && this.state.selecteddashview.viewcode === 1 && <div className="container-fluid">
          <Tooltip openDelay={100} position="bottom">
            <div className="statistics-card-wrap">
              <div className={`statistics-card ${this.state.Orderselectionontype === 1 ? "cls_dashselect" : ""}`}>
                <div className="card-body" onClick={this.onTotalordersclick}>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto mr-2">
                      <img
                        src="images/total-orders.svg"
                        alt="total-orders"
                        width="41"
                        height="55"
                      />
                    </div>
                    <div className="col">
                      <div className="status-count">
                        {parseInt(this.state.Completedorders) + parseInt(this.state.PendingOrders)
                          + parseInt(this.state.rejectedOrder) + parseInt(this.state.canceledOrder)}
                      </div>
                      <div className="status-txt">
                        <span title={isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_ALLTASKS") : this.props.t("Dashboard.IDS_LBL_TOTALORDERS")}>
                          {isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_ALLTASKS") : this.props.t("Dashboard.IDS_LBL_TOTALORDERS")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`statistics-card ${this.state.Orderselectionontype === 3 ? "cls_dashselect" : ""}`}>
                <div className="card-body" onClick={this.onPendingordersclick}>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto mr-2">
                      <img
                        src="images/pending.svg"
                        alt="completed"
                        width="41"
                        height="55"
                      />
                    </div>
                    <div className="col">
                      <div className="status-count">
                        {this.state.PendingOrders}
                      </div>
                      <div className="status-txt">
                        <span title={this.props.t("Dashboard.IDS_LBL_PENDINGORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}>
                          {this.props.t("Dashboard.IDS_LBL_PENDINGORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`statistics-card ${this.state.Orderselectionontype === 2 ? "cls_dashselect" : ""}`}>
                <div className="card-body" onClick={this.onCompleteordersclick}>
                  <div className="row no-gutters align-items-center">
                    <div className=" col-auto mr-2">
                      <img
                        src="images/completed.svg"
                        alt="completed"
                        width="41"
                        height="55"
                      />
                    </div>
                    <div className="col">
                      <div className="status-count">
                        {this.state.Completedorders}
                      </div>
                      <div className="status-txt">
                        <span title={this.props.t("Dashboard.IDS_LBL_COMPLETEDORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}>
                          {this.props.t("Dashboard.IDS_LBL_COMPLETEDORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`statistics-card ${this.state.Orderselectionontype === 5 ? "cls_dashselect" : ""}`}>
                <div className="card-body" onClick={this.onRejectedordersclick}>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto mr-2">
                      <img
                        src="images/rejected-order.svg "
                        alt="completed"
                        width="41"
                        height="55"
                      />
                    </div>
                    <div className="col">
                      <div className="status-count">
                        {this.state.rejectedOrder}
                      </div>
                      <div className="status-txt">
                        <span title={this.props.t("Dashboard.IDS_LBL_REJECTEDORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}>
                          {this.props.t("Dashboard.IDS_LBL_REJECTEDORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`statistics-card ${this.state.Orderselectionontype === 6 ? "cls_dashselect" : ""}`}>
                <div className="card-body" onClick={this.onCanceledordersclick}>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto mr-2">
                      <img
                        src="images/cancelled-order.svg"
                        alt="completed"
                        width="41"
                        height="55"
                      />
                    </div>
                    <div className="col">
                      <div className="status-count">
                        {this.state.canceledOrder}
                      </div>
                      <div className="status-txt">
                        <span title={this.props.t("Dashboard.IDS_LBL_CANCELLEDORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}>
                          {this.props.t("Dashboard.IDS_LBL_CANCELLEDORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Tooltip>
          <div className="row">
            <div className="col-lg-6 col-md-6">
              {this.state.Ordervalue &&
                <div className="kendo-box-wrap">
                  <div className="kendo-title-form dashboard-title">
                    <h6>
                      {this.props.t("Dashboard.IDS_LBL_RECENTORDERS", { screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASKS") : this.props.t("Dashboard.IDS_LBL_ORDERS") })}
                    </h6>
                    <div className="title-form-data">
                      {/* {this.state.orderRights ? ( */}
                      <label className={"radio "}>
                        <input
                          type="radio"
                          value="1"
                          name="Orderfor"
                          onChange={this.handleorderforChange.bind(this)}
                          checked={this.state.Orderfor === 1 ? true : false}
                        />
                        <span className="">
                          {this.props.t("Dashboard.IDS_LBL_SHEET", { param: "", })}
                        </span>
                      </label>
                      {/*  ) : (
                         ""
                       )} */}

                      {/* {this.state.protorderRights ? ( */}
                      <label className={"radio "}>
                        <input
                          type="radio"
                          value="2"
                          name="Orderfor"
                          onChange={this.handleorderforChange.bind(this)}
                          checked={
                            this.state.Orderfor === 2
                              ? true
                              : false
                          }
                        />
                        <span className="">
                          {this.props.t("Dashboard.IDS_LBL_PROTOCOL", { param: "", })}
                        </span>
                      </label>
                      {/* ) : (
                        ""
                      )} */}
                      <SplitButton
                        imageUrl={"./images/eyeicon.png"}
                        textField={"title"}
                        itemRender={this.Itemrender_Ordersscreen}
                        className=" btn_white_bg dropdown-bg mg-r-half"
                        // items={this.state.Orderfor === 1 ? this.state.Sheetorders_Customcolumn?.filter(items => items.pathName === undefined) : this.state.Protocolorder_Customcolumn?.filter(items => items.pathName === undefined)}
                        items={this.state.Orderfor === 1 ? this.state.Sheetorders_Customcolumn : this.state.Protocolorder_Customcolumn}
                      />
                      <button className="btn btn-user btn-primary-blue btn-block"
                        id="id-dashboard-register"
                        onClick={this.toggle}
                        disabled={

                          this.state.Orderfor === 1 ?
                            !this.state.createsheet && !this.state.Researchorderrights &&
                              !this.state.sheetevalrights && !this.state.Manageexcelrights
                              ? true : false : !this.state.protocolorder && !this.state.Dynamicorderrights ? true : false
                        }
                      >
                        <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                        <span>
                          {this.props.t("Dashboard.IDS_LBL_REGISTER", { param: "", })}
                        </span>
                      </button>
                    </div>
                    {this.state.isregpopoveron ? (
                      <MyDashboardContext.Provider value={this.state.Orderrights}>
                        <CreateDialog
                          onDialogClose={this.onregorderclose}
                          onCreateDialogClick={this.state.Orderfor === 1
                            ? this.onRegisterorderclick.bind(this)
                            : this.RegisterProtoclSample.bind(this)
                          }
                          sessionvalues={{
                            usercode: $.session.get("User"),
                            username: $.session.get("Username"),
                            lssitemaster: { sitecode: $.session.get("Usersite") },
                            lsuserMaster: {
                              usercode: $.session.get("User"),
                              username: $.session.get("Username"),
                            },
                            token: $.session.get("Token"),
                            tenant: $.session.get("tenantid")
                          }}
                          folderdata={getFolderTree(this.state.Orderfor === 1 ? this.state.folderdata : this.state.folderdataprotocol, this.state.selectedTreeItem)}
                          selectedItem={this.state.selectedTreeItem}
                          selectedFolder={this.state.selectedTreeItem}
                          t={this.props.t}
                          userData={null}
                          previousprops={{
                            ...this.props, onCDFselectstate: this.state.onCDFselectstate, onradioCDFbtnonClick: (event) => {
                              if (parseInt(event.target.value) === 4) {
                                this.setState({ onCDFselectstate: 4 })
                                return 4;
                              } else if (parseInt(event.target.value) === 5) {
                                this.setState({ onCDFselectstate: 5 })
                                return 5;
                              }
                            }, selectedCDPFolder: this.state.selectedTreeItem_Addnewfolder, onFolderCDPItemClick: (event) => { this.handleTreeItemClick(event) },
                            stateCDFData: this.state.Orderfor === 1 ? this.state.stateCDFData : this.state.stateCDFData1,
                            // getFolderTree(
                            //   this.state.Orderfor === 1
                            //     ? JSON.parse(JSON.stringify(this.state.folderdata))
                            //     : JSON.parse(JSON.stringify(this.state.folderdataprotocol)),
                            //   this.state.selectedTreeItem_Addnewfolder
                            // ),

                            onContextMenu: () => { }
                          }}
                          props={{ ...this.props, alert: this.props.alert }}
                          screen={this.state.Orderfor === 1 ? "Sheet" : "Protocol"}
                          rights={this.props.orderRights}
                          Addnewfolder_Onregister={this.state.Addnewfolder_Onregister}
                          Onenablenewfolder={this.Onenablenewfolder.bind(this)}
                          onDialogClick={this.handleDialogClick.bind(this)}


                        />
                      </MyDashboardContext.Provider>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-lg-12 col-md-12">
                    {this.formatorders()}
                  </div>
                </div>
              }
            </div>
            {isMultitenant === 2 && sessionStorage.accouttype === "1" ? "" :
              <div className="col-lg-6 col-xl-6">
                {this.state.actrights ? (
                  <div className="kendo-box-wrap">
                    <div className="kendo-title-form">
                      <h6>
                        {this.props.t("Dashboard.IDS_LBL_MYTASK")}
                      </h6>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      {/* <OverlayScrollbarsComponent
                      className="myTaskList"
                      style={{ maxHeight: "460px" }}
                      options={{
                        callbacks: {
                          onScrollStop: this.onactivitiyscrolled.bind(this),
                        },
                      }}
                    >
                      <ul className="list-group sm-center-styled list-group-flush"> */}
                      {this.formatMyTask()}
                      {/* </ul>
                    </OverlayScrollbarsComponent> */}
                    </div>
                  </div>
                ) : (
                  false
                )}
              </div>
            }

          </div>

          <div className="row">
            <div className="col-lg-6 col-md-6">
              {this.state.tempvalue ? (
                <div className="kendo-box-wrap">
                  <div className="kendo-title-form dashboard-title">
                    <h6>
                      {this.props.t("Dashboard.IDS_LBL_RECENTTEMP", { param: "", })}
                    </h6>
                    <div className="title-form-data">
                      {/* {this.state.sheetRights ? ( */}
                      <label className={"radio "}>
                        <input
                          type="radio"
                          value="1"
                          name="Templatefor"
                          onChange={this.handletemplateforChange.bind(this)}
                          checked={this.state.Templatefor === 1 ? true : false}
                        />
                        <span className="">
                          {this.props.t("Dashboard.IDS_LBL_SHEET", { param: "", })}
                        </span>
                      </label>
                      {/* ) : ("")}

                      {this.state.protoTemplRights ? ( */}
                      <label className={"radio "}>
                        <input
                          type="radio"
                          value="2"
                          name="Templatefor"
                          onChange={this.handletemplateforChange.bind(this)}
                          checked={this.state.Templatefor === 2 ? true : false}
                        />
                        <span>
                          {this.props.t("Dashboard.IDS_LBL_PROTOCOL", { param: "", })}
                        </span>
                      </label>
                      {/* ) : (
                        false
                      )} */}

                      <SplitButton
                        imageUrl={"./images/eyeicon.png"}
                        textField={"title"}
                        itemRender={this.itemRender}
                        className=" btn_white_bg dropdown-bg mg-r-half"
                        dropdownIcon="pi pi-plus"
                        items={this.state.Templatefor === 1 ? this.state.Sheettemplate_Customcolumn : this.state.Protocoltemplate_Customcolumn}
                      ></SplitButton>
                      <button
                        className="btn btn-user btn-primary-blue btn-block "
                        id="id-dashboard-new"
                        onClick={this.togglesheet}
                        disabled={!this.state.sheetcreat ? true : this.state.Templatefor === 1 ? !this.state.sheetRights ? true : false : this.state.Templatefor === 2 && !this.state.protoTemplRights ? true : !this.state.protocolRights ? true : false}
                      >
                        <i className="fa fa-plus" aria-hidden="true"></i>
                        <span>
                          {this.props.t("Dashboard.IDS_LBL_NEW", { param: "", })}
                        </span>
                      </button>
                    </div>
                    <Modal
                      isOpen={this.state.issheetpopoveron}
                      backdrop={true}
                      toggle={this.togglesheet}
                      className=" modal-md fixed-dailogbox"
                    >
                      <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">
                          {this.props.t("Dashboard.IDS_LBL_CREATETEMPLATE")}
                          {/* {properties.props.t("Common.IDS_SHAREWITHUSER", { param: "" })} */}
                        </h5>
                        {/* <button id="id-dashboard-close"
                          type="button"
                          className="btn_white_bg"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={this.onsheetorderclose}
                        >
                          <i className="fas fa-times" aria-hidden="true"></i>
                        </button> */}
                      </div>
                      <ModalBody>
                        {this.state.Templatefor === 1 ? (
                          <div>
                            <div className="row clearfix">
                              <div className="col-12">
                                <div className="login-form">
                                  <div className="form-group">
                                    <label htmlFor="inputPassword" className="form-label text required" >
                                      {this.props.t("Dashboard.IDS_LBL_SHEETNAME")}
                                    </label>
                                    <TextBox
                                      txtType="text"
                                      txtClsname={"form-control " + this.state.SheetnameNameValidcls}
                                      txtName="Profilename"
                                      txtPlaceholder=""
                                      txtDataType="Text"
                                      txtmaxlength="100"
                                      txtvalue={this.state.Sheetname}
                                      sendData={this.onsheetnamechange.bind(this)}
                                      txtrequired="true"
                                      autofocus="true"
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="inputPassword" className="form-label">
                                      <span className="label-top required">
                                        {this.props.t("Orders.Sheetorders.IDS_LBL_TASK")}
                                      </span>
                                    </label>
                                    <KendoCombobox
                                      initialValue=""
                                      id="id-combo-task"
                                      Datasource={this.state.lsttest}
                                      DefaultValue={this.state.selectedtest}
                                      onvaluechange={this.handleTestChange.bind(this)}
                                      ValueMember="testcode"
                                      DisplayMember="testname"
                                      Placeholder={this.props.t("Orders.Sheetorders.IDS_LBL_TASK")}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {isMultitenant === 2 ? false :
                              <div className="row clearfix">
                                <div className="col-12">
                                  <div className="login-form">
                                    <div className="form-group">
                                      <label htmlFor="inputPassword" className="form-label"  >
                                        {this.props.t("Setup.Domain.IDS_LBL_DOMAINCAT")}
                                      </label>
                                      <TextBox
                                        txtType="text"
                                        txtClsname={
                                          "form-control "
                                        }
                                        txtName="Profilename"
                                        txtPlaceholder=""
                                        txtDataType="Text"
                                        txtmaxlength="100"
                                        txtvalue={this.state.sheetcategory}
                                        sendData={this.onsheetcategorychange.bind(this)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        ) : (
                          <div>
                            <div className="row clearfix">
                              <div className="col-12">
                                <div className="login-form">
                                  <div className="form-group">
                                    <label
                                      htmlFor="inputPassword"
                                      className="form-label text required"
                                    >
                                      {this.props.t("Dashboard.IDS_LBL_PROTO")}
                                    </label>
                                    {/* <Suspense fallback={<div></div>}> */}
                                    <TextBox
                                      txtType="text"
                                      txtClsname={
                                        "form-control " +
                                        this.state.protocolNameValidcls
                                      }
                                      txtName="Profilename"
                                      txtPlaceholder=""
                                      txtDataType="Text"
                                      txtmaxlength="100"
                                      txtvalue={this.state.protocolname}
                                      sendData={this.onprotocolnamechange.bind(
                                        this
                                      )}
                                      txtrequired="true"
                                      autofocus="true"
                                    />

                                    {/* </Suspense> */}
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="inputPassword" className="form-label">
                                      <span className="label-top required">
                                        {this.props.t("Orders.Sheetorders.IDS_LBL_TASK")}
                                      </span>
                                    </label>
                                    <KendoCombobox
                                      initialValue=""
                                      id="id-combo-task"
                                      Datasource={this.state.lsttest}
                                      DefaultValue={this.state.selectedtest}
                                      onvaluechange={this.handleTestChange.bind(this)}
                                      ValueMember="testcode"
                                      DisplayMember="testname"
                                      Placeholder={this.props.t("Orders.Sheetorders.IDS_LBL_TASK")}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {isMultitenant === 2 ? false :
                              <div className="row clearfix">
                                <div className="col-12">
                                  <div className="login-form">
                                    <div className="form-group">
                                      <label
                                        htmlFor="inputPassword"
                                        className="form-label"
                                      >
                                        {this.props.t("Setup.Domain.IDS_LBL_DOMAINCAT")}
                                      </label>
                                      {/* <Suspense fallback={<div></div>}> */}
                                      <TextBox
                                        txtType="text"
                                        txtClsname={
                                          "form-control "

                                        }
                                        txtName="Profilename"
                                        txtPlaceholder=""
                                        txtDataType="Text"
                                        txtmaxlength="100"
                                        txtvalue={this.state.protocolcategory}
                                        sendData={(value) => this.setState({ protocolcategory: value })}
                                        txtrequired="true"
                                      // autofocus="true"
                                      />

                                      {/* </Suspense> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        )}
                        {isMultitenant === 2 ? false :
                          <div className="container p-0">
                            <fieldset className="pb-0">
                              <legend> {this.props.t("Dashboard.IDS_LBL_TEMPLATEVISIBILITY")}</legend>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div className="row clearfix">
                                    <div className="login-form pl-4">
                                      <label className={"radio"}>
                                        <input
                                          type="radio"
                                          value="1"
                                          name="Selectordershow"
                                          onChange={this.onshowtositetemp.bind(this)}
                                          checked={this.state.viewoptiontemplate === 1 ? true : false}
                                        />
                                        <span>
                                          {this.props.t("Dashboard.IDS_LBL_SITE")}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="col-sm-4">
                                  <div className="row clearfix">
                                    <div className="login-form">
                                      <label className={"radio"}>
                                        <input
                                          type="radio"
                                          value="2"
                                          name="Selectordershow"
                                          onChange={this.onshowtositetemp.bind(this)}
                                          checked={this.state.viewoptiontemplate === 2 ? true : false}
                                        />
                                        <span>
                                          {this.props.t("Dashboard.IDS_LBL_ONLYME")}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div> */}

                                <div className="col-sm-4">
                                  <div className="row clearfix">
                                    <div className="login-form">
                                      <label className={"radio"}>
                                        <input
                                          type="radio"
                                          value="3"
                                          name="Selectordershow"
                                          onChange={this.onshowtositetemp.bind(this)}
                                          checked={this.state.viewoptiontemplate === 3 ? true : false}
                                        />
                                        <span>
                                          {this.props.t("Dashboard.IDS_LBL_PROJECTTEAM")}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        }
                      </ModalBody>
                      <div className="modal-footer">
                        <button id="id-dashboard-save"
                          className="btn btn-primary-blue btnpacksel float-right"
                          onClick={
                            this.state.Templatefor === 1
                              ? this.saveSheet.bind(this)
                              : this.onAddprotocolNameClick.bind(this)
                          }
                        >
                          {this.props.t("Dashboard.IDS_LBL_SAVE")}
                        </button>

                        <button id="id-dashboard-closesheet"
                          type="button"
                          className="textBtn btn_white_bg"
                          onClick={this.onsheetorderclose}
                        >
                          {this.props.t("Dashboard.IDS_LBL_CLOSE")}
                        </button>
                      </div>
                    </Modal>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    {this.formatsheets()}
                  </div>
                </div>
              ) : (
                false
              )}
            </div>
            <div className="col-lg-6 col-xl-6">
              {this.state.actwidgetrights ? (<div className="kendo-box-wrap">
                <div className="kendo-title-form">
                  <h6>
                    {this.props.t("ActiveWidgets.IDS_AWL_ACTIVITIES")}
                    <button
                      onClick={() => { this.Onresetwidgetsdata(true); }}
                      id="idNew"
                      className="grid-icons ml-2"
                      title="Refresh"
                    >
                      <i className="fas fa-sync-alt p-1"></i>{" "}
                      {/* {this.props.t("Templates.Sheettemplates.IDS_LBL_REFRESH", {
                        param: "",
                      })} */}
                    </button>
                  </h6>

                  {/* <button id="idNew" class="btn btn-primary-blue" style={{ position: "absolute", left: "117px" }} onClick={() => { this.Onresetwidgetsdata(true) }}><i class="fas fa-sync-alt mr-1"></i></button> */}
                </div>


                <div className="col-lg-12 col-md-12">
                  <Activatewidgets props={this.props} Activatewidgets_Calldata={this.state.Activewidgets_Pulldata} Onresetwidgetsdata={this.Onresetwidgetsdata.bind(this)} />
                </div>
              </div>) : (false)}

            </div>
            {isMultitenant === 2 && sessionStorage.accouttype === "1" &&
              <>
                {this.state.Ordervalue ? (
                  <div className="col-lg-3 col-xl-3">
                    <div className="kendo-box-wrap">
                      <div className="kendo-title-form">
                        <h6>
                          {this.props.t(isMultitenant === 2 ? "Dashboard.IDS_LBL_TASKS" : "Dashboard.IDS_LBL_ORDER")}
                        </h6>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <Suspense fallback={<div></div>}>
                          {((this.state.Completedorders || this.state.PendingOrders || this.state.rejectedOrder || this.state.canceledOrder)) ?
                            <KendoChartDashboard
                              doRender={this.state.isChartRender}
                              chartType={this.state.selectedChartOrderType}
                              chartName={`${this.props.t("Dashboard.IDS_LBL_ORDERS")}: ${Number(this.state.Completedorders) + Number(this.state.PendingOrders) + Number(this.state.rejectedOrder) + Number(this.state.canceledOrder)}`}

                              chartData={[
                                {
                                  name: this.props.t("Dashboard.IDS_LBL_COMPLETED"),
                                  data: Number(this.state.Completedorders),
                                  barData: [Number(this.state.Completedorders)],
                                  // explode : true,
                                  color: "#45BF04"
                                },
                                {
                                  name: this.props.t("Dashboard.IDS_LBL_PENDING"),
                                  data: Number(this.state.PendingOrders),
                                  barData: [Number(this.state.PendingOrders)],
                                  // explode : true,
                                  color: "#FF6430"
                                },
                                {
                                  name: this.props.t("Dashboard.IDS_LBL_REJECTED"),
                                  data: Number(this.state.rejectedOrder),
                                  barData: [Number(this.state.rejectedOrder)],
                                  // explode : true,
                                  color: "#A2190E"
                                },
                                {
                                  name: this.props.t("Dashboard.IDS_LBL_CANCELLED"),
                                  data: Number(this.state.canceledOrder),
                                  barData: [Number(this.state.canceledOrder)],
                                  // explode : true,
                                  color: "#1970eb"
                                },
                              ]
                              }
                            >
                            </KendoChartDashboard>
                            :
                            <div className="no-data">
                              <center>
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                <div>
                                  {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
                                </div>
                              </center>
                            </div>
                          }
                        </Suspense>
                      </div>
                    </div>
                  </div>
                ) : false}
                {this.state.tempvalue ? (
                  <div className="col-lg-3 col-xl-3">
                    <div className="kendo-box-wrap">
                      <div className="kendo-title-form">
                        <h6>
                          {this.props.t("Dashboard.IDS_LBL_TEMPLATE")}
                        </h6>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <Suspense fallback={<div></div>}>
                          {((this.state.approvedTemplate || this.state.createdTemplate || this.state.rejectedTemplate || this.state.inProgressTemplate || this.state.retiredTemplate)) ?
                            <KendoChartDashboard
                              doRender={this.state.isChartRender}
                              chartType={this.state.selectedChartTemplateType}
                              chartName={`${this.props.t("Dashboard.IDS_LBL_TEMPLATES")}: ${Number(this.state.retiredTemplate) + Number(this.state.inProgressTemplate) + Number(this.state.approvedTemplate) + Number(this.state.createdTemplate) + Number(this.state.rejectedTemplate)}`}
                              chartData={[
                                {
                                  name: this.props.t("Dashboard.IDS_LBL_APPROVED"),
                                  data: Number(this.state.approvedTemplate),
                                  barData: [Number(this.state.approvedTemplate)],
                                  // explode : true,
                                  color: "#45BF04"
                                },
                                {
                                  name: this.props.t("Dashboard.IDS_LBL_CREATED"),
                                  data: Number(this.state.createdTemplate),
                                  barData: [Number(this.state.createdTemplate)],
                                  // explode : true,
                                  color: "#1970eb"
                                },
                                {
                                  name: this.props.t("Dashboard.IDS_LBL_REJECTED"),
                                  data: Number(this.state.rejectedTemplate),
                                  barData: [Number(this.state.rejectedTemplate)],
                                  // explode : true,
                                  color: "#A2190E"
                                },
                                {
                                  name: this.props.t("Dashboard.IDS_LBL_INPROGRESS"),
                                  data: Number(this.state.inProgressTemplate),
                                  barData: [Number(this.state.inProgressTemplate)],
                                  // explode : true,
                                  color: "#F38A07"
                                },
                                {
                                  name: this.props.t("Templates.Protocol.IDS_LBL_RETIRED"),
                                  data: Number(this.state.retiredTemplate),
                                  barData: [Number(this.state.retiredTemplate)],
                                  // explode : true,
                                  color: "#F38A09"
                                }
                              ]
                              }
                            >
                            </KendoChartDashboard>
                            :
                            <div className="no-data">
                              <center>
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                <div>
                                  {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
                                </div>
                              </center>
                            </div>
                          }
                        </Suspense>
                      </div>

                    </div>

                  </div>
                ) : false}
              </>
            }
            {/* {this.state.tempvalue ? (
              <div className="col-lg-3 col-xl-3">
                <div className="kendo-box-wrap">
                  <div className="kendo-title-form">
                    <h6>
                      {this.props.t("Dashboard.IDS_LBL_TEMPLATE")}
                    </h6>

                  </div>

                  <div className="col-lg-12 col-md-12">
                    <Suspense fallback={<div></div>}>
                      {((this.state.approvedTemplate || this.state.createdTemplate || this.state.rejectedTemplate || this.state.inProgressTemplate || this.state.retiredTemplate)) ?
                        <KendoChartDashboard
                          doRender={this.state.isChartRender}
                          chartType={this.state.selectedChartTemplateType}
                          chartName={`${this.props.t("Dashboard.IDS_LBL_TEMPLATES")}: ${Number(this.state.retiredTemplate) + Number(this.state.inProgressTemplate) + Number(this.state.approvedTemplate) + Number(this.state.createdTemplate) + Number(this.state.rejectedTemplate)}`}
                          chartData={[
                            {
                              name: this.props.t("Dashboard.IDS_LBL_APPROVED"),
                              data: Number(this.state.approvedTemplate),
                              barData: [Number(this.state.approvedTemplate)],
                              // explode : true,
                              color: "#45BF04"
                            },
                            {
                              name: this.props.t("Dashboard.IDS_LBL_CREATED"),
                              data: Number(this.state.createdTemplate),
                              barData: [Number(this.state.createdTemplate)],
                              // explode : true,
                              color: "#1970eb"
                            },
                            {
                              name: this.props.t("Dashboard.IDS_LBL_REJECTED"),
                              data: Number(this.state.rejectedTemplate),
                              barData: [Number(this.state.rejectedTemplate)],
                              // explode : true,
                              color: "#A2190E"
                            },
                            {
                              name: this.props.t("Dashboard.IDS_LBL_INPROGRESS"),
                              data: Number(this.state.inProgressTemplate),
                              barData: [Number(this.state.inProgressTemplate)],
                              // explode : true,
                              color: "#F38A07"
                            },
                            {
                              name: this.props.t("Templates.Protocol.IDS_LBL_RETIRED"),
                              data: Number(this.state.retiredTemplate),
                              barData: [Number(this.state.retiredTemplate)],
                              // explode : true,
                              color: "#F38A09"
                            }
                          ]
                          }
                        >
                        </KendoChartDashboard>
                        :
                        <div className="no-data">
                          <center>
                            <FontAwesomeIcon icon={faExclamationTriangle} />
                            <div>
                              {this.props.t("Dashboard.IDS_LBL_NORECORDSFOUND")}
                            </div>
                          </center>
                        </div>
                      }
                    </Suspense>
                  </div>

                </div>

              </div>
            )
              : false} */}
          </div>
        </div>}

        {this.state.selecteddashview && this.state.selecteddashview.viewcode === 2 && <DashboardProjectView />}


        {this.state.isupgradeopen && <Suspense fallback={<div></div>}><Upgrade isopen={this.state.isupgradeopen}
          onpopupclose={() => { this.setState({ isupgradeopen: false }); }}
          popcontent={"Only 10 templates can be created for free account. Upgrade to create more template."} /></Suspense>}

      </>
    );
  }
}
export default withAlert()(withTranslation(Dashboard));
